import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/service/shared/shared.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { Config } from 'src/app/app-constant';
import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HttpService } from 'src/app/service/http/http.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { saveAs } from 'file-saver';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import * as Highcharts from 'highcharts';
import { MarketCorrectionEmployeePopupComponent } from 'src/app/shared/popups/market-correction-employee-popup/market-correction-employee-popup.component';
import { EmployeeGivenPromotionPopupComponent } from 'src/app/shared/popups/employee-given-promotion-popup/employee-given-promotion-popup.component';
import { EligibleEmployeesPopupComponent } from 'src/app/shared/popups/eligible-employees-popup/eligible-employees-popup.component';
import * as echarts from 'echarts';
import * as XLSX from 'xlsx';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DownloadAsPdfService } from 'src/app/service/downloadAspdf/download-as-pdf.service';
import { AllPopupModalExecutionServiceService } from 'src/app/shared/services/all-popup-modal-execution-service.service';
import { ColDef, ExcelExportParams, GridReadyEvent, ISetFilterParams, themeQuartz, ValueFormatterParams, RowClassParams, RowStyle } from 'ag-grid-community';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';
import { GridApi } from 'ag-grid-community';
import { ChangeDetectorRef } from '@angular/core';

type ColDefExt = ColDef & { suppressMenu?: boolean };

class NoLoaderService {
  simpleLoader() {}
  loaderActive() {}
  simpleLoaderWithDuration() {}
  dismissLoader() {}
}
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY'
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'app-increment',
  templateUrl: './increment.component.html',
  styleUrls: ['./increment.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: LoaderService, useClass: NoLoaderService }
  ]
})
export class IncrementComponent implements OnInit {
  selectedTypeTabIndex = 0;
  selectedTypeTabName = 'Dashboard';
  eligibleDepartments: { id: string; name: string }[] = [];
  buttonColorName: any;
  subModuleButtonColor: any;
  showSetupPopup: boolean = false;
  showSetupLogs: boolean = false;
  currentDate: any = new Date();
  loggedInCompanyFiscalyear: any;
  loggedInUserName: any;
  loggedInUserId: any;
  loggedInUserCompanyID: any;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInUserRoleIsEmployee: boolean = false;
  loggedInUserEmpCode: any;
  loggedInCompanyReviewCycle: any = null;
  errorMsgForRating: boolean = false;
  approvalByHodDate: any;
  ratingArrayForSetup: any = [];
  addedratingArray: any = [];
  activeIncrementInputTab: boolean = true;
  totalPagesOfIncremnt: any = 0;
  totalIncremnt: any = 0;
  currentPageNumberOfIncremnt: any = 1;
  page: any = 0;
  showingCount: any = 0;
  showingOfCount: any = 0;
  selectedManagerYear: any;
  selectedEmployeeYear: any;
  companyYears: any = [];
  selectedYear: any;
  selectedIncrementInputYear: any;
  fromYear: any;
  toYear: any;
  formIncrementPeriodArray: any = [];
  toIncrementPeriodArray: any = [];
  fromIncremnetPeriod: any = null;
  toIncremnetPeriod: any = null;
  cutOffDateForIncrementEligibility: any = null;
  onSelectIncrementTotalCTC: any;
  getIndividualBandList: any = [];
  ScoreToFinalScoreConverterPlusCompanyScore: any = [];
  IncrementGridBandList: any = [];
  IndividualKPIPlusCompetencyWt = null;
  DeptKPIScore = null;
  KPIScoreWeightage = null;
  incrementId: any;
  editedIndividualScoreId: number | null = null;
  editedIndividualDeotCompanyScoreId: number | null = null;
  editedBandAndRatingWiseId: number | null = null;
  isFormDisabled: boolean = false;
  onCheckIconView: boolean = true;
  GetOverallIncrementBudgetGridData: any = [];
  getDepartmentByYearList: any = [];
  isInValidMaxIndividualKpi = false;
  isInValidMinIndividualKpi = false;
  isInValidMaxIndividualCompetency = false;
  isInValidMinIndividualCompetency = false;
  IsIndividualTotalWeightage = false;
  InvalidIndividualCompetencyMaxTW = false;
  InvalidIndividualCompetencyMinTW = false;
  InvalidDepthKpiMaxScore = false;
  InvalidDepthKpiMinScore = false;
  InvalidcompanyKpiScoreMaxScore = false;
  InvalidcompanyKpiScoreMinScore = false;
  InvalidcompanyscoreWT = false;
  IncrementFyYear: any;
  selectFYyear: any;
  disableBtnsOnsendApprovelForMD: any = false;
  isShowOverallBudgetGridBtn: any;
  selectedIncrementInputDept: any;
  selectedIncrementInputBand: any;
  selectedIncrementInputManager: any;
  selectedIncrementInputEmp: any;
  managerId: any;
  employeeId: any;
  getDepartmentsList: any[] = [];
  getBandList: any[] = [];
  getManagerList: any[] = [];
  getEmployeeList: any[] = [];
  getIncrementInputEligibleTableData: any = [];
  getIncrementInputNonEligibleTableData: any = [];
  selectedSizeOfIncrementInput: any = 25;
  dropdownSettings: IDropdownSettings = {};
  isAnyColumnInvisible: boolean = false;
  allColumnsInvisible: boolean = false;
  IncrementInputTableHideShowAllData: any[] = [];
  editIndexofRating: any;
  totalIncrementInputEligibleCount: any;
  totalIncrementInputNonEligibleCount: any;
  totalEligibleCount: any;
  totalNonEligibleCount: any;

  totalEligibleTotalFixedCtcPM = 0;
  totalEligibleTotalFixedCtcPA = 0;
  totalEligibleEligibleEmp = 0;
  totalEligibleFinalRating = 0;
  totalEligibleIncrementPct = 0;
  totalEligibleDaysServedinIncrementPeriod = 0;
  totalEligibleProratedIncrementPct = 0;
  totalEligibleHODIncrementPct = 0;
  totalEligibleHrAndMdIncrementPct = 0;
  totalEligibleIncrementAmount = 0;
  totalEligibleNoOfPromotionPct = 0;
  totalEligiblePromotionPct = 0;
  totalEligiblePromotionAmount = 0;
  totalEligibleupdatedCtcAfterIAndP = 0;
  totalEligibleMarketBenchMarkCtc = 0;
  totalEligiblemarketCorrectionPct = 0;
  totalEligibleMarketCorrectionAmount = 0;
  totalEligibleFinalIncrementPct = 0;
  totalEligibleFinalIncrementAmount = 0;
  totalEligibleFinalAnnualCtc = 0;
  totalEligibleFinalMonthlyCtc = 0;

  totalNonEligibleTotalFixedCtcPM = 0;
  totalNonEligibleTotalFixedCtcPA = 0;
  totalNonEligibleEligibleEmp = 0;
  totalNonEligibleFinalRating = 0;
  totalNonEligibleIncrementPct = 0;
  totalNonEligibleDaysServedinIncrementPeriod = 0;
  totalNonEligibleProratedIncrementPct = 0;
  totalNonEligibleHODIncrementPct = 0;
  totalNonEligibleHrAndMdIncrementPct = 0;
  totalNonEligibleIncrementAmount = 0;
  totalNonEligiblePromotionPct = 0;
  totalNonEligiblePromotionAmount = 0;
  totalNonEligibleNoOfPromotionPct = 0;
  totalNonEligibleupdatedCtcAfterIAndP = 0;
  totalNonEligibleMarketBenchMarkCtc = 0;
  totalNonEligiblemarketCorrectionPct = 0;
  totalNonEligibleMarketCorrectionAmount = 0;
  totalNonEligibleFinalIncrementPct = 0;
  totalNonEligibleFinalIncrementAmount = 0;
  totalNonEligibleFinalAnnualCtc = 0;
  totalNonEligibleFinalMonthlyCtc = 0;

  IncrementSummaryTableHideShowAllData: any = [];
  incrementsummaryCtc: any;
  incrementSummaryFYyear: any;
  incrementSummaryFormYear: any;
  incrementSummaryToYear: any;
  getIncrementSummaryTableData: any = [];
  selectIncrementReportsYear: any;
  overallIncrementBudgetGridCurrentYear: any;
  isEditingRow: number | null = null;
  isFinalIncrementPctFormDisabled: any = true;
  isShowMD: any;
  avgPercentageOfMarketCorrection: any;
  avgPercentageOfOverallIncrement: any;
  avgPercentageOfPromotionIncrement: any;
  budgetAmount: any;
  budgetPercentage: any;
  eligibleEmps: any;
  empGivenPromotion: any;
  marketCorrectionEmp: any;
  noOfEmployees: any;

  generWiseBudgetVsActualIcon: any = 'bar';
  GenerWiseBudgetVsActualTable: any = false;
  budgetVsActualIncrementIcon: any = 'bar';
  budgetVsActualIncrementIconTable: any = false;
  ratingWiseIncrementAmountIcon: any = 'bar';
  ratingWiseIncrementAmountTable: any = false;
  bandWiseBudgetVsActualsIcon: any = 'bar';
  bandWiseBudgetVsActualsTable: any = false;
  ratingVsEmpCountIcon: any = 'bar';
  ratingVsEmpCountTable: any = false;
  yearVsBudgetAndActualAmountIcon: any = 'bar';
  yearVsBudgetAndActualAmountTable: any = false;
  deptWiseEligibleAndNonEligibleEmpCountIcon: any = 'bar';
  deptWiseEligibleAndNonEligibleEmpCountTable: any = false;

  //  input select
  selectGenderWiseBudgetVsActualDept: any;
  selectedBudgetVsActualIncrementDept: any;
  selectRatingWiseIncrementAmount: any;
  selectBandWiseBudgetVsActuals: any;
  selectratingVsEmpCount: any;
  selectYearVsBudgetAndActualAmount: any;
  selectDeptWiseEligibleAndNonEligibleEmp: any;

  // array
  getGenderWiseBudgetVsActualData: any[] = [];
  getBudgetVsActualIncrementData: any[] = [];
  getBudgetVsActualIncrementGraphList: any[] = [];
  ratingWiseIncrementAmountData: any[] = [];
  bandWiseBudgetVsActualsData: any[] = [];
  ratingVsEmpCountData: any[] = [];
  yearVsBudgetAndActualAmountData: any[] = [];
  deptWiseEligibleAndNonEligibleEmpCountData: any[] = [];
  columnDefs: any[] = [];
  gridRowData: any[] = [];
  pinnedBottomRowData: any[] = [];
  incrementSummaryColumnDefs: ColDef[] = [];
  incrementSummaryRowData: any[] = [];
  incrementSummaryPinnedBottomRowData: any[] = [];
  gridApiIncrementSummary: GridApi | null = null;
  gridColumnApiIncrementSummary: any = null;

  // gridApiNonEligible: any;
  // gridColumnApiNonEligible: any;
  // ag-grid API handles
  public gridApi: any = null;
  public gridColumnApi: any = null;
  public gridApiNonEligible: any = null;
  public gridColumnApiNonEligible: any = null;

  // bound data for template
  public gridRowDataEligible: any[] = [];
  public gridRowDataNonEligible: any[] = [];
  public pinnedBottomRowDataEligible: any[] = [];
  public pinnedBottomRowDataNonEligible: any[] = [];
  incrementColumnDefs: ColDefExt[] = [];
  incrementEligibleRowData: any[] = [];
  incrementNonEligibleColumnDefs: any[] = [];
  incrementNonEligibleRowData: any[] = [];
  incrementInputEligibleColumnDefs: any[] = [];
  incrementInputEligibleRowData: any[] = [];
  gridApiIncrementInputEligible: any;
  gridColumnApiIncrementInputEligible: any;
  incrementInputEligiblePinnedBottomRowData: any[] = [];
  gridApiEligible: any = null;
  gridColumnApiEligible: any = null;
  gridApiIncrementInputNonEligible: any;
  gridColumnApiIncrementInputNonEligible: any;

  // graph Type
  genderWiseBudgetVsActualDeptGraphType: any = {
    bar: {},
    pie: {},
    line: {}
  };

  BudgetVsActualIncrementGraphType: any = {
    bar: {},
    pie: {},
    line: {}
  };

  ratingWiseIncrementAmountGraphType: any = {
    bar: {},
    pie: {},
    line: {}
  };

  bandWiseBudgetVsActualsGraphType: any = {
    bar: {},
    pie: {},
    line: {}
  };

  ratingVsEmpCountGraphType: any = {
    bar: {},
    pie: {},
    line: {}
  };

  yearVsBudgetAndActualAmountGraphType: any = {
    bar: {},
    pie: {},
    line: {}
  };

  deptWiseEligibleAndNonEligibleEmpCountGraphType: any = {
    bar: {},
    pie: {},
    line: {}
  };

  disableIncrementInputFormToHOD: any;
  disableIncrementInputFormToHrAdmin: any;
  disableIncrementSetupAfterMDApproved: any;

  disableIncrementSetupAfterChangeYear: any;

  completeStatusErrorMsg: any;

  ShowIncrementInputStatus: any = 'Pending';
  afterMDAndCEOApproval: any;
  approvalStatus: any;
  approvalDateAndTime: any;
  afterHODForApprovalDate: any;

  isEditHODApprovedIncrementPct: any;
  isEditHRAdminAndMDCEOApprovedIncrementPct: any;
  loggedInUserIsMD: boolean = false;

  minDate: any;
  maxDate: any;

  incrementCtcPerMonth: any = '';
  incrementCtcPerYear: any = '';
  isShowExcelData: any = false;
  isHideFreezeForTheHodBtn: any = true;
  isApprovedByHr: any;
  ShowApproveForIsPromotedContent: any = true;
  isDisableApproveBtnAfterMDApproved: any = false;
  showIncrementLetterForEmp: any = false;
  getIncrementFyYearList: any[] = [];
  incrementFromYear: any;
  incrementToYear: any;
  isDisabledFinalIncLettersBtn: any = false;
  isInValidMaxOverallBudgetGrid: any;
  checkIncrementDepartment: any = true;
  isDisabledFreezeForHodBtn: any;
  reportGridApi: any;
  reportColumnApi: any;
  gridApiIncrementReportsNonEligible: any;
  gridColumnApiIncrementReportsNonEligible: any;

  // gridRowDataEligible: any[] = [];
  // gridRowDataNonEligible: any[] = [];
  // pinnedBottomRowDataEligible: any[] = [];
  // pinnedBottomRowDataNonEligible: any[] = [];
  enableIncrementForCompanyIds: string[] = ['262', '280'];
  checkIfIsEnabledIncrement: boolean = false;

  constructor(
    public sharedService: SharedService,
    private loader: LoaderService,
    private encryptionService: EncryptionService,
    private httpService: HttpService,
    private config: Config,
    public router: Router,
    private toastr: ToastrService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private activatedroute: ActivatedRoute,
    private http: HttpClient,
    private pdfDownload: DownloadAsPdfService,
    private cd: ChangeDetectorRef,
    private popupExecution: AllPopupModalExecutionServiceService
  ) {}

  ngOnInit() {
    this.buildIncrementSummaryColumnDefs();
    this.getIncrementSummaryData();
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    console.log(' ----------------- ', this.loggedInUserCompanyID);
    this.checkIfIsEnabledIncrement = this.enableIncrementForCompanyIds.includes(String(this.loggedInUserCompanyID));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    this.isShowMD = this.loggedInUserRoles.some((role: any) => role.name === 'MD');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');

    // if(sessionStorage.getItem('loggedInUserIsMD') == 'true'){
    //   this.loggedInUserIsMD=true;
    // }else{this.loggedInUserIsMD=false;}
    if (this.isShowMD || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD' || this.loggedInUserRole == 'HOD') {
      this.loggedInUserIsMD = true;
    } else if (this.loggedInCompanyFiscalyear == 'Manager') {
      this.loggedInUserIsMD = false;
    } else {
      this.loggedInUserIsMD = false;
    }

    // if(this.loggedInCompanyFiscalyear === 'Jan_Dec'){
    //   this.minDate = new Date(new Date().getFullYear(), 0, 1);
    //   this.maxDate = new Date(new Date().getFullYear(), 11, 31);
    // }else if(this.loggedInCompanyFiscalyear === 'Apr_Mar'){
    //   this.minDate = new Date(new Date().getFullYear() - 1, 0, 1);
    //   this.maxDate = new Date(new Date().getFullYear(), 2, 31);
    // }

    const currentYear = new Date().getFullYear();
    const getCurrentMonth = new Date().getMonth();

    if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
      this.minDate = new Date(currentYear, 0, 1);
      this.maxDate = new Date(currentYear, 11, 31);
    } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
      this.minDate = getCurrentMonth < 3 ? new Date(currentYear - 1, 3, 1) : new Date(currentYear, 3, 1);
      this.maxDate = getCurrentMonth < 3 ? new Date(currentYear, 2, 31) : new Date(currentYear + 1, 2, 31);
    } else if (this.loggedInCompanyFiscalyear === 'July_Jun') {
      this.minDate = getCurrentMonth < 6 ? new Date(currentYear - 1, 6, 1) : new Date(currentYear, 6, 1);
      this.maxDate = getCurrentMonth < 6 ? new Date(currentYear, 5, 30) : new Date(currentYear + 1, 5, 30);
    } else if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
      this.minDate = getCurrentMonth < 9 ? new Date(currentYear - 1, 9, 1) : new Date(currentYear, 9, 1);
      this.maxDate = getCurrentMonth < 9 ? new Date(currentYear, 8, 30) : new Date(currentYear + 1, 8, 30);
    }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.loader.simpleLoader();
  }

  ionViewWillEnter() {
    this.activatedroute.params.subscribe((params: any) => {
      if (params?.operation == 'Setup') {
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.isShowMD) {
          this.showSetupPopup = true;
          this.selectedTypeTabName = '';
        }
      } else {
        this.showSetupPopup = false;
        this.selectedTypeTabIndex = params?.tabIndex;
      }
    });
    this.getpmsyearlist();
    this.getIncrementFyYear();
  }

  tabTypeChanged(event: MatTabChangeEvent): void {
    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event.index;
    this.checkStatusForIncrementSetup();

    if (this.selectedTypeTabIndex === 0) {
      setTimeout(() => {
        if (this.gridApiIncrementInputEligible) {
          this.gridApiIncrementInputEligible.setRowData(this.incrementInputEligibleRowData);
          this.buildEligibleFooterRow();
          this.gridApiIncrementInputEligible.refreshCells({ force: true });
          this.gridApiIncrementInputEligible.redrawRows();
          this.gridApiIncrementInputEligible.sizeColumnsToFit();
        }
      }, 80);
    }
  }

  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/increment', { operation: operation }]);
  }
  onClickBreadcrumPMS() {
    this.router.navigate(['/home/hrportal/increment']);
  }

  onClickUploadfile(uploadfile: any) {
    if (this.afterMDAndCEOApproval != true) {
      this.router.navigate(['/home/hrportal/increment/uploadfile', { uploadfile: uploadfile }]);
    }
  }

  onClickEmailContentBtn(emailContent: any) {
    this.router.navigate(['/home/hrportal/increment/emailContent', { emailContent: emailContent }]);
  }

  onClickIncrementLetterBtn(moduleName: any) {
    this.router.navigate(['/home/hrportal/incrementLetter', { moduleName: moduleName }]);
  }

  onClickLogs(moduleName: any) {
    // this.router.navigate(['/home/hrportal/auidtlogs', { moduleName: moduleName}]);
    this.router.navigate(['/home/hrportal/incrementLogs', { operation: moduleName }]);
  }

  onMenuClose() {
    // Optional: Handle any cleanup when the menu is closed
  }

  previousPageIncrement() {
    if (this.currentPageNumberOfIncremnt < 2) {
      return;
    } else {
      this.currentPageNumberOfIncremnt--;
      this.page--;
    }
  }

  nextPageIncrement() {
    if (this.currentPageNumberOfIncremnt >= this.totalPagesOfIncremnt) {
      return;
    }
    if (this.currentPageNumberOfIncremnt == 1) {
      this.page = 1;
    } else {
      this.page++;
    }
    this.currentPageNumberOfIncremnt++;
  }

  currentYearCheckFlag: any;
  yearadd: any;
  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.companyYears = [];
      // data?.data?.yearRanges?.forEach((ele: any) => {
      //   var test = ele.split('_');
      //   let obj = {
      //     year: test[0] + '-' + test[1]
      //   };
      //   this.companyYears.push(obj);
      // });
      const currentYear = new Date().getFullYear();
      data?.data?.yearRanges?.forEach((ele: any) => {
        const [startYear, endYear] = ele.split('_').map(Number);
        if (startYear <= currentYear) {
          this.companyYears.push({ year: `${startYear}-${endYear}` });
        }
      });

      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      let yearValue = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
        if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
          if (currentMonth < 3) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'July_Jun') {
          if (currentMonth < 6) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
          if (currentMonth < 9) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
      }
      this.yearadd = yearValue;
      let selectedYearIndex = this.companyYears.findIndex((ele: any) => ele?.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }
      this.currentYearCheckFlag = this.companyYears[selectedYearIndex]?.year;
      this.selectedYear = this.companyYears[selectedYearIndex]?.year;
      var test = this.selectedYear?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        this.formIncrementPeriodArray = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.selectedYear);
      } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
        this.formIncrementPeriodArray = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.selectedYear);
      } else if (this.loggedInCompanyFiscalyear === 'July_Jun') {
        this.formIncrementPeriodArray = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.selectedYear);
      } else if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
        this.formIncrementPeriodArray = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.selectedYear);
      }
      this.getAllUser();
      this.getIncrementSetupByYear();
      this.activatedroute.params.subscribe((params: any) => {
        if (params?.operation == 'Setup') {
          this.getSetupAfterMDApproved();
          this.getBandDataFunction();
        }
      });
      this.showCurrentYear();
    });
  }

  // increment Setup
  onYearChange(event: any) {
    var selectedyear = event.value?.split('-');
    this.fromYear = selectedyear[0];
    this.toYear = selectedyear[1];
    if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
      this.formIncrementPeriodArray = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.selectedYear);
    } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
      this.formIncrementPeriodArray = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.selectedYear);
    } else if (this.loggedInCompanyFiscalyear === 'July_Jun') {
      this.formIncrementPeriodArray = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.selectedYear);
    } else if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
      this.formIncrementPeriodArray = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.selectedYear);
    }

    const currentYear: number = new Date().getFullYear();
    if (parseInt(this.fromYear) !== currentYear) {
      this.disableIncrementSetupAfterChangeYear = true;
    } else {
      this.disableIncrementSetupAfterChangeYear = false;
    }

    this.getBandDataFunction();
    this.getIncrementSetupByYear();
    this.isInvalidFromIncrementPeriod = false;
    this.isInvalidToIncrementPeriod = false;
    this.isINvalidCutOffDateForIncrementEligibility = false;
    this.isInvalidIncrementTotalCTC = false;
  }

  getFormMonthsArray(fiscalYear: string, selectedYear: string): string[] {
    const monthYearArray = [];
    const [startYear, endYear] = selectedYear.split('-').map(y => parseInt(y));

    if (fiscalYear === 'Jan_Dec') {
      for (let month = 0; month < 12; month++) {
        monthYearArray.push(`${this.getMonthName(month)} ${(startYear + 1) % 100}`);
      }
    } else if (fiscalYear === 'Apr_Mar') {
      for (let month = 3; month < 15; month++) {
        const year = month < 12 ? endYear : endYear + 1;
        monthYearArray.push(`${this.getMonthName(month % 12)} ${year % 100}`);
      }
    } else if (fiscalYear === 'July_Jun') {
      for (let month = 6; month < 18; month++) {
        const year = month < 12 ? endYear : endYear + 1;
        monthYearArray.push(`${this.getMonthName(month % 12)} ${year % 100}`);
      }
    } else if (fiscalYear === 'Oct_Sep') {
      for (let month = 9; month < 21; month++) {
        const year = month < 12 ? endYear : endYear + 1;
        monthYearArray.push(`${this.getMonthName(month % 12)} ${year % 100}`);
      }
    }

    return monthYearArray;
  }

  private getMonthName(monthIndex: number): string {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return monthNames[monthIndex];
  }

  getIncrementSetupByYear() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      toYear: this.toYear
    };
    this.httpService.callPostService(this.config.getIncrementSetupByYear, request).subscribe((result: any) => {
      this.fromIncremnetPeriod = result.data.fromMonth;
      this.toIncremnetPeriod = result.data.toMonth;
      this.cutOffDateForIncrementEligibility = result.data.cutOffDateForIncrement;
      this.onSelectIncrementTotalCTC = result.data.incrementOn;
      if (result) {
        this.getOverallIncrementBudgetGrid();
      }
      if (this.onSelectIncrementTotalCTC == 'Fixed Annual CTC') {
        this.IncrementBudgetGridCTC = ' Fixed CTC of Eligible Employees';
      } else {
        this.IncrementBudgetGridCTC = 'Total CTC of Eligible Employees';
      }
    });
  }

  isInvalidFromIncrementPeriod: any;
  isInvalidToIncrementPeriod: any;
  isINvalidCutOffDateForIncrementEligibility: any;
  isInvalidIncrementTotalCTC: any;
  IncrementBudgetGridCTC: any;

  selectIncrementEligibility(data: any) {
    if (data == null) {
      this.isINvalidCutOffDateForIncrementEligibility = true;
    } else {
      this.isINvalidCutOffDateForIncrementEligibility = false;
    }
    if (this.fromIncremnetPeriod == null) {
      this.isInvalidFromIncrementPeriod = true;
    } else {
      this.isInvalidFromIncrementPeriod = false;
    }
    if (this.toIncremnetPeriod == null) {
      this.isInvalidToIncrementPeriod = true;
    } else {
      this.isInvalidToIncrementPeriod = false;
    }
  }

  selectFromIncrementPeriood(data: any) {
    if (data == null) {
      this.isInvalidFromIncrementPeriod = true;
    } else {
      this.isInvalidFromIncrementPeriod = false;
    }
  }

  selectToIncrementPeriood(data: any) {
    if (data == null) {
      this.isInvalidToIncrementPeriod = true;
    } else {
      this.isInvalidToIncrementPeriod = false;
    }
  }

  selectIncrementToBeGivenOn(data: any) {
    if (data.value == null) {
      this.isInvalidIncrementTotalCTC = true;
    } else {
      this.isInvalidIncrementTotalCTC = false;
    }
  }

  setUpIncrementCutOff() {
    if (this.fromIncremnetPeriod == null || this.toIncremnetPeriod == null || this.cutOffDateForIncrementEligibility == null || this.onSelectIncrementTotalCTC == null) {
      if (this.fromIncremnetPeriod == null) {
        this.isInvalidFromIncrementPeriod = true;
      } else {
        this.isInvalidFromIncrementPeriod = false;
      }
      if (this.toIncremnetPeriod == null) {
        this.isInvalidToIncrementPeriod = true;
      } else {
        this.isInvalidToIncrementPeriod = false;
      }
      if (this.cutOffDateForIncrementEligibility == null) {
        this.isINvalidCutOffDateForIncrementEligibility = true;
      } else {
        this.isINvalidCutOffDateForIncrementEligibility = false;
      }
      if (this.onSelectIncrementTotalCTC == null) {
        this.isInvalidIncrementTotalCTC = true;
      } else {
        this.isInvalidIncrementTotalCTC = false;
      }
    } else {
      if (this.disableIncrementSetupAfterMDApproved == true) {
        window.alert('Increment Setup Already Approved by MD/CEO');
      } else {
        this.isInvalidFromIncrementPeriod = false;
        this.isInvalidToIncrementPeriod = false;
        this.isINvalidCutOffDateForIncrementEligibility = false;
        this.isInvalidIncrementTotalCTC = false;
        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: 'Save increment setup',
            btn1: 'Cancel',
            btn2: 'Yes',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          const request = {
            companyId: this.loggedInUserCompanyID,
            cutOffDate: this.datePipe.transform(this.cutOffDateForIncrementEligibility, 'yyyy-MM-dd'),
            finalIncrementPercentage: null,
            fromMonth: this.fromIncremnetPeriod,
            id: null,
            incrementOn: this.onSelectIncrementTotalCTC,
            toMonth: this.toIncremnetPeriod,
            year: this.selectedYear
          };
          this.httpService.callPostService(this.config.incrementCutOffSetup, request).subscribe((result: any) => {
            if (result) {
              this.getIncrementSetupByYear();
            }
          });
        });
      }
    }
  }

  getSetupAfterMDApproved() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      toYear: this.toYear
    };
    this.httpService.callPostService(this.config.getIncrementApprovalDataOfCompany, request).subscribe((result: any) => {
      this.approvalStatus = result.data?.mdReviewStatus;
      this.approvalDateAndTime = result.data?.approvalByHrDate;
      const formattedDate = this.datePipe.transform(this.approvalDateAndTime, 'dd-MM-yyyy');
      this.isApprovedByHr = result.data?.isApprovedByHr;
      if (result.data?.mdReviewStatus == 'Approved') {
        this.disableIncrementSetupAfterMDApproved = true;
      } else if (result.data?.mdReviewStatus == 'Rejected') {
        this.disableIncrementSetupAfterMDApproved = false;
      } else {
        this.disableIncrementSetupAfterMDApproved = false;
      }
    });
  }

  getBandDataFunction() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      toYear: this.toYear
    };
    this.httpService.callPostService(this.config.getBandListForIncrement, request).subscribe((result: any) => {
      this.getIndividualBandList = result.data.map((data: any) => ({
        band: data,
        companyKpiScore: null,
        deptKpiScore: null,
        id: null,
        individualCompetencyWeightage: null,
        individualKpiScoreWeightage: null,
        totalWeightage: null
      }));

      this.ScoreToFinalScoreConverterPlusCompanyScore = result.data.map((data: any) => ({
        band: data,
        companyKpiScore: null,
        deptKpiScore: null,
        id: null,
        individualCompetencyWeightage: null,
        individualKpiScoreWeightage: null,
        totalWeightage: null
      }));
      this.IncrementGridBandList = result.data.map((data: any) => ({
        band: data,
        id: [],
        incrementPercentage: []
      }));
      this.getScoreToFinalConverterIndividual();
      this.getScoreToFinalConverterCompany();
      this.getScoreRating();
      this.getOverallIncrementBudgetGrid();
      this.GetIncrementGrid();
    });
  }

  // Score to final score converter (Individual Score + Individual competency)

  onClickIndividualScoreEdit(itemId: number): void {
    // if (this.IsIndividualTotalWeightage || this.isInValidMaxIndividualKpi || this.isInValidMinIndividualKpi || this.isInValidMaxIndividualCompetency || this.isInValidMinIndividualCompetency) {
    //   window.alert("error kkkk")
    //   return;
    // } else {
    if (this.disableIncrementSetupAfterMDApproved == true || this.disableIncrementSetupAfterChangeYear == true) {
      this.editedIndividualScoreId = null;
      this.onCheckIconView = true;
      this.isFormDisabled = false;
    } else {
      this.editedIndividualScoreId = itemId;
      this.onCheckIconView = true;
      this.isFormDisabled = false;
    }

    // }
  }

  onSaveIndividualScoreToFinalScoreConverter() {
    if (this.editedIndividualScoreId === null) return;
    const editRow = this.getIndividualBandList[this.editedIndividualScoreId];

    const filteredScores = [
      {
        band: editRow.band ?? null,
        id: editRow.id ?? null,
        individualCompetencyWeightage: editRow.individualCompetencyWeightage ?? null,
        individualKpiScoreWeightage: editRow.individualKpiScoreWeightage ?? null,
        totalWeightage: editRow.totalWeightage ?? null
      }
    ].filter((item: any) => item.individualKpiScoreWeightage !== null && item.individualCompetencyWeightage !== null && item.totalWeightage !== null);
    if (filteredScores.length === 0) return;
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      incrementSetupId: null,
      scores: filteredScores,
      toYear: this.toYear
    };
    if (this.IsIndividualTotalWeightage || this.isInValidMaxIndividualKpi || this.isInValidMinIndividualKpi || this.isInValidMaxIndividualCompetency || this.isInValidMinIndividualCompetency) {
      window.alert('Total weightage should be 100');
      return;
    } else {
      // this.loader.simpleLoader();

      this.httpService.callPostService(this.config.incrementScoreToFinalScoreConverter, request).subscribe((result: any) => {
        this.toastr.success(result?.message);
        this.getScoreToFinalConverterIndividual();
      });
      this.editedIndividualScoreId = null;
      this.onCheckIconView = true;
      this.isFormDisabled = false;
    }
  }

  getScoreToFinalConverterIndividual() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      incrementId: null,
      toYear: this.toYear
    };
    // if (this.IsIndividualTotalWeightage || this.isInValidMaxIndividualKpi || this.isInValidMinIndividualKpi || this.isInValidMaxIndividualCompetency || this.isInValidMinIndividualCompetency) {
    //   window.alert("error")
    //   return;
    // } else {
    this.httpService.callPostService(this.config.getScoreToFinalConverterIndividual, request).subscribe((result: any) => {
      const apiData = result.data;
      this.getIndividualBandList = this.getIndividualBandList.map((item: any) => {
        const matchingBandData = apiData.find((apiItem: any) => apiItem.band === item.band);
        console.log(matchingBandData);

        if (matchingBandData) {
          item.individualKpiScoreWeightage = matchingBandData.individualKpiScoreWeightage ?? null;
          item.id = matchingBandData.id ?? null;
          item.individualCompetencyWeightage = matchingBandData.individualCompetencyWeightage ?? null;
          item.totalWeightage = matchingBandData.totalWeightage ?? null;
        } else {
          // ✅ Reset to null if no matching band found
          item.individualKpiScoreWeightage = null;
          item.id = null;
          item.individualCompetencyWeightage = null;
          item.totalWeightage = null;
        }

        return item;
      });

      this.editedIndividualScoreId = null;
      this.onCheckIconView = false;
      this.isFormDisabled = false;
      this.loader.dismissLoader();
    });
    // }
  }

  IndividualTotalWeightage(item: any) {
    const scoreWeightage: number = Number(item.individualKpiScoreWeightage || 0);
    const competencyWeightage: number = Number(item.individualCompetencyWeightage || 0);
    let totalWeightage = scoreWeightage + competencyWeightage;
    if (totalWeightage > 100 || totalWeightage < 100) {
      this.IsIndividualTotalWeightage = true;
    } else {
      this.IsIndividualTotalWeightage = false;
    }
    if (scoreWeightage < 0) {
      item.individualKpiScoreWeightage = 0;
    }
    if (competencyWeightage < 0) {
      item.individualCompetencyWeightage = 0;
    }
    item.totalWeightage = totalWeightage;
    this.isInValidMaxIndividualKpi = item.individualKpiScoreWeightage >= 101;
    this.isInValidMinIndividualKpi = item.individualKpiScoreWeightage < 0;
    this.isInValidMaxIndividualCompetency = item.individualCompetencyWeightage >= 101;
    this.isInValidMinIndividualCompetency = item.individualCompetencyWeightage < 0;
  }

  // Score to final score converter (Individual Score + Dept Score + Company Score)

  onClickIndividualDeptcompetencyScoreEdit(itemId: number): void {
    // if (this.InvalidcompanyscoreWT || this.InvalidIndividualCompetencyMaxTW || this.InvalidIndividualCompetencyMinTW
    //   || this.InvalidDepthKpiMaxScore || this.InvalidDepthKpiMinScore || this.InvalidcompanyKpiScoreMaxScore ||
    //   this.InvalidcompanyKpiScoreMinScore) {
    //   window.alert("error")
    // } else {
    if (this.disableIncrementSetupAfterMDApproved == true || this.disableIncrementSetupAfterChangeYear == true) {
      this.editedIndividualDeotCompanyScoreId = null;
      this.onCheckIconView = true;
      this.isFormDisabled = false;
    } else {
      this.editedIndividualDeotCompanyScoreId = itemId;
      this.onCheckIconView = true;
      this.isFormDisabled = false;
    }

    // }
  }

  // onSaveincrementScoreToFinalScoreCompanyConverter() {
  //   const filteredScores = this.ScoreToFinalScoreConverterPlusCompanyScore.filter((item: any) =>
  //     item.individualCompetencyWeightage !== null &&
  //     item.deptKpiScore !== null &&
  //     item.companyKpiScore !== null &&
  //     item.totalWeightage !== null
  //   );
  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "fromYear": this.fromYear,
  //     "incrementSetupId": null,
  //     "scores": filteredScores,
  //     "toYear": this.toYear
  //   }

  //   if (this.InvalidcompanyscoreWT || this.InvalidIndividualCompetencyMaxTW || this.InvalidIndividualCompetencyMinTW
  //     || this.InvalidDepthKpiMaxScore || this.InvalidDepthKpiMinScore || this.InvalidcompanyKpiScoreMaxScore ||
  //     this.InvalidcompanyKpiScoreMinScore) {
  //     window.alert("error")
  //   } else {
  //     this.loader.simpleLoader();
  //     this.httpService.callPostService(this.config.incrementScoreToFinalScoreCompanyConverter, request)
  //       .subscribe((result: any) => {
  //         this.getScoreToFinalConverterCompany();
  //       })
  //     this.editedIndividualDeotCompanyScoreId = null;
  //     this.onCheckIconView = false;
  //     this.isFormDisabled = false;
  //   }
  // }

  onSaveincrementScoreToFinalScoreCompanyConverter() {
    if (this.editedIndividualDeotCompanyScoreId === null) return;
    const editedRow = this.ScoreToFinalScoreConverterPlusCompanyScore[this.editedIndividualDeotCompanyScoreId];
    const filteredScores = [
      {
        band: editedRow.band ?? null,
        id: editedRow.id ?? null,
        individualCompetencyWeightage: editedRow.individualCompetencyWeightage ?? null,
        deptKpiScore: editedRow.deptKpiScore ?? null,
        companyKpiScore: editedRow.companyKpiScore ?? null,
        totalWeightage: editedRow.totalWeightage ?? null
      }
    ].filter(item => item.individualCompetencyWeightage !== null && item.deptKpiScore !== null && item.companyKpiScore !== null && item.totalWeightage !== null);
    if (filteredScores.length === 0) return;
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      incrementSetupId: null,
      scores: filteredScores,
      toYear: this.toYear
    };
    if (this.InvalidcompanyscoreWT || this.InvalidIndividualCompetencyMaxTW || this.InvalidIndividualCompetencyMinTW || this.InvalidDepthKpiMaxScore || this.InvalidDepthKpiMinScore || this.InvalidcompanyKpiScoreMaxScore || this.InvalidcompanyKpiScoreMinScore) {
      window.alert('Weightage is not equal to 100');
    } else {
      // this.loader.simpleLoader();
      this.httpService.callPostService(this.config.incrementScoreToFinalScoreCompanyConverter, request).subscribe((result: any) => {
        this.toastr.success(result?.message);
        this.getScoreToFinalConverterCompany();
      });
      this.editedIndividualDeotCompanyScoreId = null;
      this.onCheckIconView = false;
      this.isFormDisabled = false;
    }
  }

  getScoreToFinalConverterCompany() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      incrementId: null,
      toYear: this.toYear
    };
    this.httpService.callPostService(this.config.getScoreToFinalConverterCompany, request).subscribe((result: any) => {
      // if (this.InvalidcompanyscoreWT || this.InvalidIndividualCompetencyMaxTW || this.InvalidIndividualCompetencyMinTW
      //   || this.InvalidDepthKpiMaxScore || this.InvalidDepthKpiMinScore || this.InvalidcompanyKpiScoreMaxScore ||
      //   this.InvalidcompanyKpiScoreMinScore) {
      //   window.alert("error")
      // } else {
      const apiData = result.data;
      this.ScoreToFinalScoreConverterPlusCompanyScore = this.ScoreToFinalScoreConverterPlusCompanyScore.map((item: any) => {
        const matchingBandData = apiData.find((apiItem: any) => apiItem.band === item.band);
        if (matchingBandData) {
          item.individualCompetencyWeightage = matchingBandData.individualCompetencyWeightage;
          item.id = matchingBandData.id;
          item.deptKpiScore = matchingBandData.deptKpiScore;
          item.companyKpiScore = matchingBandData.companyKpiScore;
          item.totalWeightage = matchingBandData.totalWeightage;
        } else {
          item.individualCompetencyWeightage = null;
          item.id = null;
          item.deptKpiScore = null;
          item.companyKpiScore = null;
          item.totalWeightage = null;
        }
        return item;
      });
      this.editedIndividualDeotCompanyScoreId = null;
      this.onCheckIconView = false;
      this.isFormDisabled = false;
      // }
      this.loader.dismissLoader();
    });
  }
  preventMinus(event: KeyboardEvent) {
    if (event.key === '-' || event.key === 'Subtract') {
      event.preventDefault();
    }
  }
  GetScoreToFinalConverterTotalWeightage(item: any) {
    const individualCompetencyWeightage: number = Number(item.individualCompetencyWeightage || 0);
    const deptKpiScore: number = Number(item.deptKpiScore || 0);
    const companyKpiScore: number = Number(item.companyKpiScore || 0);
    let totalWeightage = individualCompetencyWeightage + deptKpiScore + companyKpiScore;
    if (totalWeightage > 100 || totalWeightage < 100) {
      this.InvalidcompanyscoreWT = true;
    } else {
      this.InvalidcompanyscoreWT = false;
    }
    if (individualCompetencyWeightage < 0) {
      item.individualCompetencyWeightage = 0;
    }
    if (deptKpiScore < 0) {
      item.deptKpiScore = 0;
    }
    if (companyKpiScore < 0) {
      item.companyKpiScore = 0;
    }
    item.totalWeightage = totalWeightage;
    this.InvalidIndividualCompetencyMaxTW = item.individualCompetencyWeightage >= 101;
    this.InvalidIndividualCompetencyMinTW = item.individualCompetencyWeightage < 0;
    this.InvalidDepthKpiMaxScore = item.deptKpiScore >= 101;
    this.InvalidDepthKpiMinScore = item.deptKpiScore < 0;
    this.InvalidcompanyKpiScoreMaxScore = item.companyKpiScore >= 101;
    this.InvalidcompanyKpiScoreMinScore = item.companyKpiScore < 0;
  }

  validateInputForNormalization(event: KeyboardEvent): void {
    const pattern = /^[0-9.%]$/; // Allows only digits (0-9) and '%'.
    const inputChar = String.fromCharCode(event.keyCode || event.which);

    if (!pattern.test(inputChar)) {
      event.preventDefault(); // Prevent invalid character input.
    }
  }

  // Score to Rating Converter

  editRating(index: any) {
    this.editIndexofRating = index;
  }

  addMoreScoreRating() {
    var maxRange = 0;
    if (this.addedratingArray?.length == 0) {
      maxRange = 0;
    } else {
      for (let i = 0; i < this.addedratingArray?.length; i++) {
        maxRange = this.addedratingArray[i].maxRange;
      }
    }
    this.ratingArrayForSetup.push({
      maxRange: null,
      rating: null,
      minRange: maxRange
    });
  }
  errorMsgForRange: boolean = false;

  saveAddedScoreRating() {
    // this.loader.simpleLoader();
    if (this.ratingArrayForSetup[0].maxRange != null && this.ratingArrayForSetup[0].rating != null) {
      if (!this.isInValidMaxRange && !this.isInValidRating) {
        this.errorMsgForRange = false;
        const request = {
          companyId: this.loggedInUserCompanyID,
          fromYear: this.fromYear,
          incrementSetupId: null,
          ratings: [
            {
              id: null,
              maxScoreRange: this.ratingArrayForSetup[0].maxRange,
              minScoreRange: this.ratingArrayForSetup[0].minRange,
              rating: this.ratingArrayForSetup[0].rating
            }
          ],
          toYear: this.toYear
        };
        this.httpService.callPostService(this.config.incrementScoreToRatingConverter, request).subscribe((result: any) => {
          if (result) {
            this.toastr.success(result?.message);
            this.getScoreRating();
          }
        });
        this.ratingArrayForSetup = [];
      } else {
        this.errorMsgForRange = true;
      }
    }
  }

  getScoreRating() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      incrementId: null,
      toYear: this.toYear
    };
    this.httpService.callPostService(this.config.getScoreToRatingConverter, request).subscribe((result: any) => {
      this.addedratingArray = [];
      this.addedratingArray = result.data.map((ele: any) => ({
        maxRange: ele.maxScoreRange,
        minRange: ele.minScoreRange,
        rating: ele.rating,
        id: ele.id
      }));
      this.loader.dismissLoader();
    });
  }

  isInValidMaxRange = false;
  isInValidRating = false;

  onMaxRangeChange(data: any) {
    if (data.maxRange > data.minRange || isNaN(data.maxRange)) {
      this.isInValidMaxRange = false;
    } else {
      this.isInValidMaxRange = true;
    }
  }

  onRatingEmpty(data: any) {
    if (isNaN(data.rating)) {
      this.isInValidRating = false;
    } else {
      this.isInValidRating = true;
    }
  }

  removecreatedScoresRating() {
    this.errorMsgForRange = false;
    this.isInValidMaxRange = false;
    this.isInValidRating = false;
    this.ratingArrayForSetup = [];
  }

  deleteScoreRating() {
    if (this.disableIncrementSetupAfterMDApproved != true || this.disableIncrementSetupAfterChangeYear == true) {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Are you sure you want to delete all ratings?',
          btn1: 'Cancel',
          btn2: 'Yes',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        }
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          const request = {
            companyId: this.loggedInUserCompanyID,
            fromYear: this.fromYear,
            incrementId: null,
            toYear: this.toYear
          };
          this.httpService.callPostService(this.config.deleteRatings, request).subscribe((result: any) => {
            this.getScoreRating();
            this.IncrementGridBandList.flatMap((band: any) =>
              this.addedratingArray.map((rating: any, colId: any) => {
                band.incrementPercentage[colId] = '';
              })
            );
          });
        }
      });
    } else {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Setup is Approved By MD',
          btn2: 'Ok',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        }
      });
    }
  }

  // Overall Increment Budget Grid
  showCurrentYear() {
    const currentYear = new Date().getFullYear();
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
      this.overallIncrementBudgetGridCurrentYear = `${currentYear}-${currentYear}`;
    } else {
      this.overallIncrementBudgetGridCurrentYear = `${currentYear}-${currentYear + 1}`;
      if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
        if (currentMonth < 3) {
          this.overallIncrementBudgetGridCurrentYear = `${currentYear - 1}-${currentYear}`;
        } else {
          this.overallIncrementBudgetGridCurrentYear = `${currentYear}-${currentYear + 1}`;
        }
      }
      if (this.loggedInCompanyFiscalyear === 'July_Jun') {
        if (currentMonth < 6) {
          this.overallIncrementBudgetGridCurrentYear = `${currentYear - 1}-${currentYear}`;
        } else {
          this.overallIncrementBudgetGridCurrentYear = `${currentYear}-${currentYear + 1}`;
        }
      }
      if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
        if (currentMonth < 9) {
          this.overallIncrementBudgetGridCurrentYear = `${currentYear - 1}-${currentYear}`;
        } else {
          this.overallIncrementBudgetGridCurrentYear = `${currentYear}-${currentYear + 1}`;
        }
      }
    }

    // if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
    //   this.overallIncrementBudgetGridCurrentYear = `${currentYear}-${currentYear}`;
    // } else {
    //   this.overallIncrementBudgetGridCurrentYear = `${currentYear}-${currentYear + 1}`;
    // }
  }

  getOverallIncrementBudgetGrid() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      toYear: this.toYear
    };
    this.httpService.callPostService(this.config.getOverallBudgetGrid, request).subscribe((result: any) => {
      this.GetOverallIncrementBudgetGridData = result.data.map((ele: any) => ({
        year: `${ele.fromYear}-${ele.toYear}`,
        id: ele.id,
        noOfEligibleEmployees: ele.noOfEligibleEmployees,
        totalCtcOfEmployees: ele.totalCtcOfEmployees,
        finalIncrementPercentage: ele.finalIncrementPercentage,
        finalIncrementAmount: ele.finalIncrementAmount
      }));
      // TODO Enable loader and remove below function once old functionality work
      // this.loader.dismissLoader();
      this.getAcceptanceReportUsers();
    });
  }

  editRow(index: number) {
    // if (this.isInValidMaxOverallBudgetGrid) {
    //   return;
    // }else{
    //   this.isInValidMaxOverallBudgetGrid = false;
    if (this.disableIncrementSetupAfterMDApproved == true || this.disableIncrementSetupAfterChangeYear == true) {
      this.isEditingRow = null;
      this.isShowOverallBudgetGridBtn = true;
    } else {
      this.isEditingRow = index;
      this.isShowOverallBudgetGridBtn = true;
    }
    // }
  }

  OnSaveFinalIncrementPercentage(data: any) {
    if (!this.isInValidMaxOverallBudgetGrid) {
      const request = {
        companyId: this.loggedInUserCompanyID,
        cutOffDate: null,
        finalIncrementPercentage: data.finalIncrementPercentage,
        fromMonth: null,
        id: data.id || null,
        incrementOn: null,
        toMonth: null,
        year: data.year
      };
      // this.loader.simpleLoader();
      this.httpService.callPostService(this.config.addFinalIncrementPercentage, request).subscribe((result: any) => {
        this.isEditingRow = null;
        this.isFinalIncrementPctFormDisabled = true;
        if (result) {
          this.toastr.success(result?.message);
          this.getOverallIncrementBudgetGrid();
        }
      });
    }
  }

  cancelEdit(index: number) {
    this.isEditingRow = null;
    this.getOverallIncrementBudgetGrid();
    this.isFinalIncrementPctFormDisabled = true;
  }

  GetOverallIncrementBudgetGridIncrementPct(item: any) {
    const IncrementPercentage: number = Number(item.finalIncrementPercentage || 0);
    if (IncrementPercentage < 0) {
      item.finalIncrementPercentage = 0;
    }

    if (item.finalIncrementPercentage == null || item.finalIncrementPercentage == 0) {
      this.isInValidMaxOverallBudgetGrid = true;
    } else {
      this.isInValidMaxOverallBudgetGrid = false;
    }
  }

  // Increment Grid - Band & Rating Wise

  onClickBandAndRatingWiseEdit(rowId: any) {
    if (this.disableIncrementSetupAfterMDApproved == true || this.disableIncrementSetupAfterChangeYear == true) {
      this.editedBandAndRatingWiseId = null;
      this.onCheckIconView = true;
      this.isFormDisabled = false;
    } else {
      this.editedBandAndRatingWiseId = rowId;
      this.onCheckIconView = true;
      this.isFormDisabled = false;
    }
  }

  // onSaveIncrementGrid() {
  //   this.editedBandAndRatingWiseId = null;
  //   this.onCheckIconView = false;
  //   this.isFormDisabled = false;
  //   const getResult = this.IncrementGridBandList.flatMap((band: any) =>
  //     this.addedratingArray.map((rating: any, colId: any) => ({
  //       "band": band.band,
  //       "id": band.id[colId],
  //       "incrementPercentage": band.incrementPercentage[colId] || null,
  //       "ratingId": rating.id
  //     }))
  //   );
  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "fromYear": this.fromYear,
  //     "incrementSetupId": null,
  //     "list": getResult,
  //     "toYear": this.toYear
  //   };
  //   this.loader.simpleLoader();
  //   this.httpService.callPostService(this.config.incrementGrid, request).subscribe((result: any) => {
  //     if (result) {
  //       this.GetIncrementGrid();
  //     }
  //   });
  // }

  onSaveIncrementGrid() {
    if (this.editedBandAndRatingWiseId === null) return;
    this.onCheckIconView = false;
    this.isFormDisabled = false;
    const editedBand = this.IncrementGridBandList[this.editedBandAndRatingWiseId];
    const getResult = this.addedratingArray
      .map((rating: any, colId: any) => ({
        band: editedBand.band,
        id: editedBand.id[colId],
        incrementPercentage: editedBand.incrementPercentage[colId] ?? null,
        ratingId: rating.id
      }))
      .filter((item: any) => item.incrementPercentage !== null && item.incrementPercentage !== undefined);
    if (getResult.length === 0) return;
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      incrementSetupId: null,
      list: getResult,
      toYear: this.toYear
    };

    // this.loader.simpleLoader();
    this.httpService.callPostService(this.config.incrementGrid, request).subscribe((result: any) => {
      if (result) {
        this.toastr.success(result?.message);
        this.GetIncrementGrid();
      }
    });
  }

  GetIncrementGrid() {
    this.editedBandAndRatingWiseId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      incrementId: null,
      toYear: this.toYear
    };
    this.httpService.callPostService(this.config.getIncrementGrid, request).subscribe((result: any) => {
      if (result && result.data) {
        const IncrementPercentageData: any = {};
        result.data.forEach((item: any) => {
          if (!IncrementPercentageData[item.band]) {
            IncrementPercentageData[item.band] = {
              band: item.band,
              id: [],
              incrementPercentage: []
            };
          }
          IncrementPercentageData[item.band].incrementPercentage.push(item.incrementPercentage);
          IncrementPercentageData[item.band].id.push(item.id);
        });
        this.IncrementGridBandList.forEach((existingItem: any) => {
          if (IncrementPercentageData[existingItem.band]) {
            existingItem.incrementPercentage = IncrementPercentageData[existingItem.band].incrementPercentage;
            existingItem.id = IncrementPercentageData[existingItem.band].id;
          }
        });
      }
      this.loader.dismissLoader();
    });
  }
  InvalidBandAndRatingWise(item: any, colId: any) {
    let value = Number(item.incrementPercentage[colId]);
    if (value <= 0) {
      item.incrementPercentage[colId] = 0;
    }
  }

  // Increment FY Year
  getIncrementFyYear() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: null,
      toYear: null
    };
    this.httpService.callPostService(this.config.getOverallBudgetGrid, request).subscribe((result: any) => {
      this.getIncrementFyYearList = result.data.map((ele: any) => ({
        year: `${ele.fromYear}-${ele.toYear}`
      }));

      const currentYear = new Date().getFullYear();
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      let yearValue = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
        if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
          if (currentMonth < 3) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'July_Jun') {
          if (currentMonth < 6) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
          if (currentMonth < 9) {
            yearValue = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
      }
      let selectedYearIndex = this.getIncrementFyYearList.findIndex((ele: any) => ele?.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }
      this.IncrementFyYear = this.getIncrementFyYearList[selectedYearIndex]?.year;
      var test: any = this.IncrementFyYear?.split('-');
      this.incrementFromYear = test[0];
      this.incrementToYear = test[1];
      if (!this.loggedInUserIsMD) {
        this.sendApproveForIsPromoted();
        this.getLetterAfterApprovel();
      } else {
        this.checkStatusForIncrementSetup();
        this.getFreezForTheHODStatus();
        this.getIncrementInputTableHideShowAllData();
        this.getIncrementSummaryTableHideShowAllData();
        this.getIncrementReportsTableHideShowAllData();
      }
    });
  }

  selectedIncrementFYYear(event: any) {
    const demovalue = event.value.toString();
    const selectedYear = demovalue.split('-');
    this.incrementFromYear = selectedYear[0];
    this.incrementToYear = selectedYear[1];

    if (this.IncrementFyYear) {
      this.checkStatusForIncrementSetup();
    }
  }

  checkStatusForIncrementSetup() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.incrementFromYear,
      toYear: this.incrementToYear
    };
    if (this.selectedTypeTabName == 'Acceptance report') {
      this.getAcceptanceReport();
    } else {
      this.httpService.callPostService(this.config.checkSetupForBandsForIncrement, request).subscribe((result: any) => {
        if (result.data.isIncrementSet === true) {
          if (this.loggedInUserRole == 'Employee') {
            this.sendApproveForIsPromoted();
          } else {
            this.completeStatusErrorMsg = true;
            this.getDepartmentByYear();
            if (this.selectedTypeTabName == 'Dashboard') {
              this.getIncrementCounterList();
              this.BudgetVsActualGraph();
              this.genderWiseBudgetVsActualGraph();
              this.BudgetVsActualIncrementDeptGraph();
              this.RatingWiseIncrementAmountGraph();
              this.bandWiseBudgetVsActualsGraph();
              this.ratingVsEmpCountGraph();
              this.yearVsBudgetAndActualAmountGraph();
              this.deptWiseEligibleAndNonEligibleEmpCountGraph();
            } else if (this.selectedTypeTabName == 'Increment Input') {
              this.getMDApprovedData();
              this.getIncrementInputCount();
              if (this.activeIncrementInputTab) {
                this.getIncrementInputisEligibleTableData();
              } else {
                this.getIncrementInputisNonEligibleTableData();
              }
              this.getApproveByHodData();
            } else if (this.selectedTypeTabName == 'Increment Summary') {
              this.getIncrementSummaryData();
            } else if (this.selectedTypeTabName == 'Reports') {
              this.getIncrementReportsEligibleData();
              this.getIncrementReportsNonEligibleData();
            } else if (this.selectedTypeTabName == 'My Increment Letter' && this.loggedInUserRole == 'HOD' && !this.isShowMD) {
              // TODO Enable loader and remove below function once old functionality work
              this.getAcceptanceReportUsers();
            }
          }
        } else {
          this.completeStatusErrorMsg = false;
          if (this.selectedTypeTabName == 'Dashboard') {
            this.getIncrementCounterList();
            this.getDepartmentByYearList = [];
            this.selectGenderWiseBudgetVsActualDept = null;
            this.selectedBudgetVsActualIncrementDept = null;
            this.selectRatingWiseIncrementAmount = null;
            this.selectBandWiseBudgetVsActuals = null;
            this.selectratingVsEmpCount = null;
            this.selectYearVsBudgetAndActualAmount = null;
            this.selectDeptWiseEligibleAndNonEligibleEmp = null;

            this.getIncrementCounterList();
            this.BudgetVsActualGraph();
            this.genderWiseBudgetVsActualGraph();
            this.BudgetVsActualIncrementDeptGraph();
            this.RatingWiseIncrementAmountGraph();
            this.bandWiseBudgetVsActualsGraph();
            this.ratingVsEmpCountGraph();
            this.yearVsBudgetAndActualAmountGraph();
            this.deptWiseEligibleAndNonEligibleEmpCountGraph();
          }
          if (this.selectedTypeTabName == 'Increment Input') {
            this.getDepartmentByYearList = [];
            this.getBandList = [];
            this.getManagerList = [];
            this.getEmployeeList = [];
            this.selectedIncrementInputDept = null;
            this.selectedIncrementInputBand = null;
            this.selectedIncrementInputManager = null;
            this.selectedIncrementInputEmp = null;
            this.getIncrementInputEligibleTableData = [];
            this.getIncrementInputNonEligibleTableData = [];
            this.totalEligibleCount = 0;
            this.totalNonEligibleCount = 0;
            this.ShowIncrementInputStatus = 'Pending';
            this.isHideFreezeForTheHodBtn = true;
            this.afterMDAndCEOApproval = false;
            this.disableBtnsOnsendApprovelForMD = false;
            this.afterHODForApprovalDate = false;
          }
          if (this.selectedTypeTabName == 'Increment Summary') {
            this.getIncrementSummaryTableData = [];
          }
          if (this.selectedTypeTabName == 'Reports') {
            this.reportsTotalEligibleCount = 0;
            this.reportsTotalNonEligibleCount = 0;
            this.getDepartmentByYearList = [];
            this.getIncrementReportBandList = [];
            this.getIncrementReportDesignationList = [];
            this.getIncrementReportManagerList = [];
            this.getIncrementReportEmployeeList = [];
            this.getIncrementReportRatingList = [];
            this.selectedIncrementReportDep = null;
            this.selectedIncrementReportBand = null;
            this.selectedIncrementReportDesignation = null;
            this.selectedIncrementReportManager = null;
            this.selectedIncrementReportEmployee = null;
            this.selectedIncrementReportPromotion = null;
            this.selectedIncrementReportMarketCorr = null;
            this.selectedIncrementReportRating = null;
            this.getIncrementReportsEligibleTableData = [];
            this.getIncrementReportsNonEligibleTableData = [];
          }
        }
      });
    }
  }

  getDepartmentByYear() {
    this.getEligibleDepartments();
    let isEmpEligible: any;
    if (this.selectedTypeTabName == 'Dashboard') {
      isEmpEligible = true;
    } else {
      isEmpEligible = this.checkIncrementDepartment;
    }
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.incrementFromYear,
      toYear: this.incrementToYear,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      isEligible: isEmpEligible
    };
    this.httpService.callPostService(this.config.getDepartmentsByYearRange, request).subscribe((result: any) => {
      this.getDepartmentByYearList = result.data.map((ele: any) => ({
        id: ele,
        name: ele
      }));
    });
  }

  getEligibleDepartments() {
    const request = {
      band: [],
      companyId: this.loggedInUserCompanyID,
      department: [],
      employeeId: [],
      fromYear: this.incrementFromYear,
      isEligible: true,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      manager: [],
      search: this.searchIncrementInputTableData,
      toYear: this.incrementToYear
    };

    this.httpService.callPostService(this.config.getIncrementInput, request).subscribe((allDepts: any) => {
      this.eligibleDepartments = [];
      if (allDepts?.data?.length > 0) {
        allDepts.data.map((deptName: any) => {
          if (deptName?.departmentName)
            this.eligibleDepartments.push({
              id: deptName?.departmentName,
              name: deptName?.departmentName
            });
        });
      }
    });
  }

  // increment Dashboard

  // Counter
  getIncrementCounterList() {
    let request = {};
    // if(this.loggedInUserRole == 'HOD'){
    request = {
      companyId: this.loggedInUserCompanyID,
      depts: null,
      fromYear: this.incrementFromYear,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      toYear: this.incrementToYear
    };
    // }else{
    //   request = {
    //     "companyId": this.loggedInUserCompanyID,
    //     "depts": null,
    //     "fromYear": this.incrementFromYear,
    //     "isHod": false,
    //     "toYear": this.incrementToYear
    //   }
    // }
    this.httpService.callPostService(this.config.getCounters, request).subscribe((result: any) => {
      this.avgPercentageOfMarketCorrection = result.data.avgPercentageOfMarketCorrection;
      this.avgPercentageOfOverallIncrement = result.data.avgPercentageOfOverallIncrement;
      this.avgPercentageOfPromotionIncrement = result.data.avgPercentageOfPromotionIncrement;
      this.budgetAmount = result.data.budgetAmount;
      this.budgetPercentage = result.data.budgetPercentage;
      this.eligibleEmps = result.data.eligibleEmps;
      this.empGivenPromotion = result.data.empGivenPromotion;
      this.marketCorrectionEmp = result.data.marketCorrectionEmp;
      this.noOfEmployees = result.data.noOfEmployees;
    });
  }

  onClickMarketCorrectionEmp() {
    if (window.innerWidth <= 1000) return;

    const dialogConfig = new MatDialogConfig();
    // dialogConfig.width = '100vw';
    // dialogConfig.height = '100vh';
    // dialogConfig.maxWidth = '100vw';
    // dialogConfig.maxHeight = '100vh';
    dialogConfig.panelClass = 'phi_mdc_dialog__container_100'; // 👈 Add this
    dialogConfig.data = {};

    const dialogRef = this.dialog.open(MarketCorrectionEmployeePopupComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result: any) => {});
  }

  onClickEmpGivenPromotion() {
    // if (window.innerWidth <= 800) {
    //   return;
    // }
    const dialogConfig = new MatDialogConfig();
    //    dialogConfig.width = '95vw';       // 95% of screen width
    // dialogConfig.height = '95vh';      // 95% of screen height
    // dialogConfig.maxWidth = '95vw';
    // dialogConfig.maxHeight = '95vh';
    dialogConfig.data = {};
    dialogConfig.panelClass = 'phi_mdc_dialog__container_100';
    const dialogRef = this.dialog.open(EmployeeGivenPromotionPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result: any) => {});
  }

  onClickEligibleEmployees() {
    // if (window.innerWidth <= 800) {
    //   return;
    // }
    const dialogConfig = new MatDialogConfig();
    //   dialogConfig.width = '95vw';       // 95% of screen width
    // dialogConfig.height = '95vh';      // 95% of screen height
    // dialogConfig.maxWidth = '95vw';
    // dialogConfig.maxHeight = '95vh';
    dialogConfig.data = {};
    dialogConfig.panelClass = 'phi_mdc_dialog__container_100';
    const dialogRef = this.dialog.open(EligibleEmployeesPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result: any) => {});
  }

  // Budget Vs Actua Graph
  BudgetVsActualGraph() {
    let id: any;
    if (this.completeStatusErrorMsg) {
      id = this.loggedInUserCompanyID;
    } else {
      id = null;
    }
    const request = {
      companyId: id,
      depts: null,
      fromYear: this.incrementFromYear,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      toYear: this.incrementToYear
    };
    this.httpService.callPostService(this.config.getBudgetvsActual, request).subscribe((result: any) => {
      if (result.data !== null) {
        this.BudgetVsActualBarGraph(result.data);
      } else {
        this.BudgetVsActualBarGraph([]);
      }
    });
  }

  BudgetVsActualBarGraph(data: any) {
    const chartDom = document.getElementById('budgetVsActualGraph');
    const myChart = echarts.init(chartDom);

    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e7) + ' Cr'
        );
      if (num >= 1e5)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e5) + ' L'
        );
      if (num >= 1e3)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e3) + ' K'
        );
      return new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(num);
    };

    const totalActual = parseFloat(data.actualAmount);
    const totalBudget = parseFloat(data.budgetAmount);

    const option = {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) => `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`).join('<br/>');
          return tooltipContent;
        }
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center'
      },
      yAxis: {
        type: 'category',
        data: [''],
        name: 'Category',
        nameLocation: 'middle',
        nameTextStyle: { fontSize: 14, padding: 20 },
        axisTick: { show: false },
        axisLabel: { show: false }
      },
      xAxis: {
        type: 'value',
        name: '',
        nameLocation: 'middle',
        nameTextStyle: { fontSize: 14, padding: 20 },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        },
        splitLine: { show: false }
      },
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '20%',
          data: [totalBudget],
          itemStyle: { color: '#393186' },
          label: {
            show: true,
            position: 'right',
            color: '#000',
            fontSize: 12,
            formatter: (params: any) => formatNumber(params.value, 4)
          }
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '20%',
          data: [totalActual],
          itemStyle: { color: '#F3820E' },
          label: {
            show: true,
            position: 'right',
            color: '#000',
            fontSize: 12,
            formatter: (params: any) => formatNumber(params.value, 4)
          }
        }
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '10%',
        bottom: '15%',
        containLabel: true
      }
    };

    myChart.setOption(option);
  }

  OnClickDownloadBudgetvsActualGraph() {
    this.pdfDownload.incrementGraphPDFdownload(
      'budgetVsActualGraph', // chartId
      '', // tableId
      'Budget vs Actual', // Title
      null // Department
    );
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "depts": this.getDepartmentByYearList.map((ele: any) => ele.name),
    //   "fromYear": this.fromYear,
    //   "isHod": this.loggedInUserRole == 'HOD',
    //   "reportName": "BudgetvsActual",
    //   "reportType": "Bar Graph",
    //   "toYear": this.toYear
    // }
    // this.httpService.callPostService(this.config.IncrementDashboardGraphDownload, request).
    //   subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
  }

  // Gender wise - Budget vs Actual Graph

  selectedGenderWieBudgetVsActualDept() {
    this.genderWiseBudgetVsActualGraph();
    // if(this.selectGenderWiseBudgetVsActualDept.length > 0){
    //   this.genderWiseBudgetVsActualGraph()
    // }
  }

  genderWiseBudgetVsActualGraph() {
    let request = {};
    let id: any;

    if (this.completeStatusErrorMsg) {
      id = this.loggedInUserCompanyID;
    } else {
      id = null;
    }
    request = {
      companyId: id,
      depts: this.selectGenderWiseBudgetVsActualDept ? [this.selectGenderWiseBudgetVsActualDept] : [],
      fromYear: this.incrementFromYear,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      toYear: this.incrementToYear
    };
    this.getGenderWiseBudgetVsActualData = [];
    this.httpService.callPostService(this.config.getBudgetvsActualForGenderOfDepts, request).subscribe((result: any) => {
      if (result.data != null) {
        this.getGenderWiseBudgetVsActualData = result.data;
        this.genderWiseBudgetVsActualDeptGraphType.bar = this.genderWiseBudgetVsActualBarGraph(this.getGenderWiseBudgetVsActualData);
        this.genderWiseBudgetVsActualDeptGraphType.pie = this.genderWiseBudgetVsActualPieGraph(this.getGenderWiseBudgetVsActualData);
        this.genderWiseBudgetVsActualDeptGraphType.line = this.genderWiseBudgetVsActualLineGraph(this.getGenderWiseBudgetVsActualData);
        this.switchGenderWiseBudgetVsActualGraphType('bar');
      } else {
        this.getGenderWiseBudgetVsActualData = [];
        this.genderWiseBudgetVsActualDeptGraphType.bar = this.genderWiseBudgetVsActualBarGraph(this.getGenderWiseBudgetVsActualData);
        this.genderWiseBudgetVsActualDeptGraphType.pie = this.genderWiseBudgetVsActualPieGraph(this.getGenderWiseBudgetVsActualData);
        this.genderWiseBudgetVsActualDeptGraphType.line = this.genderWiseBudgetVsActualLineGraph(this.getGenderWiseBudgetVsActualData);
        this.switchGenderWiseBudgetVsActualGraphType('bar');
      }
    });
  }

  switchGenderWiseBudgetVsActualGraphType(graphType: any) {
    this.generWiseBudgetVsActualIcon = graphType;
    this.GenerWiseBudgetVsActualTable = false;

    const dom = document.getElementById('GenderWiseBudgetVsActualGraph') as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.genderWiseBudgetVsActualBarGraph(this.getGenderWiseBudgetVsActualData);
      }
      if (graphType == 'pie') {
        this.genderWiseBudgetVsActualPieGraph(this.getGenderWiseBudgetVsActualData);
      }
      if (graphType == 'line') {
        this.genderWiseBudgetVsActualLineGraph(this.getGenderWiseBudgetVsActualData);
      }
      if (this.genderWiseBudgetVsActualDeptGraphType[graphType] && typeof this.genderWiseBudgetVsActualDeptGraphType[graphType] === 'object') {
        chartEmpTaskStatus.setOption(this.genderWiseBudgetVsActualDeptGraphType[graphType], true);
      }
    }
  }

  genderWiseBudgetVsActualBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e7) + ' Cr'
        );
      if (num >= 1e5)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e5) + ' L'
        );
      if (num >= 1e3)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e3) + ' K'
        );
      return new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) => `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`).join('<br/>');
          return tooltipContent;
        }
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center'
      },
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.gender),
          name: 'Gender',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: {
        type: 'value',
        name: 'Increment',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 18
        },
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        }
      },
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.budgetAmount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4)
          }
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.actualAmount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4)
          }
        }
      ]
    };
  }

  genderWiseBudgetVsActualPieGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return (num / 1e7).toFixed(2) + ' Cr';
      if (num >= 1e5) return (num / 1e5).toFixed(2) + ' L';
      if (num >= 1e3) return (num / 1e3).toFixed(2) + ' K';
      return num.toFixed(2);
    };
    const totalActual = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.actualAmount), 0);
    const totalBudget = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.budgetAmount), 0);
    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item',
        formatter: function (params: any) {
          return `${params.name}: ${formatNumber(params.value)} (${params.percent}%)`;
        }
      },
      legend: {
        data: ['Actual', 'Budget'],
        bottom: 0,
        left: 'center'
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            { value: totalActual, name: 'Actual' },
            { value: totalBudget, name: 'Budget' }
          ]
        }
      ]
    };
  }

  genderWiseBudgetVsActualLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN').format(num);
    };

    return {
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.gender),
          name: 'Gender',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value);
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) => `${item.seriesName}: ${formatNumber(parseFloat(item.value))}`).join('<br/>');
          return tooltipContent;
        }
      },
      series: [
        {
          name: 'Actual Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.actualAmount))
        },
        {
          name: 'Budget Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.budgetAmount))
        }
      ]
    };
  }

  GenderWiseBudgetVsActualTableData() {
    this.generWiseBudgetVsActualIcon = '';
    this.GenerWiseBudgetVsActualTable = true;
  }

  downloadGenderWiseBudgetVsActualGraph() {
    this.pdfDownload.incrementGraphPDFdownload(
      'GenderWiseBudgetVsActualGraph', // chartId
      'genderWiseBudgetVsActualTable', // tableId
      'Gender wise - Budget vs Actual', // Title
      this.selectGenderWiseBudgetVsActualDept ? this.selectGenderWiseBudgetVsActualDept : 'All' // Department
    );
    // var reportType: any;
    // if (this.GenerWiseBudgetVsActualTable) {
    //   reportType = 'Table Chart'
    // } else {
    //   if (this.generWiseBudgetVsActualIcon == 'bar') {
    //     reportType = 'Bar Graph'
    //   }
    //   if (this.generWiseBudgetVsActualIcon == 'line') {
    //     reportType = 'Line Graph'
    //   }
    // }
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "depts": this.selectGenderWiseBudgetVsActualDept ? [this.selectGenderWiseBudgetVsActualDept] : this.getDepartmentByYearList.map((ele: any) => ele.name),
    //   "fromYear": this.fromYear,
    //   "isHod": this.loggedInUserRole == 'HOD',
    //   "reportName": "GenderwiseBudgetvsActual",
    //   "reportType": reportType,
    //   "toYear": this.toYear
    // }
    // this.httpService.callPostService(this.config.IncrementDashboardGraphDownload, request).
    //   subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
  }

  // Budget vs actual Increment Graph

  onSelectBudgetVsActualIncrementDept() {
    if (this.selectedBudgetVsActualIncrementDept.length > 0) {
      this.BudgetVsActualIncrementDeptGraph();
    }
  }

  onDeSelectBudgetVsActualIncrementDept() {
    this.BudgetVsActualIncrementDeptGraph();
  }

  selectAllBudgetVsActualIncrementDept(data: any) {
    this.selectedBudgetVsActualIncrementDept = data;
    this.onSelectBudgetVsActualIncrementDept();
  }

  onDeSelectAllBudgetVsActualIncrementDept() {
    this.selectedBudgetVsActualIncrementDept = [];
    this.BudgetVsActualIncrementDeptGraph();
  }

  BudgetVsActualIncrementDeptGraph() {
    let request = {};
    let id: any;
    if (this.completeStatusErrorMsg) {
      id = this.loggedInUserCompanyID;
    } else {
      id = null;
    }
    request = {
      companyId: id,
      depts: this.selectedBudgetVsActualIncrementDept ? this.selectedBudgetVsActualIncrementDept.map((ele: any) => ele.name) : [],
      fromYear: this.incrementFromYear,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      toYear: this.incrementToYear
    };

    this.httpService.callPostService(this.config.getBudgetvsActualForDepts, request).subscribe((result: any) => {
      if (result.data != null) {
        this.getBudgetVsActualIncrementData = result.data;
        this.BudgetVsActualIncrementGraphType.bar = this.BudgetVsActualIncrementDeptBarGraph(this.getBudgetVsActualIncrementData);
        this.BudgetVsActualIncrementGraphType.pie = this.BudgetVsActualIncrementDeptPieGraph(this.getBudgetVsActualIncrementData);
        this.BudgetVsActualIncrementGraphType.line = this.BudgetVsActualIncrementDeptLineGraph(this.getBudgetVsActualIncrementData);
        this.switchBudgetVsActualIncrementGraphType('bar');
      } else {
        this.getBudgetVsActualIncrementData = [];
        this.BudgetVsActualIncrementGraphType.bar = this.BudgetVsActualIncrementDeptBarGraph(this.getBudgetVsActualIncrementData);
        this.BudgetVsActualIncrementGraphType.pie = this.BudgetVsActualIncrementDeptPieGraph(this.getBudgetVsActualIncrementData);
        this.BudgetVsActualIncrementGraphType.line = this.BudgetVsActualIncrementDeptLineGraph(this.getBudgetVsActualIncrementData);
        this.switchBudgetVsActualIncrementGraphType('bar');
      }
    });
  }

  switchBudgetVsActualIncrementGraphType(graphType: any) {
    this.budgetVsActualIncrementIcon = graphType;
    this.budgetVsActualIncrementIconTable = false;

    const dom = document.getElementById('BudgetvsActualIncrementStatusGraph') as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.BudgetVsActualIncrementDeptBarGraph(this.getBudgetVsActualIncrementData);
      }
      if (graphType == 'pie') {
        this.BudgetVsActualIncrementDeptPieGraph(this.getBudgetVsActualIncrementData);
      }
      if (graphType == 'line') {
        this.BudgetVsActualIncrementDeptLineGraph(this.getBudgetVsActualIncrementData);
      }
      if (this.BudgetVsActualIncrementGraphType[graphType] && typeof this.BudgetVsActualIncrementGraphType[graphType] === 'object') {
        chartEmpTaskStatus.setOption(this.BudgetVsActualIncrementGraphType[graphType], true);
      }
    }
  }

  BudgetVsActualIncrementDeptBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e7) + ' Cr'
        );
      if (num >= 1e5)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e5) + ' L'
        );
      if (num >= 1e3)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e3) + ' K'
        );
      return new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) => `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`).join('<br/>');
          return tooltipContent;
        }
      },
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.department),
          name: 'Departments',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: {
        type: 'value',
        name: 'Budget Amount',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 26
        },
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.budgetAmount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4)
          }
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.actualAmount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4)
          }
        }
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 }
    };
  }

  BudgetVsActualIncrementDeptPieGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return (num / 1e7).toFixed(2) + ' Cr';
      if (num >= 1e5) return (num / 1e5).toFixed(2) + ' L';
      if (num >= 1e3) return (num / 1e3).toFixed(2) + ' K';
      return num.toFixed(2);
    };

    const totalActual = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.actualAmount), 0);
    const totalBudget = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.budgetAmount), 0);

    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item',
        formatter: function (params: any) {
          return `${params.name}: ${formatNumber(params.value)} (${params.percent}%)`;
        }
      },
      legend: {
        data: ['Actual', 'Budget'],
        bottom: 0,
        left: 'center'
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            { value: totalActual, name: 'Actual' },
            { value: totalBudget, name: 'Budget' }
          ]
        }
      ]
    };
  }

  BudgetVsActualIncrementDeptLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN').format(num);
    };

    return {
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.department),
          name: 'Departments',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value);
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) => `${item.seriesName}: ${formatNumber(parseFloat(item.value))}`).join('<br/>');
          return tooltipContent;
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      series: [
        {
          name: 'Actual Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.actualAmount))
        },
        {
          name: 'Budget Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.budgetAmount))
        }
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      }
    };
  }

  switchBudgetVsActualIncrementTable() {
    this.budgetVsActualIncrementIcon = '';
    this.budgetVsActualIncrementIconTable = true;
  }

  downloadBudgetVsActualIncrementGraph() {
    this.pdfDownload.incrementGraphPDFdownload(
      'BudgetvsActualIncrementStatusGraph', // chartId
      'budgetvsActualIncrementStatusTable', // tableId
      'Budget vs actual Increment', // Title
      this.selectedBudgetVsActualIncrementDept && this.selectedBudgetVsActualIncrementDept.length > 0 ? this.selectedBudgetVsActualIncrementDept.map((ele: any) => ele.name) : 'All'
    );
    // var reportType: any;
    // if (this.budgetVsActualIncrementIconTable) {
    //   reportType = 'Table Chart'
    // } else {
    //   if (this.budgetVsActualIncrementIcon == 'bar') {
    //     reportType = 'Bar Graph'
    //   }
    //   if (this.budgetVsActualIncrementIcon == 'line') {
    //     reportType = 'Line Graph'
    //   }
    // }
    // const selectedDepartments = (this.selectedBudgetVsActualIncrementDept && this.selectedBudgetVsActualIncrementDept.length > 0)
    //   ? this.selectedBudgetVsActualIncrementDept.map((ele: any) => ele.name)
    //   : this.getDepartmentByYearList.map((ele: any) => ele.name);
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "depts": selectedDepartments,
    //   "fromYear": this.fromYear,
    //   "isHod": this.loggedInUserRole == 'HOD',
    //   "reportName": "BudgetvsActualIncrement",
    //   "reportType": reportType,
    //   "toYear": this.toYear
    // }

    // this.httpService.callPostService(this.config.IncrementDashboardGraphDownload, request).
    //   subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
  }

  // Rating wise increment amount Graph

  selectedRatingWiseIncrementAmount() {
    this.RatingWiseIncrementAmountGraph();
  }

  RatingWiseIncrementAmountGraph() {
    let request = {};
    let id: any;
    if (this.completeStatusErrorMsg) {
      id = this.loggedInUserCompanyID;
    } else {
      id = null;
    }
    request = {
      companyId: id,
      depts: this.selectRatingWiseIncrementAmount ? [this.selectRatingWiseIncrementAmount] : [],
      fromYear: this.incrementFromYear,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      toYear: this.incrementToYear
    };
    this.httpService.callPostService(this.config.getBudgetvsActualForRatingOfDept, request).subscribe((result: any) => {
      if (result.data != null) {
        this.ratingWiseIncrementAmountData = result.data;

        this.ratingWiseIncrementAmountGraphType.bar = this.ratingWiseIncrementAmountBarGraph(this.ratingWiseIncrementAmountData);
        this.ratingWiseIncrementAmountGraphType.pie = this.ratingWiseIncrementAmountPieGraph(this.ratingWiseIncrementAmountData);
        this.ratingWiseIncrementAmountGraphType.line = this.ratingWiseIncrementAmountLineGraph(this.ratingWiseIncrementAmountData);
        this.switchRatingWiseIncrementAmountGraphType('bar');
      } else {
        this.ratingWiseIncrementAmountData = [];

        this.ratingWiseIncrementAmountGraphType.bar = this.ratingWiseIncrementAmountBarGraph(this.ratingWiseIncrementAmountData);
        this.ratingWiseIncrementAmountGraphType.pie = this.ratingWiseIncrementAmountPieGraph(this.ratingWiseIncrementAmountData);
        this.ratingWiseIncrementAmountGraphType.line = this.ratingWiseIncrementAmountLineGraph(this.ratingWiseIncrementAmountData);
        this.switchRatingWiseIncrementAmountGraphType('bar');
      }
    });
  }

  switchRatingWiseIncrementAmountGraphType(graphType: any) {
    this.ratingWiseIncrementAmountIcon = graphType;
    this.ratingWiseIncrementAmountTable = false;

    const dom = document.getElementById('ratingWiseIncrementAmountStatusGraph') as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.ratingWiseIncrementAmountBarGraph(this.ratingWiseIncrementAmountData);
      }
      if (graphType == 'pie') {
        this.ratingWiseIncrementAmountPieGraph(this.ratingWiseIncrementAmountData);
      }
      if (graphType == 'line') {
        this.ratingWiseIncrementAmountLineGraph(this.ratingWiseIncrementAmountData);
      }
      if (this.ratingWiseIncrementAmountGraphType[graphType] && typeof this.ratingWiseIncrementAmountGraphType[graphType] === 'object') {
        chartEmpTaskStatus.setOption(this.ratingWiseIncrementAmountGraphType[graphType], true);
      }
    }
  }

  ratingWiseIncrementAmountBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e7) + ' Cr'
        );
      if (num >= 1e5)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e5) + ' L'
        );
      if (num >= 1e3)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e3) + ' K'
        );
      return new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) => `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`).join('<br/>');
          return tooltipContent;
        }
      },
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.rating),
          name: 'Ratings',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: {
        type: 'value',
        name: 'Increment amount',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 26
        },
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '20%',
          barGap: '20%',
          data: data.map((ele: any) => ele.budgetAmount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4)
          }
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '20%',
          barGap: '20%',
          data: data.map((ele: any) => ele.actualAmount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4)
          }
        }
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 }
    };
  }

  ratingWiseIncrementAmountPieGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return (num / 1e7).toFixed(2) + ' Cr';
      if (num >= 1e5) return (num / 1e5).toFixed(2) + ' L';
      if (num >= 1e3) return (num / 1e3).toFixed(2) + ' K';
      return num.toFixed(2);
    };

    const totalActual = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.actualAmount), 0);
    const totalBudget = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.budgetAmount), 0);

    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item',
        formatter: function (params: any) {
          return `${params.name}: ${formatNumber(params.value)} (${params.percent}%)`;
        }
      },
      legend: {
        data: ['Actual', 'Budget'],
        bottom: 0,
        left: 'center'
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            { value: totalActual, name: 'Actual' },
            { value: totalBudget, name: 'Budget' }
          ]
        }
      ]
    };
  }

  ratingWiseIncrementAmountLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN').format(num);
    };

    return {
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.rating),
          name: 'Ratings',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value);
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) => `${item.seriesName}: ${formatNumber(parseFloat(item.value))}`).join('<br/>');
          return tooltipContent;
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      series: [
        {
          name: 'Actual Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.actualAmount))
        },
        {
          name: 'Budget Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.budgetAmount))
        }
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      }
    };
  }

  switchRatingWiseIncrementAmountTableData() {
    this.ratingWiseIncrementAmountIcon = '';
    this.ratingWiseIncrementAmountTable = true;
  }

  downloadRatingWiseIncrementAmountGraph() {
    this.pdfDownload.incrementGraphPDFdownload(
      'ratingWiseIncrementAmountStatusGraph', // chartId
      'ratingWiseIncrementAmountStatusTable', // tableId
      'Rating wise increment amount (budget vs actual)', // Title
      this.selectRatingWiseIncrementAmount ? this.selectRatingWiseIncrementAmount : 'All' // Department
    );

    // var reportType: any;
    // if (this.ratingWiseIncrementAmountTable) {
    //   reportType = 'Table Chart'
    // } else {
    //   if (this.ratingWiseIncrementAmountIcon == 'bar') {
    //     reportType = 'Bar Graph'
    //   }
    //   if (this.ratingWiseIncrementAmountIcon == 'line') {
    //     reportType = 'Line Graph'
    //   }
    // }
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "depts": this.selectRatingWiseIncrementAmount ? [this.selectRatingWiseIncrementAmount] : this.getDepartmentByYearList.map((ele: any) => ele.name),
    //   "fromYear": this.fromYear,
    //   "isHod": this.loggedInUserRole == 'HOD',
    //   "reportName": "RatingwiseIncrementAmount",
    //   "reportType": reportType,
    //   "toYear": this.toYear
    // }
    // this.httpService.callPostService(this.config.IncrementDashboardGraphDownload, request).
    //   subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
  }

  // Band wise budget Vs actuals Graph

  selectedBandWiseBudgetVsActuals() {
    this.bandWiseBudgetVsActualsGraph();
  }

  bandWiseBudgetVsActualsGraph() {
    let request = {};
    let id: any;
    if (this.completeStatusErrorMsg) {
      id = this.loggedInUserCompanyID;
    } else {
      id = null;
    }
    request = {
      companyId: id,
      depts: this.selectBandWiseBudgetVsActuals ? [this.selectBandWiseBudgetVsActuals] : [],
      fromYear: this.incrementFromYear,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      toYear: this.incrementToYear
    };
    this.httpService.callPostService(this.config.getBudgetvsActualForBandsOfDept, request).subscribe((result: any) => {
      if (result.data != null) {
        this.bandWiseBudgetVsActualsData = result.data;
        this.bandWiseBudgetVsActualsGraphType.bar = this.bandWiseBudgetVsActualsBarGraph(this.bandWiseBudgetVsActualsData);
        this.bandWiseBudgetVsActualsGraphType.pie = this.bandWiseBudgetVsActualsPieGraph(this.bandWiseBudgetVsActualsData);
        this.bandWiseBudgetVsActualsGraphType.line = this.bandWiseBudgetVsActualsLineGraph(this.bandWiseBudgetVsActualsData);
        this.switchBandWiseBudgetVsActualsGraphType('bar');
      } else {
        this.bandWiseBudgetVsActualsData = [];
        this.bandWiseBudgetVsActualsGraphType.bar = this.bandWiseBudgetVsActualsBarGraph(this.bandWiseBudgetVsActualsData);
        this.bandWiseBudgetVsActualsGraphType.pie = this.bandWiseBudgetVsActualsPieGraph(this.bandWiseBudgetVsActualsData);
        this.bandWiseBudgetVsActualsGraphType.line = this.bandWiseBudgetVsActualsLineGraph(this.bandWiseBudgetVsActualsData);
        this.switchBandWiseBudgetVsActualsGraphType('bar');
      }
    });
  }

  switchBandWiseBudgetVsActualsGraphType(graphType: any) {
    this.bandWiseBudgetVsActualsIcon = graphType;
    this.bandWiseBudgetVsActualsTable = false;

    const dom = document.getElementById('bandWiseBudgetVsActualsStatusGraph') as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.bandWiseBudgetVsActualsBarGraph(this.bandWiseBudgetVsActualsData);
      }
      if (graphType == 'pie') {
        this.bandWiseBudgetVsActualsPieGraph(this.bandWiseBudgetVsActualsData);
      }
      if (graphType == 'line') {
        this.bandWiseBudgetVsActualsLineGraph(this.bandWiseBudgetVsActualsData);
      }
      if (this.bandWiseBudgetVsActualsGraphType[graphType] && typeof this.bandWiseBudgetVsActualsGraphType[graphType] === 'object') {
        chartEmpTaskStatus.setOption(this.bandWiseBudgetVsActualsGraphType[graphType], true);
      }
    }
  }

  bandWiseBudgetVsActualsBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e7) + ' Cr'
        );
      if (num >= 1e5)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e5) + ' L'
        );
      if (num >= 1e3)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e3) + ' K'
        );
      return new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) => `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`).join('<br/>');
          return tooltipContent;
        }
      },
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.band),
          name: 'Band',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: {
        type: 'value',
        name: 'Budget Amount',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 26
        },
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => parseFloat(ele.budgetAmount)),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4)
          }
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => parseFloat(ele.actualAmount)),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4)
          }
        }
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 }
    };
  }

  bandWiseBudgetVsActualsPieGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return (num / 1e7).toFixed(2) + ' Cr';
      if (num >= 1e5) return (num / 1e5).toFixed(2) + ' L';
      if (num >= 1e3) return (num / 1e3).toFixed(2) + ' K';
      return num.toFixed(2);
    };

    const totalActual = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.actualAmount), 0);
    const totalBudget = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.budgetAmount), 0);

    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item',
        formatter: function (params: any) {
          return `${params.name}: ${formatNumber(params.value)} (${params.percent}%)`;
        }
      },
      legend: {
        data: ['Actual', 'Budget'],
        bottom: 0,
        left: 'center'
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            { value: totalActual, name: 'Actual' },
            { value: totalBudget, name: 'Budget' }
          ]
        }
      ]
    };
  }

  bandWiseBudgetVsActualsLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN').format(num);
    };

    return {
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.band),
          name: 'Band',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value);
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) => `${item.seriesName}: ${formatNumber(parseFloat(item.value))}`).join('<br/>');
          return tooltipContent;
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      series: [
        {
          name: 'Actual Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.actualAmount))
        },
        {
          name: 'Budget Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.budgetAmount))
        }
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      }
    };
  }

  switchBandWiseBudgetVsActualsTableData() {
    this.bandWiseBudgetVsActualsIcon = '';
    this.bandWiseBudgetVsActualsTable = true;
  }

  downloadBandWiseBudgetVsActualsGraph() {
    this.pdfDownload.incrementGraphPDFdownload(
      'bandWiseBudgetVsActualsStatusGraph', // chartId
      'bandWiseBudgetVsActualsStatusTable', // tableId
      'Band wise budget Vs actuals', // Title
      this.selectBandWiseBudgetVsActuals ? this.selectBandWiseBudgetVsActuals : 'All' // Department
    );
    // var reportType: any;
    // if (this.bandWiseBudgetVsActualsTable) {
    //   reportType = 'Table Chart'
    // } else {
    //   if (this.bandWiseBudgetVsActualsIcon == 'bar') {
    //     reportType = 'Bar Graph'
    //   }
    //   if (this.bandWiseBudgetVsActualsIcon == 'line') {
    //     reportType = 'Line Graph'
    //   }
    // }
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "depts": this.selectBandWiseBudgetVsActuals ? [this.selectBandWiseBudgetVsActuals] : this.getDepartmentByYearList.map((ele: any) => ele.name),
    //   "fromYear": this.fromYear,
    //   "isHod": this.loggedInUserRole == 'HOD',
    //   "reportName": "BandwiseBudgetVsActuals",
    //   "reportType": reportType,
    //   "toYear": this.toYear
    // }
    // this.httpService.callPostService(this.config.IncrementDashboardGraphDownload, request).
    //   subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
  }
  // Rating vs Employee count Graph

  selectedratingVsEmpCount() {
    this.ratingVsEmpCountGraph();
  }

  ratingVsEmpCountGraph() {
    let request = {};
    let id: any;
    if (this.completeStatusErrorMsg) {
      id = this.loggedInUserCompanyID;
    } else {
      id = null;
    }
    request = {
      companyId: id,
      depts: this.selectratingVsEmpCount ? [this.selectratingVsEmpCount] : [],
      fromYear: this.incrementFromYear,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      toYear: this.incrementToYear
    };
    this.httpService.callPostService(this.config.getRatingVsWmployeeCount, request).subscribe((result: any) => {
      if (result.data != null) {
        this.ratingVsEmpCountData = result.data;
        this.ratingVsEmpCountGraphType.bar = this.ratingVsEmpCountBarGraph(this.ratingVsEmpCountData);
        this.ratingVsEmpCountGraphType.pie = this.ratingVsEmpCountPieGraph(this.ratingVsEmpCountData);
        this.ratingVsEmpCountGraphType.line = this.ratingVsEmpCountLineGraph(this.ratingVsEmpCountData);
        this.switchRatingVsEmpCountGraphType('bar');
      } else {
        this.ratingVsEmpCountData = [];
        this.ratingVsEmpCountGraphType.bar = this.ratingVsEmpCountBarGraph(this.ratingVsEmpCountData);
        this.ratingVsEmpCountGraphType.pie = this.ratingVsEmpCountPieGraph(this.ratingVsEmpCountData);
        this.ratingVsEmpCountGraphType.line = this.ratingVsEmpCountLineGraph(this.ratingVsEmpCountData);
        this.switchRatingVsEmpCountGraphType('bar');
      }
    });
  }

  switchRatingVsEmpCountGraphType(graphType: any) {
    this.ratingVsEmpCountIcon = graphType;
    this.ratingVsEmpCountTable = false;

    const dom = document.getElementById('ratingvsEmployeeCountStatusGraph') as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.ratingVsEmpCountBarGraph(this.ratingVsEmpCountData);
      }
      if (graphType == 'pie') {
        this.ratingVsEmpCountPieGraph(this.ratingVsEmpCountData);
      }
      if (graphType == 'line') {
        this.ratingVsEmpCountLineGraph(this.ratingVsEmpCountData);
      }
      if (this.ratingVsEmpCountGraphType[graphType] && typeof this.ratingVsEmpCountGraphType[graphType] === 'object') {
        chartEmpTaskStatus.setOption(this.ratingVsEmpCountGraphType[graphType], true);
      }
    }
  }

  ratingVsEmpCountBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e7) + ' Cr'
        );
      if (num >= 1e5)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e5) + ' L'
        );
      if (num >= 1e3)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e3) + ' K'
        );
      return new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) => `${item.seriesName}: ${formatNumber(parseFloat(item.value), 0)}`).join('<br/>');
          return tooltipContent;
        }
      },
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.rating),
          name: 'Ratings',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: {
        type: 'value',
        name: 'Count',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 26
        },
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      series: [
        {
          name: 'Count',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.employeeCount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 0)
          }
        }
      ],
      grid: {
        top: '15%',
        left: '8%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 }
    };
  }

  ratingVsEmpCountPieGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return (num / 1e7).toFixed(2) + ' Cr';
      if (num >= 1e5) return (num / 1e5).toFixed(2) + ' L';
      if (num >= 1e3) return (num / 1e3).toFixed(2) + ' K';
      return num.toFixed(2);
    };
    const pieChartData = data.map((ele: any) => ({
      value: ele.employeeCount,
      name: ele.rating
    }));

    return {
      tooltip: {
        trigger: 'item',
        formatter: (params: any) => {
          return `${params.name}: ${formatNumber(params.value)} (${params.percent}%)`;
        }
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      series: [
        {
          name: 'Employee Count by Rating',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: pieChartData
        }
      ]
    };
  }

  ratingVsEmpCountLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN').format(num);
    };

    return {
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.rating),
          name: 'Ratings',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false }
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let result = '';
          params.forEach((item: any) => {
            result += `${item.seriesName}: ${formatNumber(item.data)}<br/>`;
          });
          return result;
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      series: [
        {
          name: 'Count',
          type: 'line',
          data: data.map((ele: any) => ele.employeeCount)
        }
      ],
      grid: {
        top: '15%',
        left: '8%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      }
    };
  }

  switchRatingVsEmpCountTable() {
    this.ratingVsEmpCountIcon = '';
    this.ratingVsEmpCountTable = true;
  }

  OnClickDownloadRatingVsEmpCountGraph() {
    this.pdfDownload.incrementGraphPDFdownload(
      'ratingvsEmployeeCountStatusGraph', // chartId
      'ratingvsEmployeeCountStatusTable', // tableId
      'Rating vs Employee count', // Title
      this.selectratingVsEmpCount ? this.selectratingVsEmpCount : 'All' // Department
    );
    // var reportType: any;
    // if (this.ratingVsEmpCountTable) {
    //   reportType = 'Table Chart'
    // } else {
    //   if (this.ratingVsEmpCountIcon == 'bar') {
    //     reportType = 'Bar Graph'
    //   }
    //   if (this.ratingVsEmpCountIcon == 'pie') {
    //     reportType = 'Donut Graph'
    //   }
    //   if (this.ratingVsEmpCountIcon == 'line') {
    //     reportType = 'Line Graph'
    //   }
    // }
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "depts": this.selectratingVsEmpCount ? [this.selectratingVsEmpCount] : this.getDepartmentByYearList.map((ele: any) => ele.name),
    //   "fromYear": this.fromYear,
    //   "isHod": this.loggedInUserRole == 'HOD',
    //   "reportName": "RatingvsEmployeecount",
    //   "reportType": reportType,
    //   "toYear": this.toYear
    // }
    // this.httpService.callPostService(this.config.IncrementDashboardGraphDownload, request).
    //   subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
  }

  // Year vs Budget & Actual Amount Graph

  selectedYearVsBudgetAndActualAmount() {
    this.yearVsBudgetAndActualAmountGraph();
  }

  yearVsBudgetAndActualAmountGraph() {
    let request = {};
    let id: any;
    if (this.completeStatusErrorMsg) {
      id = this.loggedInUserCompanyID;
    } else {
      id = null;
    }
    request = {
      companyId: id,
      depts: this.selectYearVsBudgetAndActualAmount ? [this.selectYearVsBudgetAndActualAmount] : [],
      fromYear: this.incrementFromYear,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      toYear: this.incrementToYear
    };
    this.httpService.callPostService(this.config.getBudgetvsActualForThreeYears, request).subscribe((result: any) => {
      if (result.data != null) {
        this.yearVsBudgetAndActualAmountData = result.data.map((ele: any) => ({
          actualAmount: ele.actualAmount,
          budgetAmount: ele.budgetAmount,
          year: `${ele.fromYear}-${ele.toYear}`
        }));
        this.yearVsBudgetAndActualAmountGraphType.bar = this.yearVsBudgetAndActualAmountBarGraph(this.yearVsBudgetAndActualAmountData);
        this.yearVsBudgetAndActualAmountGraphType.pie = this.yearVsBudgetAndActualAmountPieGraph(this.yearVsBudgetAndActualAmountData);
        this.yearVsBudgetAndActualAmountGraphType.line = this.yearVsBudgetAndActualAmountLineGraph(this.yearVsBudgetAndActualAmountData);
        this.switchYearVsBudgetAndActualAmountGraphType('bar');
      } else {
        this.yearVsBudgetAndActualAmountData = [];
        this.yearVsBudgetAndActualAmountGraphType.bar = this.yearVsBudgetAndActualAmountBarGraph(this.yearVsBudgetAndActualAmountData);
        this.yearVsBudgetAndActualAmountGraphType.pie = this.yearVsBudgetAndActualAmountPieGraph(this.yearVsBudgetAndActualAmountData);
        this.yearVsBudgetAndActualAmountGraphType.line = this.yearVsBudgetAndActualAmountLineGraph(this.yearVsBudgetAndActualAmountData);
        this.switchYearVsBudgetAndActualAmountGraphType('bar');
      }
    });
  }

  switchYearVsBudgetAndActualAmountGraphType(graphType: any) {
    this.yearVsBudgetAndActualAmountIcon = graphType;
    this.yearVsBudgetAndActualAmountTable = false;

    const dom = document.getElementById('yearVsBudgetandActualAmountStatusGraph') as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.yearVsBudgetAndActualAmountBarGraph(this.yearVsBudgetAndActualAmountData);
      }
      if (graphType == 'pie') {
        this.yearVsBudgetAndActualAmountPieGraph(this.yearVsBudgetAndActualAmountData);
      }
      if (graphType == 'line') {
        this.yearVsBudgetAndActualAmountLineGraph(this.yearVsBudgetAndActualAmountData);
      }
      if (this.yearVsBudgetAndActualAmountGraphType[graphType] && typeof this.yearVsBudgetAndActualAmountGraphType[graphType] === 'object') {
        chartEmpTaskStatus.setOption(this.yearVsBudgetAndActualAmountGraphType[graphType], true);
      }
    }
  }

  yearVsBudgetAndActualAmountBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e7) + ' Cr'
        );
      if (num >= 1e5)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e5) + ' L'
        );
      if (num >= 1e3)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e3) + ' K'
        );
      return new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(num);
    };

    const formatYear = (year: string) => {
      const [startYear, endYear] = year.split('-');
      return endYear && startYear !== endYear ? `${startYear}-${endYear.slice(-2)}` : startYear;
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) => `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`).join('<br/>');
          return tooltipContent;
        }
      },
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => formatYear(ele.year)),
          name: 'Year',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: {
        type: 'value',
        name: 'Budget & Actual Amount',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 26
        },
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.budgetAmount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4)
          }
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.actualAmount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 4)
          }
        }
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 }
    };
  }

  yearVsBudgetAndActualAmountPieGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return (num / 1e7).toFixed(2) + ' Cr';
      if (num >= 1e5) return (num / 1e5).toFixed(2) + ' L';
      if (num >= 1e3) return (num / 1e3).toFixed(2) + ' K';
      return num.toFixed(2);
    };

    const totalActual = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.actualAmount), 0);
    const totalBudget = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.budgetAmount), 0);

    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item',
        formatter: function (params: any) {
          return `${params.name}: ${formatNumber(params.value)} (${params.percent}%)`;
        }
      },
      legend: {
        data: ['Actual', 'Budget'],
        bottom: 0,
        left: 'center'
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            { value: totalActual, name: 'Actual' },
            { value: totalBudget, name: 'Budget' }
          ]
        }
      ]
    };
  }

  yearVsBudgetAndActualAmountLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN').format(num);
    };
    const formatYear = (year: string) => {
      const [startYear, endYear] = year.split('-');
      return endYear && startYear !== endYear ? `${startYear}-${endYear.slice(-2)}` : startYear;
    };
    return {
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => formatYear(ele.year)),
          name: 'Year',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value);
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) => `${item.seriesName}: ${formatNumber(parseFloat(item.value))}`).join('<br/>');
          return tooltipContent;
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      series: [
        {
          name: 'Actual Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.actualAmount))
        },
        {
          name: 'Budget Amount',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.budgetAmount))
        }
      ],
      grid: {
        top: '15%',
        left: '6%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      }
    };
  }

  switchYearVsBudgetAndActualAmountTable() {
    this.yearVsBudgetAndActualAmountIcon = '';
    this.yearVsBudgetAndActualAmountTable = true;
  }

  downloadYearVsBudgetAndActualAmountGraph() {
    this.pdfDownload.incrementGraphPDFdownload(
      'yearVsBudgetandActualAmountStatusGraph', // chartId
      'yearVsBudgetandActualAmountStatusTable', // tableId
      'Year vs Budget & Actual Amount', // Title
      this.selectYearVsBudgetAndActualAmount ? this.selectYearVsBudgetAndActualAmount : 'All' // Department
    );
    // var reportType: any;
    // if (this.yearVsBudgetAndActualAmountTable) {
    //   reportType = 'Table Chart'
    // } else {
    //   if (this.yearVsBudgetAndActualAmountIcon == 'bar') {
    //     reportType = 'Bar Graph'
    //   }
    //   if (this.yearVsBudgetAndActualAmountIcon == 'line') {
    //     reportType = 'Line Graph'
    //   }
    // }
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "depts": this.selectYearVsBudgetAndActualAmount ? [this.selectYearVsBudgetAndActualAmount] : this.getDepartmentByYearList.map((ele: any) => ele.name),
    //   "fromYear": this.fromYear,
    //   "isHod": this.loggedInUserRole == 'HOD',
    //   "reportName": "YearvsBudgetActualAmount",
    //   "reportType": reportType,
    //   "toYear": this.toYear
    // }
    // this.httpService.callPostService(this.config.IncrementDashboardGraphDownload, request).
    //   subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
  }

  // Dept wise Eligible and not eligible employee count Graph

  onSelectselectedDeptWiseEligibleAndNonEligibleEmpCount() {
    if (this.selectDeptWiseEligibleAndNonEligibleEmp.length > 0) {
      this.deptWiseEligibleAndNonEligibleEmpCountGraph();
    }
  }

  onDeSelectselectedDeptWiseEligibleAndNonEligibleEmpCount() {
    this.deptWiseEligibleAndNonEligibleEmpCountGraph();
  }

  selectAllselectedDeptWiseEligibleAndNonEligibleEmpCount(data: any) {
    this.selectDeptWiseEligibleAndNonEligibleEmp = data;
    this.onSelectselectedDeptWiseEligibleAndNonEligibleEmpCount();
  }
  onDeSelectAllselectedDeptWiseEligibleAndNonEligibleEmpCount() {
    this.selectDeptWiseEligibleAndNonEligibleEmp = [];
    this.deptWiseEligibleAndNonEligibleEmpCountGraph();
  }

  deptWiseEligibleAndNonEligibleEmpCountGraph() {
    let request = {};
    let id: any;
    if (this.completeStatusErrorMsg) {
      id = this.loggedInUserCompanyID;
    } else {
      id = null;
    }
    request = {
      companyId: id,
      depts: this.selectDeptWiseEligibleAndNonEligibleEmp ? this.selectDeptWiseEligibleAndNonEligibleEmp.map((ele: any) => ele.name) : [],
      fromYear: this.incrementFromYear,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      toYear: this.incrementToYear
    };

    this.httpService.callPostService(this.config.getDeptwiseWligibleVsNonEligibleCount, request).subscribe((result: any) => {
      if (result.data != null) {
        this.deptWiseEligibleAndNonEligibleEmpCountData = result.data;
        this.deptWiseEligibleAndNonEligibleEmpCountGraphType.bar = this.deptWiseEligibleAndNonEligibleEmpCountBarGraph(this.deptWiseEligibleAndNonEligibleEmpCountData);
        this.deptWiseEligibleAndNonEligibleEmpCountGraphType.pie = this.deptWiseEligibleAndNonEligibleEmpCounttPieGraph(this.deptWiseEligibleAndNonEligibleEmpCountData);
        this.deptWiseEligibleAndNonEligibleEmpCountGraphType.line = this.deptWiseEligibleAndNonEligibleEmpCountLineGraph(this.deptWiseEligibleAndNonEligibleEmpCountData);
        this.switchDeptWiseEligibleAndNonEligibleEmpCountGraphType('bar');
      } else {
        this.deptWiseEligibleAndNonEligibleEmpCountData = [];
        this.deptWiseEligibleAndNonEligibleEmpCountGraphType.bar = this.deptWiseEligibleAndNonEligibleEmpCountBarGraph(this.deptWiseEligibleAndNonEligibleEmpCountData);
        this.deptWiseEligibleAndNonEligibleEmpCountGraphType.pie = this.deptWiseEligibleAndNonEligibleEmpCounttPieGraph(this.deptWiseEligibleAndNonEligibleEmpCountData);
        this.deptWiseEligibleAndNonEligibleEmpCountGraphType.line = this.deptWiseEligibleAndNonEligibleEmpCountLineGraph(this.deptWiseEligibleAndNonEligibleEmpCountData);
        this.switchDeptWiseEligibleAndNonEligibleEmpCountGraphType('bar');
      }
    });
  }

  switchDeptWiseEligibleAndNonEligibleEmpCountGraphType(graphType: any) {
    this.deptWiseEligibleAndNonEligibleEmpCountIcon = graphType;
    this.deptWiseEligibleAndNonEligibleEmpCountTable = false;

    const dom = document.getElementById('deptWiseEligibleAndNonEligibleEmpCountStatusGraph') as HTMLDivElement;
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.deptWiseEligibleAndNonEligibleEmpCountBarGraph(this.deptWiseEligibleAndNonEligibleEmpCountData);
      }
      if (graphType == 'pie') {
        this.deptWiseEligibleAndNonEligibleEmpCounttPieGraph(this.deptWiseEligibleAndNonEligibleEmpCountData);
      }
      if (graphType == 'line') {
        this.deptWiseEligibleAndNonEligibleEmpCountLineGraph(this.deptWiseEligibleAndNonEligibleEmpCountData);
      }
      if (this.deptWiseEligibleAndNonEligibleEmpCountGraphType[graphType] && typeof this.deptWiseEligibleAndNonEligibleEmpCountGraphType[graphType] === 'object') {
        chartEmpTaskStatus.setOption(this.deptWiseEligibleAndNonEligibleEmpCountGraphType[graphType], true);
      }
    }
  }

  deptWiseEligibleAndNonEligibleEmpCountBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e7) + ' Cr'
        );
      if (num >= 1e5)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e5) + ' L'
        );
      if (num >= 1e3)
        return (
          new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
          }).format(num / 1e3) + ' K'
        );
      return new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let tooltipContent = params.map((item: any) => `${item.seriesName}: ${formatNumber(parseFloat(item.value), 0)}`).join('<br/>');
          return tooltipContent;
        }
      },
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.department),
          name: 'Department',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: {
        type: 'value',
        name: 'Budget Amount',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 24
        },
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      series: [
        {
          name: 'Eligible',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.eligibleCount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 0)
          }
        },
        {
          name: 'Non Eligible',
          type: 'bar',
          barWidth: '20%',
          barGap: '15%',
          data: data.map((ele: any) => ele.nonEligibleCount),
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: '#000',
            formatter: (params: any) => formatNumber(params.value, 0)
          }
        }
      ],
      grid: {
        top: '15%',
        left: '8%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      },
      toolbox: {
        show: true,
        iconStyle: { borderColor: '#F3820E' }
      },
      legend: { bottom: 10 }
    };
  }

  deptWiseEligibleAndNonEligibleEmpCounttPieGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN').format(num);
    };

    const eligibleCount = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.eligibleCount), 0);
    const nonEligibleCount = data.reduce((sum: number, ele: any) => sum + parseFloat(ele.nonEligibleCount), 0);

    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item',
        formatter: function (params: any) {
          return `${params.name}: ${formatNumber(params.value)} (${params.percent}%)`;
        }
      },
      legend: {
        data: ['Actual', 'Budget'],
        bottom: 0,
        left: 'center'
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            { value: eligibleCount, name: 'Eligible' },
            { value: nonEligibleCount, name: 'Non Eligible' }
          ]
        }
      ]
    };
  }

  deptWiseEligibleAndNonEligibleEmpCountLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN').format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN').format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN').format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN').format(num);
    };
    return {
      xAxis: [
        {
          type: 'category',
          data: data.map((ele: any) => ele.department),
          name: 'Department',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6
          },
          axisTick: {
            alignWithLabel: true
          }
        }
      ],
      yAxis: {
        show: true,
        type: 'value',
        splitLine: { show: false }
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params: any) {
          let result = '';
          params.forEach((item: any) => {
            result += `${item.seriesName}: ${formatNumber(item.data)}<br/>`;
          });
          return result;
        }
      },
      dataZoom: [
        {
          type: 'slider',
          start: 0,
          end: 100,
          handleSize: '100%',
          showDetail: false,
          xAxisIndex: [0]
        }
      ],
      series: [
        {
          name: 'Eligible',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.eligibleCount || 0))
        },
        {
          name: 'Non Eligible',
          type: 'line',
          data: data.map((ele: any) => parseFloat(ele.nonEligibleCount || 0))
        }
      ],
      grid: {
        top: '15%',
        left: '8%',
        right: '0%',
        bottom: '15%',
        containLabel: true
      }
    };
  }

  switchDeptWiseEligibleAndNonEligibleEmpCountTable() {
    this.deptWiseEligibleAndNonEligibleEmpCountIcon = '';
    this.deptWiseEligibleAndNonEligibleEmpCountTable = true;
  }

  downloadDeptWiseEligibleEmpCoungGraph() {
    this.pdfDownload.incrementGraphPDFdownload(
      'deptWiseEligibleAndNonEligibleEmpCountStatusGraph', // chartId
      'deptWiseEligibleAndNonEligibleEmpCountStatusTable', // tableId
      'Dept wise Eligible and not eligible employee count', // Title
      this.selectDeptWiseEligibleAndNonEligibleEmp && this.selectDeptWiseEligibleAndNonEligibleEmp.length > 0 ? this.selectDeptWiseEligibleAndNonEligibleEmp.map((ele: any) => ele.name) : 'All'
    );
    // var reportType: any;
    // if (this.deptWiseEligibleAndNonEligibleEmpCountTable) {
    //   reportType = 'Table Chart'
    // } else {
    //   if (this.deptWiseEligibleAndNonEligibleEmpCountIcon == 'bar') {
    //     reportType = 'Bar Graph'
    //   }
    //   if (this.deptWiseEligibleAndNonEligibleEmpCountIcon == 'line') {
    //     reportType = 'Line Graph'
    //   }
    // }
    // const selectedDepartments = (this.selectDeptWiseEligibleAndNonEligibleEmp && this.selectDeptWiseEligibleAndNonEligibleEmp.length > 0)
    //   ? this.selectDeptWiseEligibleAndNonEligibleEmp.map((ele: any) => ele.name)
    //   : this.getDepartmentByYearList.map((ele: any) => ele.name);
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "depts": selectedDepartments,
    //   "fromYear": this.fromYear,
    //   "isHod": this.loggedInUserRole == 'HOD',
    //   "reportName": "DeptwiseEligibleAndNotEligibleEmployeeCount",
    //   "reportType": reportType,
    //   "toYear": this.toYear
    // }
    // this.httpService.callPostService(this.config.IncrementDashboardGraphDownload, request).
    //   subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
  }
  // end

  // Increment Input

  onClickIncrementIntputActiveTab(data: any) {
    this.activeIncrementInputTab = data;
    if (this.activeIncrementInputTab === true) {
      this.checkIncrementDepartment = true;
    } else if (this.activeIncrementInputTab === false) {
      this.checkIncrementDepartment = false;
    }
    this.getDepartmentByYear();
    this.selectedIncrementInputDept = '';
    this.selectedIncrementInputBand = '';
    this.selectedIncrementInputManager = '';
    this.selectedIncrementInputEmp = '';
    this.checkStatusForIncrementSetup();
  }

  // select department

  onSelectIncrementInputDept() {
    if (this.selectedIncrementInputDept.length > 0) {
      this.getBandList = [];
      this.selectedIncrementInputBand = '';
      this.selectedIncrementInputManager = '';
      this.selectedIncrementInputEmp = '';
      this.getBandListByDepartment();
      this.getIncrementInputCount();
      if (this.activeIncrementInputTab) {
        this.getIncrementInputisEligibleTableData();
      } else {
        this.getIncrementInputisNonEligibleTableData();
      }
    } else {
      this.getBandList = [];
      this.selectedIncrementInputBand = '';
      this.selectedIncrementInputManager = '';
      this.selectedIncrementInputEmp = '';
    }
  }

  onDeSelectIncrementInputDept() {
    this.getBandList = [];
    this.getEmployeeList = [];
    this.getManagerList = [];
    this.selectedIncrementInputBand = '';
    this.selectedIncrementInputManager = '';
    this.selectedIncrementInputEmp = '';
    this.getBandListByDepartment();
    this.getIncrementInputCount();
    if (this.activeIncrementInputTab) {
      this.getIncrementInputisEligibleTableData();
    } else {
      this.getIncrementInputisNonEligibleTableData();
    }
  }

  selectAllIncrementInputDept(items: any): void {
    this.selectedIncrementInputDept = items;
    this.onSelectIncrementInputDept();
    this.selectedIncrementInputBand = '';
    this.selectedIncrementInputManager = '';
    this.selectedIncrementInputEmp = '';
  }

  onDeSelectAllIncrementInputDept() {
    this.selectedIncrementInputDept = [];
    this.getBandList = [];
    this.getEmployeeList = [];
    this.getManagerList = [];
    this.selectedIncrementInputBand = '';
    this.selectedIncrementInputManager = '';
    this.selectedIncrementInputEmp = '';
    this.getIncrementInputCount();
    if (this.activeIncrementInputTab) {
      this.getIncrementInputisEligibleTableData();
    } else {
      this.getIncrementInputisNonEligibleTableData();
    }
  }

  // Select Band

  getBandListByDepartment() {
    const request: any = {
      fromYear: this.incrementFromYear,
      toYear: this.incrementToYear,
      companyId: this.loggedInUserCompanyID,
      department: this.selectedIncrementInputDept.map((dept: any) => dept.name),
      isEligible: this.checkIncrementDepartment
    };
    this.httpService.callPostService(this.config.getBandListByDepartment, request).subscribe((result: any) => {
      if (result.data) {
        this.getBandList = result.data
          .map((ele: any) => ({
            id: ele,
            name: ele
          }))
          .sort((a: any, b: any) => a.name.localeCompare(b.name));
      }
    });
  }

  onSelectdIncrementInputBand() {
    if (this.selectedIncrementInputBand.length > 0) {
      this.getManagerList = [];
      this.selectedIncrementInputManager = '';
      this.selectedIncrementInputEmp = '';
      this.getManagerListByBand();
      this.getIncrementInputCount();
      if (this.activeIncrementInputTab) {
        this.getIncrementInputisEligibleTableData();
      } else {
        this.getIncrementInputisNonEligibleTableData();
      }
    } else {
      this.getManagerList = [];
      this.selectedIncrementInputManager = '';
      this.selectedIncrementInputEmp = '';
    }
  }

  onDeSelectdIncrementInputBand() {
    this.getManagerList = [];
    this.getEmployeeList = [];
    this.selectedIncrementInputManager = '';
    this.selectedIncrementInputEmp = '';
    this.getIncrementInputCount();
    if (this.activeIncrementInputTab) {
      this.getIncrementInputisEligibleTableData();
    } else {
      this.getIncrementInputisNonEligibleTableData();
    }
  }

  selectAllIncrementInputBand(items: any): void {
    this.selectedIncrementInputBand = items;
    this.selectedIncrementInputManager = '';
    this.selectedIncrementInputEmp = '';
    this.onSelectdIncrementInputBand();
  }

  onDeSelectAllIncrementInputBand() {
    this.selectedIncrementInputBand = [];
    this.getManagerList = [];
    this.selectedIncrementInputManager = '';
    this.selectedIncrementInputEmp = '';
    this.getEmployeeList = [];
    this.getIncrementInputCount();
    if (this.activeIncrementInputTab) {
      this.getIncrementInputisEligibleTableData();
    } else {
      this.getIncrementInputisNonEligibleTableData();
    }
  }

  // select Manager

  getManagerListByBand() {
    const request: any = {
      bands: this.selectedIncrementInputBand.map((band: any) => band.name),
      companyId: this.loggedInUserCompanyID,
      department: this.selectedIncrementInputDept.map((dept: any) => dept.name),
      fromYear: this.incrementFromYear,
      toYear: this.incrementToYear,
      isEligible: this.checkIncrementDepartment
    };
    this.httpService.callPostService(this.config.getManagerListByBand, request).subscribe((result: any) => {
      if (result.data) {
        this.getManagerList = result.data
          .map((ele: any) => ({
            name: ele.name,
            id: ele.id,
            managerId: ele.employeeId
          }))
          .sort((a: any, b: any) => a.name.localeCompare(b.name));
      }
    });
  }

  onSelectIncrementInputdManager() {
    if (this.selectedIncrementInputManager.length > 0) {
      this.getEmployeeList = [];
      this.selectedIncrementInputEmp = '';
      this.getEmployeeListByManager();
      this.getIncrementInputCount();
      if (this.activeIncrementInputTab) {
        this.getIncrementInputisEligibleTableData();
      } else {
        this.getIncrementInputisNonEligibleTableData();
      }
    } else {
      this.getEmployeeList = [];
      this.selectedIncrementInputEmp = '';
    }
  }

  onDeSelectdIncrementInputdManager() {
    this.getEmployeeList = [];
    this.selectedIncrementInputEmp = '';
    this.getIncrementInputCount();
    if (this.activeIncrementInputTab) {
      this.getIncrementInputisEligibleTableData();
    } else {
      this.getIncrementInputisNonEligibleTableData();
    }
  }

  selectAllIncrementInputdManager(items: any): void {
    this.selectedIncrementInputManager = items;
    this.selectedIncrementInputEmp = '';
    this.onSelectIncrementInputdManager();
  }

  onDeSelectAllIncrementInputdManager() {
    this.selectedIncrementInputManager = [];
    this.getEmployeeList = [];
    this.selectedIncrementInputEmp = '';
    this.getIncrementInputCount();
    if (this.activeIncrementInputTab) {
      this.getIncrementInputisEligibleTableData();
    } else {
      this.getIncrementInputisNonEligibleTableData();
    }
  }
  exitedUser: any;
  getAllUser() {
    const request = {
      search: null,
      userType: null,
      status: 0,
      companyId: this.loggedInUserCompanyID,
      loggedInUserRole: this.loggedInUserRole
    };
    this.loader.simpleLoaderWithDuration();
    this.httpService.callPostService(this.config.searchEmployeeMaster + '?page=' + 0 + '&size=' + 1000, request).subscribe(
      (data: any) => {
        this.loader.dismissLoader();
        console.log(data?.data?.users);
        this.exitedUser = data?.data?.users;
      },
      (error: any) => {
        this.loader.dismissLoader();
      },
      () => {}
    );
  }
  // select Employee

  getEmployeeListByManager() {
    const request = {
      bands: this.selectedIncrementInputBand.map((band: any) => band.name),
      companyId: this.loggedInUserCompanyID,
      department: this.selectedIncrementInputDept.map((dept: any) => dept.name),
      fromYear: this.incrementFromYear,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      toYear: this.incrementToYear,
      userId: this.selectedIncrementInputManager.map((ele: any) => ele.id),
      isEligible: this.checkIncrementDepartment
    };
    this.httpService.callPostService(this.config.getEmployeesListByManager, request).subscribe((result: any) => {
      let findExitedUserId = this.exitedUser.map((elm: any) => elm.id);

      if (result.data) {
        this.getEmployeeList = result.data
          .map((ele: any) => ({
            name: ele.name,
            id: ele.id
          }))
          .sort((a: any, b: any) => a.name.localeCompare(b.name))
          .filter((e: any) => !findExitedUserId.includes(e.id));
      }
    });
  }

  onSelectdIncrementInputEmp() {
    if (this.selectedIncrementInputEmp.length > 0) {
      this.getIncrementInputCount();
      if (this.activeIncrementInputTab) {
        this.getIncrementInputisEligibleTableData();
      } else {
        this.getIncrementInputisNonEligibleTableData();
      }
    }
  }

  onDeSelectdIncrementInputEmp() {
    this.getIncrementInputCount();
    if (this.activeIncrementInputTab) {
      this.getIncrementInputisEligibleTableData();
    } else {
      this.getIncrementInputisNonEligibleTableData();
    }
  }

  selectAllIncrementInputEmp(items: any) {
    this.selectedIncrementInputEmp = items;
    this.onSelectdIncrementInputEmp();
  }

  onDeSelectAllIncrementInputEmp() {
    this.selectedIncrementInputEmp = [];
    this.getIncrementInputEligibleTableData = [];
    this.getIncrementInputNonEligibleTableData = [];
    this.getIncrementInputCount();
    if (this.activeIncrementInputTab) {
      this.getIncrementInputisEligibleTableData();
    } else {
      this.getIncrementInputisNonEligibleTableData();
    }
  }

  countEligibleEmployees(departmentList: any[]): number {
    return departmentList.reduce((total, department) => {
      return (
        total +
        department.bandGrades.reduce((bandTotal: any, bandGrade: any) => {
          return bandTotal + bandGrade.employeeData.filter((employee: any) => employee.isEligible).length;
        }, 0)
      );
    }, 0);
  }

  countNonEligibleEmployees(departmentList: any[]): number {
    return departmentList.reduce((total, department) => {
      return (
        total +
        department.bandGrades.reduce((bandTotal: any, bandGrade: any) => {
          return bandTotal + bandGrade.employeeData.filter((employee: any) => !employee.isEligible).length;
        }, 0)
      );
    }, 0);
  }

  getIncrementInputTableHideShowAllData() {
    if (this.onSelectIncrementTotalCTC == 'Fixed Annual CTC') {
      this.incrementCtcPerMonth = 'Fixed CTC p.m.';
      this.incrementCtcPerYear = 'Fixed CTC p.a.';
    } else {
      this.incrementCtcPerMonth = 'Total CTC p.m.';
      this.incrementCtcPerYear = 'Total CTC p.a.';
    }

    this.IncrementInputTableHideShowAllData = [
      {
        fieldId: 1,
        isVisible: true,
        fieldName: 'Department',
        position: 1,
        isEditable: true
      },
      {
        fieldId: 2,
        isVisible: true,
        fieldName: 'Band',
        position: 2,
        isEditable: true
      },
      {
        fieldId: 3,
        isVisible: true,
        fieldName: 'Employee',
        position: 3,
        isEditable: true
      },
      {
        fieldId: 4,
        isVisible: true,
        fieldName: 'Manager',
        position: 4,
        isEditable: true
      },
      {
        fieldId: 5,
        isVisible: true,
        fieldName: 'HOD',
        position: 5,
        isEditable: true
      },
      {
        fieldId: 6,
        isVisible: true,
        fieldName: 'Designation',
        position: 6,
        isEditable: true
      },
      {
        fieldId: 7,
        isVisible: true,
        fieldName: 'DOJ',
        position: 7,
        isEditable: true
      },
      {
        fieldId: 8,
        isVisible: true,
        fieldName: this.incrementCtcPerMonth,
        position: 8,
        isEditable: true
      },
      {
        fieldId: 9,
        isVisible: true,
        fieldName: this.incrementCtcPerYear,
        position: 9,
        isEditable: true
      },
      {
        fieldId: 10,
        isVisible: true,
        fieldName: 'Eligible Emp.',
        position: 10,
        isEditable: true
      },
      {
        fieldId: 11,
        isVisible: true,
        fieldName: 'Individual KPI + Competency Score',
        position: 11,
        isEditable: true
      },
      {
        fieldId: 12,
        isVisible: true,
        fieldName: 'Department Score (out of 100)',
        position: 12,
        isEditable: true
      },
      {
        fieldId: 13,
        isVisible: true,
        fieldName: 'Company Score (out of 100)',
        position: 13,
        isEditable: true
      },
      {
        fieldId: 14,
        isVisible: true,
        fieldName: 'Final Score',
        position: 14,
        isEditable: true
      },
      {
        fieldId: 15,
        isVisible: true,
        fieldName: 'Final Rating',
        position: 15,
        isEditable: true
      },
      {
        fieldId: 16,
        isVisible: true,
        fieldName: 'Increment %',
        position: 16,
        isEditable: true
      },
      {
        fieldId: 17,
        isVisible: true,
        fieldName: 'Days Served in the Increment Period',
        position: 17,
        isEditable: true
      },
      {
        fieldId: 18,
        isVisible: true,
        fieldName: 'Prorated Increment %',
        position: 18,
        isEditable: true
      },
      {
        fieldId: 19,
        isVisible: true,
        fieldName: 'Increment Amount',
        position: 19,
        isEditable: true
      },
      {
        fieldId: 20,
        isVisible: true,
        fieldName: 'No Promotion Last 3 Year',
        position: 20,
        isEditable: true
      },
      {
        fieldId: 21,
        isVisible: true,
        fieldName: 'Promotion',
        position: 21,
        isEditable: true
      },
      {
        fieldId: 22,
        isVisible: true,
        fieldName: 'Promotion %',
        position: 22,
        isEditable: true
      },
      {
        fieldId: 23,
        isVisible: true,
        fieldName: 'Promotion Amount',
        position: 23,
        isEditable: true
      },
      {
        fieldId: 24,
        isVisible: true,
        fieldName: 'Updated CTC after Increment & Promotion',
        position: 24,
        isEditable: true
      },
      {
        fieldId: 25,
        isVisible: true,
        fieldName: 'Market BenchMark CTC',
        position: 25,
        isEditable: true
      },
      {
        fieldId: 26,
        isVisible: true,
        fieldName: 'Market Correction %',
        position: 26,
        isEditable: true
      },
      {
        fieldId: 27,
        isVisible: true,
        fieldName: 'Market Correction Amount',
        position: 27,
        isEditable: true
      },
      {
        fieldId: 28,
        isVisible: true,
        fieldName: 'Final Increment % p.a',
        position: 28,
        isEditable: true
      },
      {
        fieldId: 29,
        isVisible: true,
        fieldName: `Increment % in ${new Date().getFullYear() - 3}`,
        position: 29,
        isEditable: true
      },
      {
        fieldId: 30,
        isVisible: true,
        fieldName: `Increment % in ${new Date().getFullYear() - 2}`,
        position: 30,
        isEditable: true
      },
      {
        fieldId: 31,
        isVisible: true,
        fieldName: `Increment % in ${new Date().getFullYear() - 1}`,
        position: 31,
        isEditable: true
      },
      {
        fieldId: 32,
        isVisible: true,
        fieldName: 'HOD Approved Increment %',
        position: 32,
        isEditable: true
      },
      {
        fieldId: 33,
        isVisible: true,
        fieldName: 'HR Admin & MD/CEO Approved Increment %',
        position: 33,
        isEditable: true
      },
      {
        fieldId: 34,
        isVisible: true,
        fieldName: 'Final Increment Amount',
        position: 34,
        isEditable: true
      },
      {
        fieldId: 35,
        isVisible: true,
        fieldName: 'Final Annual Revised CTC (post increment)',
        position: 35,
        isEditable: true
      },
      {
        fieldId: 36,
        isVisible: true,
        fieldName: 'Final Monthly Revised CTC (post increment)',
        position: 36,
        isEditable: true
      },
      {
        fieldId: 37,
        isVisible: true,
        fieldName: 'Increment Letter Format',
        position: 37,
        isEditable: true
      }
    ];
  }

  getIncrementColumnName(yearsAgo: number): string {
    return `Increment % in ${new Date().getFullYear() - yearsAgo}`;
  }

  onSelectIncrementInputHideShowCheckBox() {
    this.isAnyColumnInvisible = this.IncrementInputTableHideShowAllData?.some((ele: any) => !ele.isVisible);
    this.allColumnsInvisible = this.IncrementInputTableHideShowAllData?.every((ele: any) => !ele.isVisible);
  }

  onClickShowAllHeader() {
    this.IncrementInputTableHideShowAllData?.forEach((ele: any, ind: any) => {
      this.IncrementInputTableHideShowAllData[ind].isVisible = true;
    });
    this.onSelectIncrementInputHideShowCheckBox();
  }

  updateIncrementInputColumnVisibility(data: any, index: any) {
    this.IncrementInputTableHideShowAllData[index].isVisible = false;
    this.onSelectIncrementInputHideShowCheckBox();
  }

  getIncrementInputColumnVisibility(fieldName: string): boolean {
    const column = this.IncrementInputTableHideShowAllData.find(item => item.fieldName.trim() === fieldName.trim());
    return column ? column.isVisible : false;
  }

  getIncrementInputCount() {
    let request = {};
    if (this.selectedIncrementInputEmp) {
      request = {
        band: this.selectedIncrementInputBand.length > 0 ? this.selectedIncrementInputBand.map((band: any) => band.name) : [],
        companyId: this.loggedInUserCompanyID,
        department: this.selectedIncrementInputDept.length > 0 ? this.selectedIncrementInputDept.map((dept: any) => dept.name) : [],
        employeeId: this.selectedIncrementInputEmp.length > 0 ? this.selectedIncrementInputEmp.map((ele: any) => ele.id) : [],
        fromYear: this.incrementFromYear,
        isEligible: null,
        isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
        manager: this.selectedIncrementInputManager.length > 0 ? this.selectedIncrementInputManager.map((ele: any) => ele.id) : [],
        search: this.searchIncrementInputTableData,
        toYear: this.incrementToYear
      };
    } else {
      request = {
        band: [],
        companyId: this.loggedInUserCompanyID,
        department: [],
        employeeId: [],
        fromYear: this.incrementFromYear,
        isEligible: null,
        isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
        manager: [],
        search: this.searchIncrementInputTableData,
        toYear: this.incrementToYear
      };
    }
    this.httpService.callPostService(this.config.getIncrementInputCount, request).subscribe((result: any) => {
      this.totalEligibleCount = result.data?.eligibleEmps;
      this.totalNonEligibleCount = result.data?.nonEligibleEmps;
    });
  }

  searchIncrementInputTableData: any = null;

  onIncrementInputSearch(data: any) {
    var search = '';
    this.searchIncrementInputTableData = data;
    if (data == '') {
      this.searchIncrementInputTableData = null;
      this.getIncrementInputCount();
      if (this.activeIncrementInputTab) {
        this.getIncrementInputisEligibleTableData();
      } else {
        this.getIncrementInputisNonEligibleTableData();
      }
      return;
    }
    if (data.length > 0) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            this.getIncrementInputCount();
            if (this.activeIncrementInputTab) {
              this.getIncrementInputisEligibleTableData();
            } else {
              this.getIncrementInputisNonEligibleTableData();
            }
          }, 500);
        }
      }, 1500);
    }
  }

  getIncrementInputisEligibleTableData() {
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      if (this.selectedIncrementInputEmp) {
        const request = {
          band: this.selectedIncrementInputBand.length > 0 ? this.selectedIncrementInputBand.map((band: any) => band.name) : [],
          companyId: this.loggedInUserCompanyID,
          department: this.selectedIncrementInputDept.length > 0 ? this.selectedIncrementInputDept.map((dept: any) => dept.name) : [],
          employeeId: this.selectedIncrementInputEmp.length > 0 ? this.selectedIncrementInputEmp.map((ele: any) => ele.id) : [],
          fromYear: this.incrementFromYear,
          isEligible: true,
          isHod: true,
          manager: this.selectedIncrementInputManager.length > 0 ? this.selectedIncrementInputManager.map((ele: any) => ele.id) : [],
          search: this.searchIncrementInputTableData,
          toYear: this.incrementToYear
        };
        this.httpService.callPostService(this.config.getIncrementInput, request).subscribe((result: any) => {
          this.getIncrementInputEligibleTableData = result.data;
          this.buildIncrementColumnDefs();
          this.incrementEligibleRowData = this.buildIncrementRowData(this.getIncrementInputEligibleTableData);
          if (this.gridApiIncrementInputEligible) {
            this.gridApiIncrementInputEligible.setRowData(this.incrementEligibleRowData);
          }
          this.calculateInputEligibleTotals(this.getIncrementInputEligibleTableData);
          // build pinned totals and push to grid
          this.buildPinnedBottomTotalsEligible();
          if (this.gridApiIncrementInputEligible) {
            this.gridApiIncrementInputEligible.sizeColumnsToFit();
          }
          this.loader.dismissLoader();
        });
      } else {
        const request = {
          band: [],
          companyId: this.loggedInUserCompanyID,
          department: [],
          employeeId: [],
          fromYear: this.incrementFromYear,
          isEligible: true,
          isHod: true,
          manager: [],
          search: this.searchIncrementInputTableData,
          toYear: this.incrementToYear
        };
        this.httpService.callPostService(this.config.getIncrementInput, request).subscribe((result: any) => {
          this.getIncrementInputEligibleTableData = result.data;
          this.buildIncrementColumnDefs();
          this.incrementEligibleRowData = this.buildIncrementRowData(this.getIncrementInputEligibleTableData);
          if (this.gridApiIncrementInputEligible) {
            this.gridApiIncrementInputEligible.setRowData(this.incrementEligibleRowData);
          }
          this.calculateInputEligibleTotals(this.getIncrementInputEligibleTableData);
          // build pinned totals and push to grid
          this.buildPinnedBottomTotalsEligible();
          if (this.gridApiIncrementInputEligible) {
            this.gridApiIncrementInputEligible.sizeColumnsToFit();
          }
          this.loader.dismissLoader();
        });
      }
      this.isEditHODApprovedIncrementPct = false;
      this.isEditHRAdminAndMDCEOApprovedIncrementPct = true;
    } else {
      if (this.selectedIncrementInputDept || this.selectedIncrementInputBand || this.selectedIncrementInputEmp || this.selectedIncrementInputManager) {
        const request = {
          band: this.selectedIncrementInputBand.length > 0 ? this.selectedIncrementInputBand.map((band: any) => band.name) : [],
          companyId: this.loggedInUserCompanyID,
          department: this.selectedIncrementInputDept.length > 0 ? this.selectedIncrementInputDept.map((dept: any) => dept.name) : [],
          employeeId: this.selectedIncrementInputEmp.length > 0 ? this.selectedIncrementInputEmp.map((ele: any) => ele.id) : [],
          fromYear: this.incrementFromYear,
          isEligible: true,
          isHod: false,
          manager: this.selectedIncrementInputManager.length > 0 ? this.selectedIncrementInputManager.map((ele: any) => ele.id) : [],
          search: this.searchIncrementInputTableData,
          toYear: this.incrementToYear
        };
        this.httpService.callPostService(this.config.getIncrementInput, request).subscribe((result: any) => {
          this.getIncrementInputEligibleTableData = result.data;
          this.buildIncrementColumnDefs();
          this.incrementEligibleRowData = this.buildIncrementRowData(this.getIncrementInputEligibleTableData);
          if (this.gridApiIncrementInputEligible) {
            this.gridApiIncrementInputEligible.setRowData(this.incrementEligibleRowData);
          }
          this.calculateInputEligibleTotals(this.getIncrementInputEligibleTableData);
          // build pinned totals and push to grid
          this.buildPinnedBottomTotalsEligible();
          if (this.gridApiIncrementInputEligible) {
            this.gridApiIncrementInputEligible.sizeColumnsToFit();
          }
          this.loader.dismissLoader();
        });
      } else {
        const request = {
          band: [],
          companyId: this.loggedInUserCompanyID,
          department: [],
          employeeId: [],
          fromYear: this.incrementFromYear,
          isEligible: true,
          isHod: false,
          manager: [],
          search: this.searchIncrementInputTableData,
          toYear: this.incrementToYear
        };
        this.httpService.callPostService(this.config.getIncrementInput, request).subscribe((result: any) => {
          this.getIncrementInputEligibleTableData = result.data;
          this.buildIncrementColumnDefs();
          this.incrementEligibleRowData = this.buildIncrementRowData(this.getIncrementInputEligibleTableData);
          if (this.gridApiIncrementInputEligible) {
            this.gridApiIncrementInputEligible.setRowData(this.incrementEligibleRowData);
          }
          this.calculateInputEligibleTotals(this.getIncrementInputEligibleTableData);
          // build pinned totals and push to grid
          this.buildPinnedBottomTotalsEligible();
          if (this.gridApiIncrementInputEligible) {
            this.gridApiIncrementInputEligible.sizeColumnsToFit();
          }
          this.loader.dismissLoader();
        });
      }
      this.isEditHODApprovedIncrementPct = true;
      this.isEditHRAdminAndMDCEOApprovedIncrementPct = false;
    }
  }

  trackByDepartment(index: number, item: any) {
    return item.departmentId || index;
  }

  trackByBandGrade(index: number, item: any) {
    return item.band || index;
  }

  trackByEmployee(index: number, item: any) {
    return item.employeeId || index;
  }

  calculateInputEligibleTotals(data: any[]): void {
    this.totalEligibleTotalFixedCtcPM = 0;
    this.totalEligibleTotalFixedCtcPA = 0;
    this.totalEligibleEligibleEmp = 0;
    this.totalEligibleFinalRating = 0;
    this.totalEligibleIncrementPct = 0;
    this.totalEligibleDaysServedinIncrementPeriod = 0;
    this.totalEligibleProratedIncrementPct = 0;
    this.totalEligibleHODIncrementPct = 0;
    this.totalEligibleHrAndMdIncrementPct = 0;
    this.totalEligibleIncrementAmount = 0;
    this.totalEligibleNoOfPromotionPct = 0;
    this.totalEligiblePromotionPct = 0;
    this.totalEligiblePromotionAmount = 0;
    this.totalEligibleupdatedCtcAfterIAndP = 0;
    this.totalEligibleMarketBenchMarkCtc = 0;
    this.totalEligiblemarketCorrectionPct = 0;
    this.totalEligibleMarketCorrectionAmount = 0;
    this.totalEligibleFinalIncrementPct = 0;
    this.totalEligibleFinalIncrementAmount = 0;
    this.totalEligibleFinalAnnualCtc = 0;
    this.totalEligibleFinalMonthlyCtc = 0;

    let totalFinalIncrementPctCount = 0;
    let totalMarketCorrectionPctCount = 0;
    let totalPromotionPctCount = 0;
    let totalHODIncrementPctCount = 0;
    let totalHrAndMdIncrementPctCount = 0;
    let totalIncrementPctCount = 0;
    let totalDaysServedCount = 0;
    let totalProratedIncrementPctCount = 0;

    data?.forEach(department => {
      department.bandGrades.forEach((bandGrade: any) => {
        bandGrade.employeeData.forEach((employee: any) => {
          this.totalEligibleTotalFixedCtcPM += parseFloat(employee.monthlyCtc || 0);
          this.totalEligibleTotalFixedCtcPA += parseFloat(employee.annualCtc || 0);
          this.totalEligibleEligibleEmp += employee.isEligible ? 1 : 0;
          this.totalEligibleFinalRating += parseFloat(employee.finalRating || 0);

          if (employee.incrementPercentage !== null && employee.incrementPercentage !== undefined) {
            this.totalEligibleIncrementPct += parseFloat(employee.incrementPercentage);
            totalIncrementPctCount++;
          }

          if (employee.daysServed !== null && employee.daysServed !== undefined) {
            this.totalEligibleDaysServedinIncrementPeriod += parseFloat(employee.daysServed);
            totalDaysServedCount++;
          }

          if (employee.proratedIncrementPercentage !== null && employee.proratedIncrementPercentage !== undefined) {
            this.totalEligibleProratedIncrementPct += parseFloat(employee.proratedIncrementPercentage);
            totalProratedIncrementPctCount++;
          }

          if (employee.hodIncrementPercentage !== null && employee.hodIncrementPercentage !== undefined) {
            this.totalEligibleHODIncrementPct += parseFloat(employee.hodIncrementPercentage);
            totalHODIncrementPctCount++;
          }

          if (employee.hrAndMdIncrementPercentage !== null && employee.hrAndMdIncrementPercentage !== undefined) {
            this.totalEligibleHrAndMdIncrementPct += parseFloat(employee.hrAndMdIncrementPercentage);
            totalHrAndMdIncrementPctCount++;
          }

          if (employee.promotionPercentage !== null && employee.promotionPercentage !== undefined) {
            this.totalEligiblePromotionPct += parseFloat(employee.promotionPercentage);
            totalPromotionPctCount++;
          }

          this.totalEligibleIncrementAmount += parseFloat(employee.incrementAmount || 0);
          this.totalEligibleNoOfPromotionPct += parseFloat(employee.noOfPromotions || 0);
          this.totalEligiblePromotionAmount += parseFloat(employee.promotionAmount || 0);
          this.totalEligibleupdatedCtcAfterIAndP += parseFloat(employee.updatedCtcAfterIncrementAndPromotion || 0);
          this.totalEligibleMarketBenchMarkCtc += parseFloat(employee.marketBenchMarkCtc || 0);

          if (employee.finalIncrementPercentage !== null && employee.finalIncrementPercentage !== undefined) {
            this.totalEligibleFinalIncrementPct += parseFloat(employee.finalIncrementPercentage);
            totalFinalIncrementPctCount++;
          }

          if (employee.marketCorrectionPercentage !== null && employee.marketCorrectionPercentage !== undefined) {
            this.totalEligiblemarketCorrectionPct += parseFloat(employee.marketCorrectionPercentage);
            totalMarketCorrectionPctCount++;
          }

          this.totalEligibleMarketCorrectionAmount += parseFloat(employee.marketCorrectionAmount || 0);
          this.totalEligibleFinalIncrementAmount += parseFloat(employee.finalIncrementAmount || 0);
          this.totalEligibleFinalAnnualCtc += parseFloat(employee.finalAnnualCtc || 0);
          this.totalEligibleFinalMonthlyCtc += parseFloat(employee.finalMonthlyCtc || 0);
        });
      });
    });

    if (totalFinalIncrementPctCount > 0) {
      this.totalEligibleFinalIncrementPct = parseFloat((this.totalEligibleFinalIncrementPct / totalFinalIncrementPctCount).toFixed(2));
    }
    if (totalMarketCorrectionPctCount > 0) {
      this.totalEligiblemarketCorrectionPct = parseFloat((this.totalEligiblemarketCorrectionPct / totalMarketCorrectionPctCount).toFixed(2));
    }
    if (totalPromotionPctCount > 0) {
      this.totalEligiblePromotionPct = parseFloat((this.totalEligiblePromotionPct / totalPromotionPctCount).toFixed(2));
    }
    if (totalHODIncrementPctCount > 0) {
      this.totalEligibleHODIncrementPct = parseFloat((this.totalEligibleHODIncrementPct / totalHODIncrementPctCount).toFixed(2));
    }
    if (totalHrAndMdIncrementPctCount > 0) {
      this.totalEligibleHrAndMdIncrementPct = parseFloat((this.totalEligibleHrAndMdIncrementPct / totalHrAndMdIncrementPctCount).toFixed(2));
    }
    if (totalIncrementPctCount > 0) {
      this.totalEligibleIncrementPct = parseFloat((this.totalEligibleIncrementPct / totalIncrementPctCount).toFixed(2));
    }
    if (totalDaysServedCount > 0) {
      this.totalEligibleDaysServedinIncrementPeriod = parseFloat((this.totalEligibleDaysServedinIncrementPeriod / totalDaysServedCount).toFixed(2));
    }
    if (totalProratedIncrementPctCount > 0) {
      this.totalEligibleProratedIncrementPct = parseFloat((this.totalEligibleProratedIncrementPct / totalProratedIncrementPctCount).toFixed(2));
    }
  }

  getIncrementInputisNonEligibleTableData() {
    const request = {
      band: this.selectedIncrementInputBand.length ? this.selectedIncrementInputBand.map((b: any) => b.name) : [],
      companyId: this.loggedInUserCompanyID,
      department: this.selectedIncrementInputDept.length ? this.selectedIncrementInputDept.map((d: any) => d.name) : [],
      employeeId: this.selectedIncrementInputEmp.length ? this.selectedIncrementInputEmp.map((e: any) => e.id) : [],
      fromYear: this.incrementFromYear,
      isEligible: false,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      manager: this.selectedIncrementInputManager.length ? this.selectedIncrementInputManager.map((m: any) => m.id) : [],
      search: this.searchIncrementInputTableData,
      toYear: this.incrementToYear
    };

    this.httpService.callPostService(this.config.getIncrementInput, request).subscribe((result: any) => {
      // 1️⃣ Save API result
      this.getIncrementInputNonEligibleTableData = result.data || [];

      console.log('📌 Non-Eligible API Block →', JSON.stringify(this.getIncrementInputNonEligibleTableData, null, 2));

      // 2️⃣ Flatten into grid rows
      this.prepareNonEligibleRowData();

      console.log('📌 Flattened Non-Eligible Row →', JSON.stringify(this.incrementNonEligibleRowData?.[0], null, 2));

      // 3️⃣ Build shared column defs
      this.buildIncrementColumnDefs();

      // 4️⃣ Build footer totals
      this.buildPinnedBottomTotalsNonEligible(this.incrementNonEligibleRowData);

      // 5️⃣ Old totals for your summary logic
      this.calculateNonEligibleTotals(this.getIncrementInputNonEligibleTableData);

      // 6️⃣ Push into grid if ready (use dedicated API)
      if (this.gridApiIncrementInputNonEligible) {
        this.gridApiIncrementInputNonEligible.setRowData(this.incrementNonEligibleRowData);
        this.gridApiIncrementInputNonEligible.setPinnedBottomRowData(this.pinnedBottomRowDataNonEligible);
      }

      // 7️⃣ Role flags (same as before)
      if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
        this.isEditHODApprovedIncrementPct = false;
        this.isEditHRAdminAndMDCEOApprovedIncrementPct = true;
      } else {
        this.isEditHODApprovedIncrementPct = true;
        this.isEditHRAdminAndMDCEOApprovedIncrementPct = false;
      }
    });
  }

  calculateNonEligibleTotals(data: any[]): void {
    // Initialize total and count variables for all fields
    this.totalNonEligibleTotalFixedCtcPM = 0;
    this.totalNonEligibleTotalFixedCtcPA = 0;
    this.totalNonEligibleEligibleEmp = 0;
    this.totalNonEligibleFinalRating = 0;
    this.totalNonEligibleIncrementPct = 0;
    this.totalNonEligibleDaysServedinIncrementPeriod = 0;
    this.totalNonEligibleProratedIncrementPct = 0;
    this.totalNonEligibleHODIncrementPct = 0;
    this.totalNonEligibleHrAndMdIncrementPct = 0;
    this.totalNonEligibleIncrementAmount = 0;
    this.totalNonEligibleNoOfPromotionPct = 0;
    this.totalNonEligiblePromotionPct = 0;
    this.totalNonEligiblePromotionAmount = 0;
    this.totalNonEligibleupdatedCtcAfterIAndP = 0;
    this.totalNonEligibleMarketBenchMarkCtc = 0;
    this.totalNonEligiblemarketCorrectionPct = 0;
    this.totalNonEligibleMarketCorrectionAmount = 0;
    this.totalNonEligibleFinalIncrementPct = 0;
    this.totalNonEligibleFinalIncrementAmount = 0;
    this.totalNonEligibleFinalAnnualCtc = 0;
    this.totalNonEligibleFinalMonthlyCtc = 0;

    // Counters for calculating averages
    let totalFinalIncrementPctCount = 0;
    let totalMarketCorrectionPctCount = 0;
    let totalPromotionPctCount = 0;
    let totalHODIncrementPctCount = 0;
    let totalHrAndMdIncrementPctCount = 0;
    let totalIncrementPctCount = 0;
    let totalDaysServedCount = 0;
    let totalProratedIncrementPctCount = 0;

    data?.forEach(department => {
      department.bandGrades.forEach((bandGrade: any) => {
        bandGrade.employeeData.forEach((employee: any) => {
          // Only process non-eligible employees
          if (!employee.isEligible) {
            this.totalNonEligibleTotalFixedCtcPM += parseFloat(employee.monthlyCtc || 0);
            this.totalNonEligibleTotalFixedCtcPA += parseFloat(employee.annualCtc || 0);
            this.totalNonEligibleEligibleEmp += 1;
            this.totalNonEligibleFinalRating += parseFloat(employee.finalRating || 0);

            // IncrementPct and count
            if (employee.incrementPercentage !== null && employee.incrementPercentage !== undefined) {
              this.totalNonEligibleIncrementPct += parseFloat(employee.incrementPercentage);
              totalIncrementPctCount++;
            }

            // DaysServed and count
            if (employee.daysServed !== null && employee.daysServed !== undefined) {
              this.totalNonEligibleDaysServedinIncrementPeriod += parseFloat(employee.daysServed);
              totalDaysServedCount++;
            }

            // ProratedIncrementPct and count
            if (employee.proratedIncrementPercentage !== null && employee.proratedIncrementPercentage !== undefined) {
              this.totalNonEligibleProratedIncrementPct += parseFloat(employee.proratedIncrementPercentage);
              totalProratedIncrementPctCount++;
            }

            // HODIncrementPct and count
            if (employee.hodIncrementPercentage !== null && employee.hodIncrementPercentage !== undefined) {
              this.totalNonEligibleHODIncrementPct += parseFloat(employee.hodIncrementPercentage);
              totalHODIncrementPctCount++;
            }

            // HrAndMdIncrementPct and count
            if (employee.hrAndMdIncrementPercentage !== null && employee.hrAndMdIncrementPercentage !== undefined) {
              this.totalNonEligibleHrAndMdIncrementPct += parseFloat(employee.hrAndMdIncrementPercentage);
              totalHrAndMdIncrementPctCount++;
            }

            // PromotionPct and count
            if (employee.promotionPercentage !== null && employee.promotionPercentage !== undefined) {
              this.totalNonEligiblePromotionPct += parseFloat(employee.promotionPercentage);
              totalPromotionPctCount++;
            }

            this.totalNonEligibleIncrementAmount += parseFloat(employee.incrementAmount || 0);
            this.totalNonEligibleNoOfPromotionPct += parseFloat(employee.noOfPromotions || 0);
            this.totalNonEligiblePromotionAmount += parseFloat(employee.promotionAmount || 0);
            this.totalNonEligibleupdatedCtcAfterIAndP += parseFloat(employee.updatedCtcAfterIncrementAndPromotion || 0);
            this.totalNonEligibleMarketBenchMarkCtc += parseFloat(employee.marketBenchMarkCtc || 0);

            // FinalIncrementPct and count
            if (employee.finalIncrementPercentage !== null && employee.finalIncrementPercentage !== undefined) {
              this.totalNonEligibleFinalIncrementPct += parseFloat(employee.finalIncrementPercentage);
              totalFinalIncrementPctCount++;
            }

            // MarketCorrectionPct and count
            if (employee.marketCorrectionPercentage !== null && employee.marketCorrectionPercentage !== undefined) {
              this.totalNonEligiblemarketCorrectionPct += parseFloat(employee.marketCorrectionPercentage);
              totalMarketCorrectionPctCount++;
            }

            this.totalNonEligibleMarketCorrectionAmount += parseFloat(employee.marketCorrectionAmount || 0);
            this.totalNonEligibleFinalIncrementAmount += parseFloat(employee.finalIncrementAmount || 0);
            this.totalNonEligibleFinalAnnualCtc += parseFloat(employee.finalAnnualCtc || 0);
            this.totalNonEligibleFinalMonthlyCtc += parseFloat(employee.finalMonthlyCtc || 0);
          }
        });
      });
    });

    // Calculate averages for all percentage fields with valid counts
    if (totalFinalIncrementPctCount > 0) {
      this.totalNonEligibleFinalIncrementPct = parseFloat((this.totalNonEligibleFinalIncrementPct / totalFinalIncrementPctCount).toFixed(2));
    }
    if (totalMarketCorrectionPctCount > 0) {
      this.totalNonEligiblemarketCorrectionPct = parseFloat((this.totalNonEligiblemarketCorrectionPct / totalMarketCorrectionPctCount).toFixed(2));
    }
    if (totalPromotionPctCount > 0) {
      this.totalNonEligiblePromotionPct = parseFloat((this.totalNonEligiblePromotionPct / totalPromotionPctCount).toFixed(2));
    }
    if (totalHODIncrementPctCount > 0) {
      this.totalNonEligibleHODIncrementPct = parseFloat((this.totalNonEligibleHODIncrementPct / totalHODIncrementPctCount).toFixed(2));
    }
    if (totalHrAndMdIncrementPctCount > 0) {
      this.totalNonEligibleHrAndMdIncrementPct = parseFloat((this.totalNonEligibleHrAndMdIncrementPct / totalHrAndMdIncrementPctCount).toFixed(2));
    }
    if (totalIncrementPctCount > 0) {
      this.totalNonEligibleIncrementPct = parseFloat((this.totalNonEligibleIncrementPct / totalIncrementPctCount).toFixed(2));
    }
    if (totalDaysServedCount > 0) {
      this.totalNonEligibleDaysServedinIncrementPeriod = parseFloat((this.totalNonEligibleDaysServedinIncrementPeriod / totalDaysServedCount).toFixed(2));
    }

    if (totalProratedIncrementPctCount > 0) {
      this.totalNonEligibleProratedIncrementPct = parseFloat((this.totalNonEligibleProratedIncrementPct / totalProratedIncrementPctCount).toFixed(2));
    }
  }

  getTotalRowSpan(bandGrades: any[]): number {
    let totalRows = 0;
    bandGrades.forEach(bandGrade => {
      totalRows += bandGrade.employeeData.length;
    });
    return totalRows;
  }

  onEditIncrementInputTableData(employee: any, gridParams?: any) {
    console.log('🔥 onEditIncrementInputTableData', 'inputId=', employee?.inputId, 'hasGridParams=', !!gridParams, 'rowData=', gridParams?.node?.data);

    const request = {
      designation: employee.designation ?? null,
      hodIncrementPercentage: employee.hodIncrementPercentage ?? null,
      hrIncrementPercentage: employee.hrAndMdIncrementPercentage ?? null,
      inputId: employee.inputId,
      isEligible: employee.isEligible,
      isPromoted: employee.isPromoted,
      marketBenchmarkCtc: employee.marketBenchMarkCtc ?? null,
      marketCorrectionPercentage: employee.marketCorrectionPercentage ?? null,
      promotionPercentage: employee.promotionPercentage ?? null
    };

    this.httpService.callPostService(this.config.editIncrementInput, request).subscribe((result: any) => {
      console.log('editIncrementInput result:', result);
      if (!result?.status) return;

      if (employee.inputId && gridParams?.api) {
        // ✅ suppress events so refreshing row doesn’t retrigger onCellValueChanged
        (gridParams.api as any).suppressEvents = true;
        this.getIncrementInputEditData(employee.inputId, gridParams);
        (gridParams.api as any).suppressEvents = false;
      }
    });
  }

  getIncrementInputEditData(id: any, gridParams?: any) {
    console.log('🔥 getIncrementInputEditData', 'id=', id, 'hasGridParams=', !!gridParams, 'rowBefore=', gridParams?.node?.data);

    this.httpService.callGetService(this.config.getIncrementInputById + id).subscribe((result: any) => {
      console.log('getIncrementInputById result:', result);

      const updatedData = result?.data;
      if (!updatedData || !updatedData.bandGrades?.length) return;

      const updatedEmployee = updatedData.bandGrades[0].employeeData[0];
      console.log('updatedEmployee from backend:', updatedEmployee);

      // 1️⃣ sync nested table data
      [this.getIncrementInputEligibleTableData, this.getIncrementInputNonEligibleTableData].forEach((tableData: any) => {
        if (!Array.isArray(tableData)) return;
        tableData.forEach((dept: any) => {
          dept.bandGrades?.forEach((band: any) => {
            band.employeeData = band.employeeData?.map((emp: any) => (emp.employeeId === updatedEmployee.employeeId ? updatedEmployee : emp));
          });
        });
      });

      // 2️⃣ update visible AG-Grid row safely
      if (gridParams?.node) {
        const node = gridParams.node;
        const rowData = node.data || {};
        const emp = updatedEmployee;

        rowData.__rawEmployee = emp;
        rowData.inputId = emp.inputId;
        rowData.employeeId = emp.employeeId;

        const updateField = (header: string, prop: keyof typeof emp) => {
          const fieldKey = this.fieldKeyFromDisplayName(header);
          const value = (emp as any)[prop];

          // assign directly to rowData
          rowData[fieldKey] = value;
          (rowData as any)[prop] = value;

          // refresh visuals without firing onCellValueChanged
          gridParams.api?.refreshCells({
            rowNodes: [node],
            columns: [fieldKey],
            force: false
          });
        };

        // update recalculated fields
        updateField('Promotion %', 'promotionPercentage');
        updateField('Promotion Amount', 'promotionAmount');
        updateField('Updated CTC after Increment & Promotion', 'updatedCtcAfterIncrementAndPromotion');
        updateField('Increment Amount', 'incrementAmount');
        updateField('Final Increment % p.a', 'finalIncrementPercentage');
        updateField('Final Increment Amount', 'finalIncrementAmount');
        updateField('Final Annual Revised CTC (post increment)', 'finalAnnualCtc');
        updateField('Final Monthly Revised CTC (post increment)', 'finalMonthlyCtc');
        updateField('Market BenchMark CTC', 'marketBenchMarkCtc');
        updateField('Market Correction %', 'marketCorrectionPercentage');
        updateField('Market Correction Amount', 'marketCorrectionAmount');
        updateField('HR Admin & MD/CEO Approved Increment %', 'hrAndMdIncrementPercentage');

        console.log('Row after safe updates:', rowData);
      }

      // 3️⃣ recalc totals + pinned rows
      try {
        if (typeof this.calculateInputEligibleTotals === 'function') {
          this.calculateInputEligibleTotals(this.getIncrementInputEligibleTableData);
        }
        if (typeof this.calculateNonEligibleTotals === 'function') {
          this.calculateNonEligibleTotals(this.getIncrementInputNonEligibleTableData);
        }

        if (this.gridApiIncrementInputEligible && this.pinnedBottomRowDataEligible) {
          this.gridApiIncrementInputEligible.setPinnedBottomRowData(this.pinnedBottomRowDataEligible);
        }
        if (this.gridApiIncrementInputNonEligible && this.pinnedBottomRowDataNonEligible) {
          this.gridApiIncrementInputNonEligible.setPinnedBottomRowData(this.pinnedBottomRowDataNonEligible);
        }
      } catch (e) {
        console.warn('Error in footer / totals recalc:', e);
      }
    });
  }
  onClickShowIncrementLetter(id: any) {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.incrementFromYear,
      id: id,
      toYear: this.incrementToYear
    };

    this.httpService.callPostService(this.config.getLetterOfUser, request).subscribe(
      (result: any) => {
        // this.http.get(result?.data, { responseType: 'blob' }).subscribe(
        //   (blob: any) => {
        //     const url = URL.createObjectURL(blob);
        //     window.open(url, '_blank');
        //     setTimeout(() => URL.revokeObjectURL(url), 100);
        //   },
        // );
        if (result?.data != null) {
          var fileName = result?.data?.split(environment.downloadURL);
          console.log(fileName[0]);

          // saveAs(result?.data, fileName[0]);

          // add view
          this.downloadSign(result?.data);
        }
      },
      error => {
        if (error.status === 500) {
          window.alert('Letter not found');
        }
      }
    );
  }
  downloadSign(event: any) {
    if (event) {
      // Open the document in a new tab
      let fileUrl = `${this.config.downloadFile}${this.loggedInUserCompanyID}/${event}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }
  }
  // genreate increment letters btn
  onClickGenerateIncrementLetters() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Please fill the CTC breakup in employee master before proceeding or else you will see updated CTC with the old breakup',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigate(['/home/hrportal/increment/generateIncrementLetters']);
      }
    });
  }

  onCLickFreezforTheHOD() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to freeze the input file for all HODs?',
        btn1: 'Cancel',
        btn2: 'Freeze',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const request = {
          companyId: this.loggedInUserCompanyID,
          fromYear: this.incrementFromYear,
          toYear: this.incrementToYear
        };
        this.httpService.callPostService(this.config.freezeForTheHod, request).subscribe((result: any) => {
          this.getMDApprovedData();
        });
      }
    });
  }

  getFreezForTheHODStatus() {
    // const request = {
    //   "companyId": this.loggedInUserCompanyID,
    //   "fromYear": this.incrementFromYear,
    //   "toYear": this.incrementToYear
    // }
    // this.httpService.callPostService(this.config.getIncrementApprovalDataOfCompany, request).subscribe((result: any) => {
    //   const status:any = result.data?.freezeForHod;
    //   if (status === true) {
    //     this.disableIncrementInputFormToHOD = true;
    //   } else {
    //     this.disableIncrementInputFormToHOD = false
    //   }
    // })
  }
  onCLickSendToMDForApproval() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to send for approval',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        const request = {
          companyId: this.loggedInUserCompanyID,
          fromYear: this.incrementFromYear,
          toYear: this.incrementToYear
        };
        this.httpService.callPostService(this.config.sendToMdOrCeoForApproval, request).subscribe((result: any) => {
          if (result) {
            this.getMDApprovedData();
          }
        });
      }
    });
  }

  onCLickHODsendToHrAdminToApproval() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to send for approval',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result) return;

      const request = {
        companyId: this.loggedInUserCompanyID,
        department: '',
        fromYear: this.incrementFromYear,
        isApprovedByMd: true,
        toYear: this.incrementToYear
      };

      this.httpService.callPostService(this.config.approveByHod, request).subscribe({
        next: (result: any) => {
          if (result && result.data === true) {
            // mark as sent (global lock)
            this.afterHODForApprovalDate = true;

            // If you want to store which HOD sent it (optional), uncomment/set:
            // this.approvalSentByHodUserId = this.loggedInUserId;

            // Rebuild column definitions so editable callbacks reflect the new state
            try {
              this.buildIncrementColumnDefs();
            } catch (e) {
              console.error('Error rebuilding columnDefs:', e);
            }

            // Re-apply columnDefs to the grid and refresh UI so editability updates immediately
            if (this.gridApi) {
              try {
                this.gridApi.setColumnDefs(this.incrementColumnDefs);
                // stop any active editing
                this.gridApi.stopEditing();
                // force re-render of cells
                this.gridApi.refreshCells({ force: true });
              } catch (e) {
                console.error('Error re-applying columnDefs to gridApi:', e);
              }
            } else {
              console.warn('gridApi is not available; columnDefs rebuilt but not applied to grid.');
            }

            // refresh server-derived approval data if needed
            this.getApproveByHodData();
          } else {
            // server responded but result.data is not true
            console.warn('approveByHod returned false or unexpected payload:', result);
          }
        },
        error: (err: any) => {
          console.error('approveByHod API error', err);
        }
      });
    });
  }

  getApproveByHodData() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.incrementFromYear,
      toYear: this.incrementToYear
    };
    this.httpService.callPostService(this.config.getApproveByHodData, request).subscribe((result: any) => {
      if (result.data?.approvalByHodDate) {
        this.approvalByHodDate = result.data.approvalByHodDate;
        this.afterHODForApprovalDate = true;
      } else {
        this.afterHODForApprovalDate = false;
      }
    });
  }

  // getDateAndTiemAfterMdOrCeoForApproval(){
  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "fromYear": this.fromYear,
  //     "toYear": this.toYear
  //   }
  //   this.httpService.callPostService(this.config.getIncrementApprovalDataOfCompany, request).subscribe((result:any)=>{
  //     const status = result.data.freezeForHod;
  //   })
  // }

  onClickMDRejectApproval() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to Reject the Increment?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.loader.simpleLoaderWithDuration();
        const request = {
          companyId: this.loggedInUserCompanyID,
          department: null,
          fromYear: this.incrementFromYear,
          isApprovedByMd: false,
          toYear: this.incrementToYear
        };
        this.httpService.callPostService(this.config.approveOrRejectByMD, request).subscribe((result: any) => {
          if (result) {
            this.getMDApprovedData();
          }
        });
      }
    });
  }

  onClickMDApproveAproval() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to approve the Increment?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result) return;

      try {
        this.loader?.simpleLoaderWithDuration?.();
      } catch (e) {}

      const request = {
        companyId: this.loggedInUserCompanyID,
        department: null,
        fromYear: this.incrementFromYear,
        isApprovedByMd: true,
        toYear: this.incrementToYear
      };

      this.httpService.callPostService(this.config.approveOrRejectByMD, request).subscribe({
        next: (res: any) => {
          try {
            if (!res) {
              console.warn('MD approve returned empty response', res);
              return;
            }

            // CASE A: server returns true -> global MD lock
            if (res.data === true || res === true) {
              this.afterMDAndCEOApproval = true;
            } else {
              // CASE B: server returns list of approved user ids in various shapes
              let ids: string[] = [];

              if (res.data && Array.isArray(res.data.approvedUserIds)) {
                ids = res.data.approvedUserIds;
              } else if (Array.isArray(res.data)) {
                ids = res.data;
              } else if (Array.isArray(res.approvedUserIds)) {
                ids = res.approvedUserIds;
              }

              if (ids.length > 0) {
                // Mark matching rows in the in-memory row data
                if (Array.isArray(this.incrementEligibleRowData)) {
                  this.incrementEligibleRowData.forEach((row: any) => {
                    const emp = row?.__rawEmployee;
                    if (emp && emp.userId && ids.includes(emp.userId)) {
                      emp.approvedByMd = true;
                      // keep row consistent
                      row.__rawEmployee = emp;
                    }
                  });
                }

                // If your component happens to have departments, mark them too — use runtime-safe access
                try {
                  const maybeDepartments = (this as any).departments;
                  if (Array.isArray(maybeDepartments)) {
                    maybeDepartments.forEach((d: any) => {
                      (d.bandGrades || []).forEach((bg: any) => {
                        (bg.employeeData || []).forEach((emp: any) => {
                          if (emp && emp.userId && ids.includes(emp.userId)) {
                            emp.approvedByMd = true;
                          }
                        });
                      });
                    });
                  }
                } catch (e) {
                  // ignore if not present / accessible
                }
              }
            }

            // Rebuild column defs (editable checks will now consider MD locks)
            try {
              this.buildIncrementColumnDefs();
            } catch (e) {
              console.error('buildIncrementColumnDefs error', e);
            }

            // Apply to grid and refresh UI so editability updates immediately
            if (this.gridApi) {
              try {
                this.gridApi.setColumnDefs(this.incrementColumnDefs);
                this.gridApi.stopEditing();
                this.gridApi.refreshCells({ force: true });
              } catch (e) {
                console.error('Error re-applying columnDefs to gridApi after MD approve:', e);
              }
            } else {
              console.warn('gridApi not available — columnDefs rebuilt but not applied');
            }

            // Refresh any approval data you keep on UI
            try {
              this.getMDApprovedData?.();
            } catch (e) {}
            try {
              this.getApproveByHodData?.();
            } catch (e) {}
          } catch (e) {
            console.error('Error processing MD approve response', e);
          }
        },
        error: (err: any) => {
          console.error('approveOrRejectByMD API error', err);
        }
      });
    });
  }

  getMDApprovedData() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.incrementFromYear,
      toYear: this.incrementToYear
    };
    this.httpService.callPostService(this.config.getIncrementApprovalDataOfCompany, request).subscribe((result: any) => {
      this.approvalStatus = result.data?.mdReviewStatus;
      this.approvalDateAndTime = result.data?.approvalByHrDate;
      const formattedDate = this.datePipe.transform(this.approvalDateAndTime, 'dd-MM-yyyy');
      this.isApprovedByHr = result.data?.isApprovedByHr;
      this.isHideFreezeForTheHodBtn = false;
      if (result.data?.mdReviewStatus == 'Approved') {
        this.afterMDAndCEOApproval = true;
        this.ShowIncrementInputStatus = `${this.approvalStatus} on ${formattedDate}`;

        this.editedIndividualScoreId = null;
        this.disableIncrementInputFormToHrAdmin = true;
        // this.isHideScoreToRatingConverterAddBtn = false;
      } else if (result.data?.mdReviewStatus == 'Rejected') {
        this.ShowIncrementInputStatus = 'Rejected';
        this.disableIncrementInputFormToHrAdmin = false;
        this.isHideFreezeForTheHodBtn = true;
      } else {
        this.ShowIncrementInputStatus = 'Pending';
        this.afterMDAndCEOApproval = false;
        this.disableIncrementInputFormToHrAdmin = false;
        this.isHideFreezeForTheHodBtn = true;
      }

      // Approved or Reject Btn
      if (result.data?.mdReviewStatus == 'Approved' || result.data?.isApprovedByHr == false) {
        this.isDisableApproveBtnAfterMDApproved = true;
      } else {
        this.isDisableApproveBtnAfterMDApproved = false;
      }

      // Hod approved
      const status: any = result.data?.freezeForHod;
      this.isDisabledFreezeForHodBtn = result.data?.freezeForHod;
      if (status === true && !this.isShowMD) {
        this.disableIncrementInputFormToHOD = true;
      } else {
        this.disableIncrementInputFormToHOD = false;
      }

      // Send to MD/CEO for Approval
      if (result.data?.isApprovedByHr == true) {
        this.disableBtnsOnsendApprovelForMD = true;
        if (this.isShowMD && result.data?.mdReviewStatus != 'Approved') {
          this.disableIncrementInputFormToHrAdmin = false;
        } else {
          this.disableIncrementInputFormToHrAdmin = true;
        }
      } else {
        this.disableIncrementInputFormToHrAdmin = false;
        this.disableBtnsOnsendApprovelForMD = false;
      }

      if (result?.data?.isLetterSubmitted == true) {
        this.isDisabledFinalIncLettersBtn = true;
      } else {
        this.isDisabledFinalIncLettersBtn = false;
      }
    });
  }

  // onClickSubmitIncrementLetters() {
  //   // this.loader.simpleLoader();
  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "fromYear": this.incrementFromYear,
  //     "incrementId": null,
  //     "toYear": this.incrementToYear
  //   }
  //   this.httpService.callPostService(this.config.submitIncrementLetters, request).subscribe((result: any) => {
  //     if (result) {
  //       this.loader.dismissLoader();
  //       const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
  //         disableClose: true,
  //         height: '25%',
  //         width: '30%',
  //         data: {
  //           msg: 'Letter Submited Successfully',
  //           btn2: 'Ok',
  //           btn2BgColor: this.buttonColorName,
  //           showSuccessIcon: true,
  //           showSuccessMessage: false,
  //           showCloseIcon: false
  //         },
  //       });
  //       dialogRef.afterClosed().subscribe((result:any) => {
  //         if (result) {
  //           this.getMDApprovedData();
  //         }
  //       })
  //     }
  //   }, (error)=>{
  //     this.loader.dismissLoader();
  //   })
  // }
  onClickSubmitIncrementLetters() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Please complete the employee masters CTC breakdown before sending the updated CTC',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        // User clicked "Yes" → Proceed with API call
        // this.loader.simpleLoader();
        const request = {
          companyId: this.loggedInUserCompanyID,
          fromYear: this.incrementFromYear,
          incrementId: null,
          toYear: this.incrementToYear
        };

        this.httpService.callPostService(this.config.submitIncrementLetters, request).subscribe(
          (apiResult: any) => {
            if (apiResult) {
              this.loader.dismissLoader();
              const successDialog = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: 'Letter Submitted Successfully',
                  btn2: 'Ok',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                }
              });

              successDialog.afterClosed().subscribe((closeResult: any) => {
                if (closeResult) {
                  this.getMDApprovedData();
                }
              });
            }
          },
          error => {
            this.loader.dismissLoader();
          }
        );
      }
    });
  }

  onClickDownloadIncrementInputExcelFile() {
    this.loader.simpleLoader();
    this.isShowExcelData = true;
    const tableName = this.activeIncrementInputTab ? 'incrementInputEligibleTable' : 'incrementInputNonEligibleTable';
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').split('-').join('-');
    if (tableName == 'incrementInputEligibleTable') {
      setTimeout(() => {
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString('en-GB').split('-').join('-');
        const flattenedData: any[] = [];

        // const formatDate = (date: string) => {
        //   const formattedDate = new Date(date);
        //   return !isNaN(formattedDate.getTime()) ? formattedDate.toLocaleDateString('en-GB') : date;
        // };
        const formatDate = (date: string) => {
          const formattedDate = new Date(date);

          if (isNaN(formattedDate.getTime())) return date; // invalid date

          const day = String(formattedDate.getDate()).padStart(2, '0');
          const month = String(formattedDate.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
          const year = formattedDate.getFullYear();

          return `${day}-${month}-${year}`;
        };

        const formatNum = (value: any) => {
          const num = parseFloat(value);
          return isNaN(num) ? '0.00' : num.toFixed(2);
        };

        const currentYear = new Date().getFullYear();
        const lastThreeYears = [currentYear - 3, currentYear - 2, currentYear - 1];

        this.getIncrementInputEligibleTableData.forEach((department: any) => {
          department.bandGrades.forEach((band: any) => {
            band.employeeData.forEach((employee: any) => {
              flattenedData.push({
                Department: department.departmentName,
                Band: band.band,
                Employee: employee.employeeName,
                Manager: employee.managerName,
                HOD: employee.hodName,
                Designation: employee.designation,
                DOJ: formatDate(employee.dateOfJoining),
                'Total CTC p.m.': formatNum(employee.monthlyCtc),
                'Total CTC p.a.': formatNum(employee.annualCtc),
                'Eligible Emp.': employee.isEligible ? 'Yes' : 'No',
                'Individual KPI + Competency Score': formatNum(employee.individualKpiCompetencyScore),
                'Department Score (out of 100)': formatNum(employee.deptScore),
                'Company Score (out of 100)': formatNum(employee.companyScore),
                'Final Score': formatNum(employee.finalScore),
                'Final Rating': employee.finalRating,
                'Increment %': formatNum(employee.incrementPercentage),
                'Days Served in the Increment Period': `${employee.daysServed || 0}`,
                'Prorated Increment %': formatNum(employee.proratedIncrementPercentage),
                'Increment Amount': formatNum(employee.incrementAmount),
                'No Promotion Last 3 Year': `${employee.noOfPromotions || 0}`,
                Promotion: employee.isPromoted ? 'Yes' : 'No',
                'Promotion %': formatNum(employee.promotionPercentage),
                'Promotion Amount': formatNum(employee.promotionAmount),
                'Updated CTC after Increment & Promotion': formatNum(employee.updatedCtcAfterIncrementAndPromotion),
                'Market BenchMark CTC': formatNum(employee.marketBenchMarkCtc),
                'Market Correction %': formatNum(employee.marketCorrectionPercentage),
                'Market Correction Amount': formatNum(employee.marketCorrectionAmount),
                'Final Increment % p.a': formatNum(employee.finalIncrementPercentage),
                [`Increment % in ${lastThreeYears[0]}`]: formatNum(employee.yearBeforeLastYrIncrementPercentage),
                [`Increment % in ${lastThreeYears[1]}`]: formatNum(employee.lastToLastYrIncrementPercentage),
                [`Increment % in ${lastThreeYears[2]}`]: formatNum(employee.lastYrIncrementPercentage),
                'HOD Approved Increment %': formatNum(employee.hodIncrementPercentage),
                'HR Admin & MD/CEO Approved Increment %': formatNum(employee.hrAndMdIncrementPercentage),
                'Final Increment Amount': formatNum(employee.finalIncrementAmount),
                'Final Annual Revised CTC (post increment)': formatNum(employee.finalAnnualCtc),
                'Final Monthly Revised CTC (post increment)': formatNum(employee.finalMonthlyCtc),
                'Increment Letter Format': employee.incrementLetterFormat?.letterName || 'Letter not found'
              });
            });
          });
        });

        // Summary row
        flattenedData.push({
          Department: 'Total',
          Band: '',
          Employee: '',
          Manager: '',
          HOD: '',
          Designation: '',
          DOJ: '',
          'Total CTC p.m.': formatNum(this.totalEligibleTotalFixedCtcPM),
          'Total CTC p.a.': formatNum(this.totalEligibleTotalFixedCtcPA),
          'Eligible Emp.': `${this.totalEligibleEligibleEmp}`,
          'Individual KPI + Competency Score': '',
          'Department Score (out of 100)': '',
          'Company Score (out of 100)': '',
          'Final Score': '',
          'Final Rating': '',
          'Increment %': formatNum(this.totalEligibleIncrementPct),
          'Days Served in the Increment Period': `${this.totalEligibleDaysServedinIncrementPeriod}`,
          'Prorated Increment %': formatNum(this.totalEligibleProratedIncrementPct),
          'Increment Amount': formatNum(this.totalEligibleIncrementAmount),
          'No Promotion Last 3 Year': `${this.totalEligibleNoOfPromotionPct}`,
          Promotion: '',
          'Promotion %': formatNum(this.totalEligiblePromotionPct),
          'Promotion Amount': formatNum(this.totalEligiblePromotionAmount),
          'Updated CTC after Increment & Promotion': formatNum(this.totalEligibleupdatedCtcAfterIAndP),
          'Market BenchMark CTC': formatNum(this.totalEligibleMarketBenchMarkCtc),
          'Market Correction %': formatNum(this.totalEligiblemarketCorrectionPct),
          'Market Correction Amount': formatNum(this.totalEligibleMarketCorrectionAmount),
          'Final Increment % p.a': formatNum(this.totalEligibleFinalIncrementPct),
          [`Increment % in ${lastThreeYears[0]}`]: '',
          [`Increment % in ${lastThreeYears[1]}`]: '',
          [`Increment % in ${lastThreeYears[2]}`]: '',
          'HOD Approved Increment %': formatNum(this.totalEligibleHODIncrementPct),
          'HR Admin & MD/CEO Approved Increment %': formatNum(this.totalEligibleHrAndMdIncrementPct),
          'Final Increment Amount': formatNum(this.totalEligibleFinalIncrementAmount),
          'Final Annual Revised CTC (post increment)': formatNum(this.totalEligibleFinalAnnualCtc),
          'Final Monthly Revised CTC (post increment)': formatNum(this.totalEligibleFinalMonthlyCtc),
          'Increment Letter Format': ''
        });

        // Excel export
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
        const defaultCellStyle = {
          alignment: { horizontal: 'left', vertical: 'top' },
          font: { name: 'Arial', sz: 12 }
        };

        const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
        for (let row = range.s.r; row <= range.e.r; row++) {
          for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
            if (worksheet[cellAddress]) {
              worksheet[cellAddress].s = defaultCellStyle;
            }
          }
        }
        worksheet['!cols'] = Object.keys(flattenedData[0]).map(() => ({
          wpx: 200
        }));
        const workbook: XLSX.WorkBook = {
          Sheets: { data: worksheet },
          SheetNames: ['data']
        };
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
        const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
        const fileName = `Increment_Input_Eligible_Employee_Data_${formattedDate}`;
        saveAs(data, fileName);

        this.isShowExcelData = false;
        this.loader.dismissLoader();
      }, 1000);
    } else if (tableName == 'incrementInputNonEligibleTable') {
      setTimeout(() => {
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
        const flattenedData: any[] = [];
        const formatDate = (date: string) => {
          const formattedDate = new Date(date);
          return !isNaN(formattedDate.getTime()) ? formattedDate.toLocaleDateString('en-GB') : date;
        };
        const formatNum = (value: any) => {
          const num = parseFloat(value);
          return isNaN(num) ? '0.00' : num.toFixed(2);
        };
        const currentYear = new Date().getFullYear();
        const lastThreeYears = [currentYear - 3, currentYear - 2, currentYear - 1];
        this.getIncrementInputNonEligibleTableData.forEach((department: any) => {
          department.bandGrades.forEach((band: any) => {
            band.employeeData.forEach((employee: any) => {
              flattenedData.push({
                Department: department.departmentName,
                Band: band.band,
                Employee: employee.employeeName,
                Manager: employee.managerName,
                HOD: employee.hodName,
                Designation: employee.designation,
                DOJ: formatDate(employee.dateOfJoining),
                'Total CTC p.m.': formatNum(employee.monthlyCtc),
                'Total CTC p.a.': formatNum(employee.annualCtc),
                'Eligible Emp.': employee.isEligible ? 'Yes' : 'No',
                'Individual KPI + Competency Score': formatNum(employee.individualKpiCompetencyScore),
                'Department Score (out of 100)': formatNum(employee.deptScore),
                'Company Score (out of 100)': formatNum(employee.companyScore),
                'Final Score': formatNum(employee.finalScore),
                'Final Rating': employee.finalRating,
                'Increment %': formatNum(employee.incrementPercentage),
                'Days Served in the Increment Period': `${employee.daysServed || 0}`,
                'Prorated Increment %': formatNum(employee.proratedIncrementPercentage),
                'Increment Amount': formatNum(employee.incrementAmount),
                'No Promotion Last 3 Year': `${employee.noOfPromotions || 0}`,
                Promotion: employee.isPromoted ? 'Yes' : 'No',
                'Promotion %': formatNum(employee.promotionPercentage),
                'Promotion Amount': formatNum(employee.promotionAmount),
                'Updated CTC after Increment & Promotion': formatNum(employee.updatedCtcAfterIncrementAndPromotion),
                'Market BenchMark CTC': formatNum(employee.marketBenchMarkCtc),
                'Market Correction %': formatNum(employee.marketCorrectionPercentage),
                'Market Correction Amount': formatNum(employee.marketCorrectionAmount),
                'Final Increment % p.a': formatNum(employee.finalIncrementPercentage),
                [`Increment % in ${lastThreeYears[0]}`]: formatNum(employee.yearBeforeLastYrIncrementPercentage),
                [`Increment % in ${lastThreeYears[1]}`]: formatNum(employee.lastToLastYrIncrementPercentage),
                [`Increment % in ${lastThreeYears[2]}`]: formatNum(employee.lastYrIncrementPercentage),
                'HOD Approved Increment %': formatNum(employee.hodIncrementPercentage),
                'HR Admin & MD/CEO Approved Increment %': formatNum(employee.hrAndMdIncrementPercentage),
                'Final Increment Amount': formatNum(employee.finalIncrementAmount),
                'Final Annual Revised CTC (post increment)': formatNum(employee.finalAnnualCtc),
                'Final Monthly Revised CTC (post increment)': formatNum(employee.finalMonthlyCtc),
                'Increment Letter Format': employee.incrementLetterFormat?.letterName || 'Letter not found'
              });
            });
          });
        });
        flattenedData.push({
          Department: 'Total',
          Band: '',
          Employee: '',
          Manager: '',
          HOD: '',
          Designation: '',
          DOJ: '',
          'Total CTC p.m.': formatNum(this.totalNonEligibleTotalFixedCtcPM),
          'Total CTC p.a.': formatNum(this.totalNonEligibleTotalFixedCtcPA),
          'Eligible Emp.': `${this.totalNonEligibleEligibleEmp}`,
          'Individual KPI + Competency Score': '',
          'Department Score (out of 100)': '',
          'Company Score (out of 100)': '',
          'Final Score': '',
          'Final Rating': '',
          'Increment %': formatNum(this.totalNonEligibleIncrementPct),
          'Days Served in the Increment Period': `${this.totalNonEligibleDaysServedinIncrementPeriod}`,
          'Prorated Increment %': formatNum(this.totalNonEligibleProratedIncrementPct),
          'Increment Amount': formatNum(this.totalNonEligibleIncrementAmount),
          'No Promotion Last 3 Year': `${this.totalNonEligibleNoOfPromotionPct}`,
          Promotion: '',
          'Promotion %': formatNum(this.totalNonEligiblePromotionPct),
          'Promotion Amount': formatNum(this.totalNonEligiblePromotionAmount),
          'Updated CTC after Increment & Promotion': formatNum(this.totalNonEligibleupdatedCtcAfterIAndP),
          'Market BenchMark CTC': formatNum(this.totalNonEligibleMarketBenchMarkCtc),
          'Market Correction %': formatNum(this.totalNonEligiblemarketCorrectionPct),
          'Market Correction Amount': formatNum(this.totalNonEligibleMarketCorrectionAmount),
          'Final Increment % p.a': formatNum(this.totalNonEligibleFinalIncrementPct),
          [`Increment % in ${lastThreeYears[0]}`]: '',
          [`Increment % in ${lastThreeYears[1]}`]: '',
          [`Increment % in ${lastThreeYears[2]}`]: '',
          'HOD Approved Increment %': formatNum(this.totalNonEligibleHODIncrementPct),
          'HR Admin & MD/CEO Approved Increment %': formatNum(this.totalNonEligibleHrAndMdIncrementPct),
          'Final Increment Amount': formatNum(this.totalNonEligibleFinalIncrementAmount),
          'Final Annual Revised CTC (post increment)': formatNum(this.totalNonEligibleFinalAnnualCtc),
          'Final Monthly Revised CTC (post increment)': formatNum(this.totalNonEligibleFinalMonthlyCtc),
          'Increment Letter Format': ''
        });
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
        const defaultCellStyle = {
          alignment: { horizontal: 'left', vertical: 'top' },
          font: { name: 'Arial', sz: 12 }
        };
        const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
        for (let row = range.s.r; row <= range.e.r; row++) {
          for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
            if (worksheet[cellAddress]) {
              worksheet[cellAddress].s = defaultCellStyle;
            }
          }
        }
        worksheet['!cols'] = Object.keys(flattenedData[0]).map(() => ({
          wpx: 200
        }));
        const workbook: XLSX.WorkBook = {
          Sheets: { data: worksheet },
          SheetNames: ['data']
        };
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
        const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
        const fileName = `Increment_Input_NonEligible_Employee_Data_${formattedDate}`;
        saveAs(data, fileName);
        this.isShowExcelData = false;
        this.loader.dismissLoader();
      }, 1000);
    }
  }

  // Increment Summary
  getIncrementSummaryTableHideShowAllData() {
    if (this.onSelectIncrementTotalCTC == 'Fixed Annual CTC') {
      this.incrementsummaryCtc = 'Fixed CTC';
    } else {
      this.incrementsummaryCtc = 'Total CTC';
    }
    this.IncrementSummaryTableHideShowAllData = [
      {
        fieldId: 1,
        isVisible: true,
        fieldName: 'Department',
        position: 1,
        isEditable: true
      },
      {
        fieldId: 2,
        isVisible: true,
        fieldName: 'Band',
        position: 2,
        isEditable: true
      },
      {
        fieldId: 3,
        isVisible: true,
        fieldName: 'Total Emp.',
        position: 3,
        isEditable: true
      },
      {
        fieldId: 4,
        isVisible: true,
        fieldName: this.incrementsummaryCtc,
        position: 4,
        isEditable: true
      },
      {
        fieldId: 5,
        isVisible: true,
        fieldName: 'Eligible Emp.',
        position: 5,
        isEditable: true
      },
      {
        fieldId: 6,
        isVisible: true,
        fieldName: 'Eligible Emp. Fixed CTC',
        position: 6,
        isEditable: true
      },
      {
        fieldId: 7,
        isVisible: true,
        fieldName: 'Overall Increment Budget',
        position: 7,
        isEditable: true
      },
      {
        fieldId: 8,
        isVisible: true,
        fieldName: 'Increment Amount',
        position: 8,
        isEditable: true
      },
      {
        fieldId: 9,
        isVisible: true,
        fieldName: 'No of Promotions',
        position: 9,
        isEditable: true
      },
      {
        fieldId: 10,
        isVisible: true,
        fieldName: 'Promotion Amount',
        position: 10,
        isEditable: true
      },
      {
        fieldId: 11,
        isVisible: true,
        fieldName: 'No of Market Corrections',
        position: 11,
        isEditable: true
      },
      {
        fieldId: 12,
        isVisible: true,
        fieldName: 'Market Correction Amount',
        position: 12,
        isEditable: true
      },
      {
        fieldId: 13,
        isVisible: true,
        fieldName: 'Final Increment Amount',
        position: 13,
        isEditable: true
      },
      {
        fieldId: 14,
        isVisible: true,
        fieldName: 'Variance',
        position: 14,
        isEditable: true
      },
      {
        fieldId: 15,
        isVisible: true,
        fieldName: 'Variance %',
        position: 15,
        isEditable: true
      }
    ];
  }

  updateIncrementSummaryColumnVisibility(data: any, index: any) {
    this.IncrementSummaryTableHideShowAllData[index].isVisible = false;
  }

  onSelectIncrementSummaryHideShowCheckBox(event: any) {
    this.isAnyColumnInvisible = this.IncrementSummaryTableHideShowAllData?.some((ele: any) => !ele.isVisible);
    this.allColumnsInvisible = this.IncrementSummaryTableHideShowAllData?.every((ele: any) => !ele.isVisible);
  }

  getIncrementSummaryColumnVisibility(fieldName: string): boolean {
    const column = this.IncrementSummaryTableHideShowAllData.find((item: any) => item.fieldName.trim() === fieldName.trim());
    return column ? column.isVisible : false;
  }

  searchIncrementSummaryTableData: any = null;
  onIncrementSummarySearch(data: any) {
    var search = '';
    this.searchIncrementSummaryTableData = data;
    if (data == '') {
      this.searchIncrementSummaryTableData = null;
      this.getIncrementSummaryData();
      return;
    }
    if (data.length > 0) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            this.getIncrementSummaryData();
          }, 500);
        }
      }, 1500);
    }
  }

  getIncrementSummaryData() {
    const request = {
      band: [],
      companyId: this.loggedInUserCompanyID,
      department: [],
      employeeId: [],
      fromYear: this.incrementFromYear,
      isEligible: true,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      manager: [],
      search: this.searchIncrementSummaryTableData,
      toYear: this.incrementToYear
    };

    this.httpService.callPostService(this.config.getIncrementSummary, request).subscribe((result: any) => {
      this.getIncrementSummaryTableData = result?.data || [];

      // rebuild grid data based on new API response
      this.buildIncrementSummaryRowDataFromTableData();
      this.buildIncrementSummaryPinnedBottomRows();

      if (this.gridApiIncrementSummary) {
        this.gridApiIncrementSummary.sizeColumnsToFit();
      }
    });
  }

  incrementSummaryRowClassRules: any = {
    'row-band-total': (params: any) => params.data?.rowType === 'bandTotal',
    'row-grand-total': (params: any) => params.data?.rowType === 'grandTotal',
    'department-total-row': (params: any) => params.data?.rowType === 'departmentTotal'
  };

  getDepartmentTotal(employeeSummaryData: { [key: string]: any }[], key: string): number {
    const total = employeeSummaryData.reduce((acc, employee) => {
      const value = parseFloat(employee[key]);
      return acc + (isNaN(value) ? 0 : value);
    }, 0);
    return total;
  }

  getOverallTotal(property: string): number {
    let total = 0;
    this.getIncrementSummaryTableData.forEach((department: any) => {
      department.employeeSummaryData.forEach((employee: any) => {
        total += employee[property];
      });
    });
    return total;
  }

  getGrandTotal(key: string): number {
    if (key === 'variancePercentage') {
      let variancePercentageSum = 0;
      let count = 0;

      this.getIncrementSummaryTableData.forEach((department: any) => {
        department.employeeSummaryData.forEach((employee: any) => {
          if (employee.variancePercentage != null) {
            variancePercentageSum += parseFloat(employee.variancePercentage);
            count++;
          }
        });
      });

      return count > 0 ? parseFloat((variancePercentageSum / count).toFixed(2)) : 0;
    } else {
      return this.getIncrementSummaryTableData.reduce((acc: any, department: any) => {
        return (acc += this.getDepartmentTotal(department.employeeSummaryData, key));
      }, 0);
    }
  }

  getAggregatedBandTotals(): any[] {
    const bandTotals: any = {};
    this.getIncrementSummaryTableData.forEach((department: any) => {
      department.employeeSummaryData.forEach((employee: any) => {
        if (!bandTotals[employee.band]) {
          bandTotals[employee.band] = {
            totalEmp: 0,
            totalFixedCtc: 0,
            eligibleEmp: 0,
            eligibleEmpFixedCtc: 0,
            overallIncrementBudget: 0,
            incrementAmount: 0,
            noOfPromotions: 0,
            promotionAmount: 0,
            noOfMarketCorrections: 0,
            marketCorrectionAmount: 0,
            finalIncrementAmount: 0,
            variance: 0,
            variancePercentageSum: 0,
            variancePercentageCount: 0
          };
        }

        // Summing numeric values
        bandTotals[employee.band].totalEmp += parseInt(employee.totalEmp || '0');
        bandTotals[employee.band].totalFixedCtc += parseFloat(employee.totalFixedCtc || '0');
        bandTotals[employee.band].eligibleEmp += parseFloat(employee.eligibleEmp || '0');
        bandTotals[employee.band].eligibleEmpFixedCtc += parseFloat(employee.eligibleEmpFixedCtc || '0');
        bandTotals[employee.band].overallIncrementBudget += parseFloat(employee.overallIncrementBudget || '0');
        bandTotals[employee.band].incrementAmount += parseFloat(employee.incrementAmount || '0');
        bandTotals[employee.band].noOfPromotions += parseFloat(employee.noOfPromotions || '0');
        bandTotals[employee.band].promotionAmount += parseFloat(employee.promotionAmount || '0');
        bandTotals[employee.band].noOfMarketCorrections += parseFloat(employee.noOfMarketCorrections || '0');
        bandTotals[employee.band].marketCorrectionAmount += parseFloat(employee.marketCorrectionAmount || '0');
        bandTotals[employee.band].finalIncrementAmount += parseFloat(employee.finalIncrementAmount || '0');
        bandTotals[employee.band].variance += parseFloat(employee.variance || '0');
        if (employee.variancePercentage != null) {
          bandTotals[employee.band].variancePercentageSum += parseFloat(employee.variancePercentage);
          bandTotals[employee.band].variancePercentageCount++;
        }
      });
    });

    // Map to final result array
    return Object.keys(bandTotals).map(band => ({
      band: band,
      totalEmp: bandTotals[band].totalEmp,
      totalFixedCtc: bandTotals[band].totalFixedCtc,
      eligibleEmp: bandTotals[band].eligibleEmp,
      eligibleEmpFixedCtc: bandTotals[band].eligibleEmpFixedCtc,
      overallIncrementBudget: bandTotals[band].overallIncrementBudget,
      incrementAmount: bandTotals[band].incrementAmount,
      noOfPromotions: bandTotals[band].noOfPromotions,
      promotionAmount: bandTotals[band].promotionAmount,
      noOfMarketCorrections: bandTotals[band].noOfMarketCorrections,
      marketCorrectionAmount: bandTotals[band].marketCorrectionAmount,
      finalIncrementAmount: bandTotals[band].finalIncrementAmount,
      variance: bandTotals[band].variance,
      variancePercentage: bandTotals[band].variancePercentageCount > 0 ? (bandTotals[band].variancePercentageSum / bandTotals[band].variancePercentageCount).toFixed(2) : '0.00'
    }));
  }

  onClickDownloadIncrementSummaryExcelFile(id: any) {
    this.loader.simpleLoader();
    this.isShowExcelData = true;
    setTimeout(() => {
      const tableId = id;
      const table = document.getElementById(tableId) as HTMLTableElement;
      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
      if (!table) {
        alert('Table not found!');
        return;
      }
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `Increment_Summary_${formattedDate}.xlsx`);
      this.isShowExcelData = false;
      this.loader.dismissLoader();
    }, 1000);
  }

  // Increment Reports

  IncrementReportsTableHideShowAllData: any[] = [];
  activeIncrementReportsTab: any = true;
  getIncrementReportsEligibleTableData: any[] = [];
  getIncrementReportsNonEligibleTableData: any[] = [];
  reportsTotalEligibleCount: any;
  reportsTotalNonEligibleCount: any;

  selectedIncrementReportDep: any;
  selectedIncrementReportBand: any;
  selectedIncrementReportDesignation: any;
  selectedIncrementReportManager: any;
  selectedIncrementReportEmployee: any;
  selectedIncrementReportPromotion: any;
  selectedIncrementReportMarketCorr: any;
  selectedIncrementReportRating: any;

  getIncrementReportBandList: any[] = [];
  getIncrementReportDesignationList: any[] = [];
  getIncrementReportManagerList: any[] = [];
  getIncrementReportEmployeeList: any[] = [];
  getIncrementReportPromotionList: any[] = [];
  getIncrementReportMarketCorrList: any[] = [];
  getIncrementReportRatingList: any[] = [];

  // onClickIncrementReportsActiveTab(data: any) {
  //   this.activeIncrementReportsTab = data;
  //   this.checkIncrementDepartment = this.activeIncrementReportsTab ?? false;

  //   this.selectedIncrementReportDep = '';
  //   this.selectedIncrementReportBand = '';
  //   this.selectedIncrementReportDesignation = "";
  //   this.selectedIncrementReportManager = "";
  //   this.selectedIncrementReportEmployee = "";
  //   this.selectedIncrementReportPromotion = "";
  //   this.selectedIncrementReportMarketCorr = "";
  //   this.selectedIncrementReportRating = "";
  //   this.getDepartmentByYear();
  //   this.checkStatusForIncrementSetup()
  // }

  onSelectIncrementReportDep() {
    if (this.selectedIncrementReportDep.length > 0) {
      this.getIncrementReportBandList = [];
      this.selectedIncrementReportBand = '';
      this.getIncrementReportDesignationList = [];
      this.selectedIncrementReportDesignation = '';
      this.getIncrementReportManagerList = [];
      this.selectedIncrementReportManager = '';
      this.getIncrementReportEmployeeList = [];
      this.selectedIncrementReportEmployee = '';
      this.selectedIncrementReportPromotion = '';
      this.selectedIncrementReportMarketCorr = '';
      this.getIncrementReportRatingList = [];
      this.selectedIncrementReportRating = '';
      this.getIncrementReportBandByDep();
      this.getIncrementReportsEligibleData();
      this.getIncrementReportsNonEligibleData();
    }
  }

  onDeSelectIncrementReportDep() {
    this.getIncrementReportBandList = [];
    this.selectedIncrementReportBand = '';
    this.getIncrementReportDesignationList = [];
    this.selectedIncrementReportDesignation = '';
    this.getIncrementReportManagerList = [];
    this.selectedIncrementReportManager = '';
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = '';
    this.selectedIncrementReportPromotion = '';
    this.selectedIncrementReportMarketCorr = '';
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';

    this.getIncrementReportBandByDep();
    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  selectAllIncrementReportDep(items: any): void {
    this.selectedIncrementReportDep = items;
    this.getIncrementReportBandList = [];
    this.selectedIncrementReportBand = '';
    this.getIncrementReportDesignationList = [];
    this.selectedIncrementReportDesignation = '';
    this.getIncrementReportManagerList = [];
    this.selectedIncrementReportManager = '';
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = '';
    this.selectedIncrementReportPromotion = '';
    this.selectedIncrementReportMarketCorr = '';
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';

    this.onSelectIncrementReportDep();
  }

  onDeSelectAllIncrementReportDep() {
    this.selectedIncrementReportDep = [];
    this.getIncrementReportBandList = [];
    this.selectedIncrementReportBand = '';
    this.getIncrementReportDesignationList = [];
    this.selectedIncrementReportDesignation = '';
    this.getIncrementReportManagerList = [];
    this.selectedIncrementReportManager = '';
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = '';
    this.selectedIncrementReportPromotion = '';
    this.selectedIncrementReportMarketCorr = '';
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';

    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  // Select Band

  getIncrementReportBandByDep() {
    const request: any = {
      fromYear: this.incrementFromYear,
      toYear: this.incrementToYear,
      companyId: this.loggedInUserCompanyID,
      department: this.selectedIncrementReportDep.map((dept: any) => dept.name),
      isEligible: this.checkIncrementDepartment
    };
    this.httpService.callPostService(this.config.getBandListByDepartment, request).subscribe((result: any) => {
      if (result.data) {
        this.getIncrementReportBandList = result.data
          .map((ele: any) => ({
            id: ele,
            name: ele
          }))
          .sort((a: any, b: any) => a.name.localeCompare(b.name));
      }
    });
  }

  onSelectIncrementReportBand() {
    if (this.selectedIncrementReportBand.length > 0) {
      this.getIncrementReportDesignationList = [];
      this.selectedIncrementReportDesignation = '';
      this.getIncrementReportManagerList = [];
      this.selectedIncrementReportManager = '';
      this.getIncrementReportEmployeeList = [];
      this.selectedIncrementReportEmployee = '';
      this.selectedIncrementReportPromotion = '';
      this.selectedIncrementReportMarketCorr = '';
      this.getIncrementReportRatingList = [];
      this.selectedIncrementReportRating = '';

      this.getIncrementReportsDesignation();
      this.getIncrementReportsEligibleData();
      this.getIncrementReportsNonEligibleData();
    }
  }

  onDeSelectIncrementReportBand() {
    this.getIncrementReportDesignationList = [];
    this.selectedIncrementReportDesignation = '';
    this.getIncrementReportManagerList = [];
    this.selectedIncrementReportManager = '';
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = '';
    this.selectedIncrementReportPromotion = '';
    this.selectedIncrementReportMarketCorr = '';
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';

    this.getIncrementReportsDesignation();
    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  selectAllIncrementReportBand(items: any): void {
    this.selectedIncrementReportBand = items;
    this.onSelectIncrementReportBand();
  }

  onDeSelectAllIncrementReportBand() {
    this.selectedIncrementReportBand = [];
    this.getIncrementReportDesignationList = [];
    this.selectedIncrementReportDesignation = '';
    this.getIncrementReportManagerList = [];
    this.selectedIncrementReportManager = '';
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = '';
    this.selectedIncrementReportPromotion = '';
    this.selectedIncrementReportMarketCorr = '';
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';

    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  // Designation

  getIncrementReportsDesignation() {
    const request = {
      bands: this.selectedIncrementReportBand.map((band: any) => band.name),
      companyId: this.loggedInUserCompanyID,
      department: this.selectedIncrementReportDep.map((dept: any) => dept.name),
      fromYear: this.incrementFromYear,
      toYear: this.incrementToYear
    };
    this.httpService.callPostService(this.config.getDesignationsFromBands, request).subscribe((result: any) => {
      if (result.data) {
        this.getIncrementReportDesignationList = result.data
          .map((ele: any) => ({
            id: ele,
            name: ele
          }))
          .sort((a: any, b: any) => a.name.localeCompare(b.name));
      }
    });
  }

  onSelectIncrementReportDesignation() {
    if (this.selectedIncrementReportDesignation.length > 0) {
      this.getIncrementReportManagerList = [];
      this.selectedIncrementReportManager = '';
      this.getIncrementReportEmployeeList = [];
      this.selectedIncrementReportEmployee = '';
      this.selectedIncrementReportPromotion = '';
      this.selectedIncrementReportMarketCorr = '';
      this.getIncrementReportRatingList = [];
      this.selectedIncrementReportRating = '';

      this.getIncrementReportManagerByDesignation();
      this.getIncrementReportsEligibleData();
      this.getIncrementReportsNonEligibleData();
    }
  }

  onDeSelectIncrementReportDesignation() {
    this.getIncrementReportManagerList = [];
    this.selectedIncrementReportManager = '';
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = '';
    this.selectedIncrementReportPromotion = '';
    this.selectedIncrementReportMarketCorr = '';
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';

    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  selectAllIncrementReportDesignation(item: any) {
    this.selectedIncrementReportDesignation = item;

    this.onSelectIncrementReportDesignation();
  }

  onDeSelectAllIncrementReportDesignation() {
    this.selectedIncrementReportDesignation = [];
    this.getIncrementReportManagerList = [];
    this.selectedIncrementReportManager = '';
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = '';
    this.selectedIncrementReportPromotion = '';
    this.selectedIncrementReportMarketCorr = '';
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';

    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  // Select Manager

  getIncrementReportManagerByDesignation() {
    const request: any = {
      bands: this.selectedIncrementReportBand.map((band: any) => band.name),
      companyId: this.loggedInUserCompanyID,
      department: this.selectedIncrementReportDep.map((dept: any) => dept.name),
      fromYear: this.incrementFromYear,
      toYear: this.incrementToYear,
      isEligible: this.checkIncrementDepartment
    };
    this.httpService.callPostService(this.config.getManagerListByBand, request).subscribe((result: any) => {
      if (result.data) {
        this.getIncrementReportManagerList = result.data
          .map((ele: any) => ({
            name: ele.name,
            id: ele.id
          }))
          .sort((a: any, b: any) => a.name.localeCompare(b.name));
      }
    });
  }

  onSelectIncrementReportManager() {
    if (this.selectedIncrementReportManager.length > 0) {
      this.getIncrementReportEmployeeList = [];
      this.selectedIncrementReportEmployee = '';
      this.selectedIncrementReportPromotion = '';
      this.selectedIncrementReportMarketCorr = '';
      this.getIncrementReportRatingList = [];
      this.selectedIncrementReportRating = '';

      this.getIncrementReportsEmployeeByManager();
      this.getIncrementReportsEligibleData();
      this.getIncrementReportsNonEligibleData();
    }
  }

  onDeSelectIncrementReportManager() {
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = '';
    this.selectedIncrementReportPromotion = '';
    this.selectedIncrementReportMarketCorr = '';
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';

    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  selectAllIncrementReportManager(item: any) {
    this.selectedIncrementReportManager = item;
    this.onSelectIncrementReportManager();
  }

  onDeSelectAllIncrementReportManager() {
    this.selectedIncrementReportManager = [];
    this.getIncrementReportEmployeeList = [];
    this.selectedIncrementReportEmployee = '';
    this.selectedIncrementReportPromotion = '';
    this.selectedIncrementReportMarketCorr = '';
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';

    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  //  select Employee

  getIncrementReportsEmployeeByManager() {
    const request = {
      bands: this.selectedIncrementReportBand.map((band: any) => band.name),
      companyId: this.loggedInUserCompanyID,
      department: this.selectedIncrementReportDep.map((dept: any) => dept.name),
      fromYear: this.incrementFromYear,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      toYear: this.incrementToYear,
      userId: this.selectedIncrementReportManager.map((ele: any) => ele.id),
      isEligible: this.checkIncrementDepartment
    };
    this.httpService.callPostService(this.config.getEmployeesListByManager, request).subscribe((result: any) => {
      if (result.data) {
        this.getIncrementReportEmployeeList = result.data
          .map((ele: any) => ({
            name: ele.name,
            id: ele.id
          }))
          .sort((a: any, b: any) => a.name.localeCompare(b.name));
      }
    });
  }

  onSelectIncrementReportEmployee() {
    if (this.selectedIncrementReportEmployee.length > 0) {
      this.getIncrementReportPromotionList = [];
      this.getIncrementReportMarketCorrList = [];
      this.getIncrementReportRatingList = [];
      this.selectedIncrementReportRating = '';
      this.selectedIncrementReportPromotion = '';
      this.selectedIncrementReportMarketCorr = '';
      this.getIncrementReportRatingList = [];
      this.selectedIncrementReportRating = '';

      this.getIncrementReportsEligibleData();
      this.getIncrementReportsNonEligibleData();
    }
  }

  onDeSelectIncrementReportEmployee() {
    this.getIncrementReportPromotionList = [];
    this.getIncrementReportMarketCorrList = [];
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';
    this.selectedIncrementReportPromotion = '';
    this.selectedIncrementReportMarketCorr = '';
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';

    this.onSelectIncrementReportEmployee();
    this.getIncrementReportsEligibleData();
  }

  selectAllIncrementReportEmployee(item: any) {
    this.selectedIncrementReportEmployee = item;
    this.getIncrementReportPromotionList = [];
    this.getIncrementReportMarketCorrList = [];
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';
    this.selectedIncrementReportPromotion = '';
    this.selectedIncrementReportMarketCorr = '';
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';

    this.onSelectIncrementReportEmployee();
  }

  onDeSelectAllIncrementReportEmployee() {
    this.selectedIncrementReportEmployee = [];
    this.getIncrementReportEmployeeList = [];
    this.getIncrementReportPromotionList = [];
    this.getIncrementReportMarketCorrList = [];
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';
    this.selectedIncrementReportPromotion = '';
    this.selectedIncrementReportMarketCorr = '';
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';

    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  // Promotion
  onSelectIncrementReportPromotion() {
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';

    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  // Market Correction
  onSelectIncrementReportMarketCorr() {
    this.getIncrementReportRatingList = [];
    this.selectedIncrementReportRating = '';

    this.getIncrementReportRatings();
    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  // Rating

  getIncrementReportRatings() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.incrementFromYear,
      toYear: this.incrementToYear,
      userId: this.selectedIncrementReportEmployee.map((ele: any) => ele.id)
    };
    this.httpService.callPostService(this.config.getRatingsByUserId, request).subscribe((result: any) => {
      this.getIncrementReportRatingList = result.data
        .map((ele: any) => ({
          name: ele,
          id: ele
        }))
        .sort((a: any, b: any) => a.name.localeCompare(b.name));
    });
  }

  onSelectIncrementReportRating() {
    if (this.selectedIncrementReportRating.length > 0) {
      this.getIncrementReportsEligibleData();
      this.getIncrementReportsNonEligibleData();
    }
  }

  onDeSelectIncrementReportRating() {
    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  selectAllIncrementReportRating(item: any) {
    this.selectedIncrementReportRating = item;
    this.onSelectIncrementReportRating();
  }

  onDeSelectAllIncrementReportRating() {
    this.selectedIncrementReportRating = [];
    this.getIncrementReportsEligibleData();
    this.getIncrementReportsNonEligibleData();
  }

  getIncrementReportsTableHideShowAllData() {
    if (this.onSelectIncrementTotalCTC == 'Fixed Annual CTC') {
      this.incrementCtcPerMonth = 'Fixed CTC p.m.';
      this.incrementCtcPerYear = 'Fixed CTC p.a.';
    } else {
      this.incrementCtcPerMonth = 'Total CTC p.m.';
      this.incrementCtcPerYear = 'Total CTC p.a.';
    }
    this.IncrementReportsTableHideShowAllData = [
      {
        fieldId: 1,
        isVisible: true,
        fieldName: 'Department',
        position: 1,
        isEditable: true
      },
      {
        fieldId: 2,
        isVisible: true,
        fieldName: 'Band',
        position: 2,
        isEditable: true
      },
      {
        fieldId: 3,
        isVisible: true,
        fieldName: 'Employee',
        position: 3,
        isEditable: true
      },
      {
        fieldId: 4,
        isVisible: true,
        fieldName: 'Manager',
        position: 4,
        isEditable: true
      },
      {
        fieldId: 5,
        isVisible: true,
        fieldName: 'HOD',
        position: 5,
        isEditable: true
      },
      {
        fieldId: 6,
        isVisible: true,
        fieldName: 'Designation',
        position: 6,
        isEditable: true
      },
      {
        fieldId: 7,
        isVisible: true,
        fieldName: 'DOJ',
        position: 7,
        isEditable: true
      },
      {
        fieldId: 8,
        isVisible: true,
        fieldName: this.incrementCtcPerMonth,
        position: 8,
        isEditable: true
      },
      {
        fieldId: 9,
        isVisible: true,
        fieldName: this.incrementCtcPerYear,
        position: 9,
        isEditable: true
      },
      {
        fieldId: 10,
        isVisible: true,
        fieldName: 'Eligible Emp.',
        position: 10,
        isEditable: true
      },
      {
        fieldId: 11,
        isVisible: true,
        fieldName: 'Individual KPI + Competency Score',
        position: 11,
        isEditable: true
      },
      {
        fieldId: 12,
        isVisible: true,
        fieldName: 'Department Score (out of 100)',
        position: 12,
        isEditable: true
      },
      {
        fieldId: 13,
        isVisible: true,
        fieldName: 'Company Score (out of 100)',
        position: 13,
        isEditable: true
      },
      {
        fieldId: 14,
        isVisible: true,
        fieldName: 'Final Score',
        position: 14,
        isEditable: true
      },
      {
        fieldId: 15,
        isVisible: true,
        fieldName: 'Final Rating',
        position: 15,
        isEditable: true
      },
      {
        fieldId: 16,
        isVisible: true,
        fieldName: 'Increment %',
        position: 16,
        isEditable: true
      },
      {
        fieldId: 17,
        isVisible: true,
        fieldName: 'Days Served in the Increment Period',
        position: 17,
        isEditable: true
      },
      {
        fieldId: 18,
        isVisible: true,
        fieldName: 'Prorated Increment %',
        position: 18,
        isEditable: true
      },
      {
        fieldId: 19,
        isVisible: true,
        fieldName: 'Increment Amount',
        position: 19,
        isEditable: true
      },
      {
        fieldId: 20,
        isVisible: true,
        fieldName: 'No Promotion Last 3 Year',
        position: 20,
        isEditable: true
      },
      {
        fieldId: 21,
        isVisible: true,
        fieldName: 'Promotion',
        position: 21,
        isEditable: true
      },
      {
        fieldId: 22,
        isVisible: true,
        fieldName: 'Promotion %',
        position: 22,
        isEditable: true
      },
      {
        fieldId: 23,
        isVisible: true,
        fieldName: 'Promotion Amount',
        position: 23,
        isEditable: true
      },
      {
        fieldId: 24,
        isVisible: true,
        fieldName: 'Updated CTC after Increment & Promotion',
        position: 24,
        isEditable: true
      },
      {
        fieldId: 25,
        isVisible: true,
        fieldName: 'Market BenchMark CTC',
        position: 25,
        isEditable: true
      },
      {
        fieldId: 26,
        isVisible: true,
        fieldName: 'Market Correction %',
        position: 26,
        isEditable: true
      },
      {
        fieldId: 27,
        isVisible: true,
        fieldName: 'Market Correction Amount',
        position: 27,
        isEditable: true
      },
      {
        fieldId: 28,
        isVisible: true,
        fieldName: 'Final Increment % p.a',
        position: 28,
        isEditable: true
      },
      {
        fieldId: 29,
        isVisible: true,
        fieldName: `Increment % in ${new Date().getFullYear() - 3}`,
        position: 29,
        isEditable: true
      },
      {
        fieldId: 30,
        isVisible: true,
        fieldName: `Increment % in ${new Date().getFullYear() - 2}`,
        position: 30,
        isEditable: true
      },
      {
        fieldId: 31,
        isVisible: true,
        fieldName: `Increment % in ${new Date().getFullYear() - 1}`,
        position: 31,
        isEditable: true
      },
      {
        fieldId: 32,
        isVisible: true,
        fieldName: 'HOD Approved Increment %',
        position: 32,
        isEditable: true
      },
      {
        fieldId: 33,
        isVisible: true,
        fieldName: 'HR Admin & MD/CEO Approved Increment %',
        position: 33,
        isEditable: true
      },
      {
        fieldId: 34,
        isVisible: true,
        fieldName: 'Final Increment Amount',
        position: 34,
        isEditable: true
      },
      {
        fieldId: 35,
        isVisible: true,
        fieldName: 'Final Annual Revised CTC (post increment)',
        position: 35,
        isEditable: true
      },
      {
        fieldId: 36,
        isVisible: true,
        fieldName: 'Final Monthly Revised CTC (post increment)',
        position: 36,
        isEditable: true
      },
      {
        fieldId: 37,
        isVisible: true,
        fieldName: 'Increment Letter Format',
        position: 37,
        isEditable: true
      }
    ];
  }

  searchIncrementReportTableData: any = null;
  onIncrementReportSearch(data: any) {
    var search = '';
    this.searchIncrementReportTableData = data;
    if (data == '') {
      this.searchIncrementReportTableData = null;
      this.getIncrementReportsEligibleData();
      this.getIncrementReportsNonEligibleData();
      return;
    }
    if (data.length > 0) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            this.getIncrementReportsEligibleData();
            this.getIncrementReportsNonEligibleData();
          }, 500);
        }
      }, 1500);
    }
  }

  onClickIncrementReportsFileDownload(status: any) {
    let flattenedData: any = [];
    if (status == true) {
      flattenedData = this.getIncrementReportsEligibleTableData.forEach((department: any) => department.bandGrades.forEach((band: any) => band.employeeData.forEach((employee: any) => {})));
    } else if (status == false) {
    }

    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data']
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    const fileName = 'Increment_Reports_data.xlsx';
    saveAs(data, fileName);
  }

  getIncrementReportsEligibleData() {
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      if (this.selectedIncrementReportDep || this.selectedIncrementReportBand || this.selectedIncrementReportDesignation || this.selectedIncrementReportManager || this.selectedIncrementReportEmployee || this.selectedIncrementReportPromotion || this.selectedIncrementReportMarketCorr || this.selectedIncrementReportRating) {
        const request = {
          band: this.selectedIncrementReportBand.length > 0 ? this.selectedIncrementReportBand?.map((band: any) => band.name) : [],
          companyId: this.loggedInUserCompanyID,
          department: this.selectedIncrementReportDep.length > 0 ? this.selectedIncrementReportDep?.map((band: any) => band.name) : [],
          designation: this.selectedIncrementReportDesignation.length > 0 ? this.selectedIncrementReportDesignation?.map((band: any) => band.name) : [],
          employeeId: this.selectedIncrementReportEmployee.length > 0 ? this.selectedIncrementReportEmployee?.map((ele: any) => ele.id) : [],
          fromYear: this.incrementFromYear,
          isEligible: true,
          isHod: true,
          manager: this.selectedIncrementReportManager.length > 0 ? this.selectedIncrementReportManager?.map((ele: any) => ele.id) : [],
          marketCorrection: this.selectedIncrementReportMarketCorr,
          promotion: this.selectedIncrementReportPromotion,
          ratings: this.selectedIncrementReportRating.length > 0 ? this.selectedIncrementReportRating?.map((band: any) => band.name) : [],
          search: this.searchIncrementReportTableData,
          toYear: this.incrementToYear
        };
        this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
          this.getIncrementReportsEligibleTableData = result.data;
          // wire flattened rows to the AG Grid
          this.applyReportDataToGrid(this.getIncrementReportsEligibleTableData);
          this.calculateReportsEligibleTotals(this.getIncrementReportsEligibleTableData);
          this.reportsTotalEligibleCount = this.getIncrementReportsEligibleTableData.reduce((total: number, department: any) => {
            return (
              total +
              department.bandGrades.reduce((bandTotal: number, band: any) => {
                return bandTotal + band.employeeData.length;
              }, 0)
            );
          }, 0);
        });
      } else {
        const request = {
          band: [],
          companyId: this.loggedInUserCompanyID,
          department: [],
          designation: [],
          employeeId: [],
          fromYear: this.incrementFromYear,
          isEligible: true,
          isHod: true,
          manager: [],
          marketCorrection: null,
          promotion: null,
          ratings: [],
          search: this.searchIncrementReportTableData,
          toYear: this.incrementToYear
        };
        this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
          this.getIncrementReportsEligibleTableData = result.data;
          // wire flattened rows to the AG Grid
          this.applyReportDataToGrid(this.getIncrementReportsEligibleTableData);
          this.calculateReportsEligibleTotals(this.getIncrementReportsEligibleTableData);
          this.reportsTotalEligibleCount = this.getIncrementReportsEligibleTableData.reduce((total: number, department: any) => {
            return (
              total +
              department.bandGrades.reduce((bandTotal: number, band: any) => {
                return bandTotal + band.employeeData.length;
              }, 0)
            );
          }, 0);
        });
      }
    } else {
      if (this.selectedIncrementReportDep || this.selectedIncrementReportBand || this.selectedIncrementReportDesignation || this.selectedIncrementReportManager || this.selectedIncrementReportEmployee || this.selectedIncrementReportPromotion || this.selectedIncrementReportMarketCorr || this.selectedIncrementReportRating) {
        const request = {
          band: this.selectedIncrementReportBand.length > 0 ? this.selectedIncrementReportBand?.map((band: any) => band.name) : [],
          companyId: this.loggedInUserCompanyID,
          department: this.selectedIncrementReportDep.length > 0 ? this.selectedIncrementReportDep.map((dept: any) => dept.name) : [],
          designation: this.selectedIncrementReportDesignation.length > 0 ? this.selectedIncrementReportDesignation?.map((band: any) => band.name) : [],
          employeeId: this.selectedIncrementReportEmployee.length > 0 ? this.selectedIncrementReportEmployee?.map((ele: any) => ele.id) : [],
          fromYear: this.incrementFromYear,
          isEligible: true,
          isHod: false,
          manager: this.selectedIncrementReportManager.length > 0 ? this.selectedIncrementReportManager?.map((ele: any) => ele.id) : [],
          marketCorrection: this.selectedIncrementReportMarketCorr,
          promotion: this.selectedIncrementReportPromotion,
          ratings: this.selectedIncrementReportRating.length > 0 ? this.selectedIncrementReportRating?.map((band: any) => band.name) : [],
          search: this.searchIncrementReportTableData,
          toYear: this.incrementToYear
        };
        this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
          console.log(result.data);

          // this.getIncrementReportsEligibleTableData = result.data;
          const hasFilter = this.selectedIncrementReportDep || this.selectedIncrementReportBand || this.selectedIncrementReportDesignation || this.selectedIncrementReportManager || this.selectedIncrementReportEmployee || this.selectedIncrementReportPromotion || this.selectedIncrementReportMarketCorr || this.selectedIncrementReportRating;
          console.log('result.data?.bandGrades', result.data[0]?.bandGrades);
          const isMarketCorrSelected = this.selectedIncrementReportMarketCorr === true;
          const isMarketCorrUnselected = this.selectedIncrementReportMarketCorr === false;

          // Iterate through departments
          const filteredDepartments = (result.data || []).map((dept: any) => {
            const filteredBandGrades = (dept.bandGrades || []).map((band: any) => {
              let filteredEmployees = band.employeeData || [];

              if (isMarketCorrSelected) {
                filteredEmployees = filteredEmployees.filter((emp: any) => emp.marketCorrectionAmount > 0.0);
              } else if (isMarketCorrUnselected) {
                filteredEmployees = filteredEmployees.filter((emp: any) => emp.marketCorrectionAmount === 0.0);
              }

              console.log(filteredEmployees);

              return { ...band, employeeData: filteredEmployees };
            });

            return { ...dept, bandGrades: filteredBandGrades };
          });

          // ✅ Assign full structure (department → band → employee)
          this.getIncrementReportsEligibleTableData = filteredDepartments;
          // populate ag-grid rows from the nested response
          this.applyReportDataToGrid(this.getIncrementReportsEligibleTableData);

          // ✅ Calculate totals based on updated data
          this.calculateReportsEligibleTotals(this.getIncrementReportsEligibleTableData);

          // ✅ Calculate total eligible employee count safely
          this.reportsTotalEligibleCount = (this.getIncrementReportsEligibleTableData || []).reduce((total: number, department: any) => {
            const bandGrades = department.bandGrades || [];
            const deptTotal = bandGrades.reduce((bandTotal: number, band: any) => {
              const employees = band.employeeData || [];
              return bandTotal + employees.length;
            }, 0);
            return total + deptTotal;
          }, 0);

          console.log('reportsTotalEligibleCount', this.reportsTotalEligibleCount);

          console.log('reportsTotalEligibleCount', this.reportsTotalEligibleCount);
        });
      } else {
        const request = {
          band: [],
          companyId: this.loggedInUserCompanyID,
          department: [],
          designation: [],
          employeeId: [],
          fromYear: this.incrementFromYear,
          isEligible: true,
          isHod: false,
          manager: [],
          marketCorrection: null,
          promotion: null,
          ratings: [],
          search: this.searchIncrementReportTableData,
          toYear: this.incrementToYear
        };
        this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
          this.getIncrementReportsEligibleTableData = result.data;
          // wire flattened rows to the AG Grid
          this.applyReportDataToGrid(this.getIncrementReportsEligibleTableData);
          this.calculateReportsEligibleTotals(this.getIncrementReportsEligibleTableData);
          this.reportsTotalEligibleCount = this.getIncrementReportsEligibleTableData.reduce((total: number, department: any) => {
            return (
              total +
              department.bandGrades.reduce((bandTotal: number, band: any) => {
                return bandTotal + band.employeeData.length;
              }, 0)
            );
          }, 0);
        });
      }
    }
  }
  reportTotalEligibleTotalFixedCtcPM: any = 0;
  reportTotalEligibleTotalFixedCtcPA: any = 0;
  reportTotalEligibleEligibleEmp: any = 0;
  reportTotalEligibleIncrementPct: any = 0;
  reportTotalEligibleDaysServedinIncrementPeriod: any = 0;
  reportTotalEligibleProratedIncrementPct: any = 0;
  reportTotalEligibleHODIncrementPct: any = 0;
  reportTotalEligibleHrAndMdIncrementPct: any = 0;
  reportTotalEligibleIncrementAmount: any = 0;
  reportTotalEligibleNoOfPromotionPct: any = 0;
  reportTotalEligiblePromotionPct: any = 0;
  reportTotalEligiblePromotionAmount: any = 0;
  reportTotalEligibleupdatedCtcAfterIAndP: any = 0;
  reportTotalEligibleMarketBenchMarkCtc: any = 0;
  reportTotalEligiblemarketCorrectionPct: any = 0;
  reportTotalEligibleMarketCorrectionAmount: any = 0;
  reportTotalEligibleFinalIncrementPct: any = 0;
  reportTotalEligibleFinalIncrementAmount: any = 0;
  reportTotalEligibleFinalAnnualCtc: any = 0;
  reportTotalEligibleFinalMonthlyCtc: any = 0;

  calculateReportsEligibleTotals(data: any[]): void {
    // Initialize totals and counters for percentage fields
    this.reportTotalEligibleTotalFixedCtcPM = 0;
    this.reportTotalEligibleTotalFixedCtcPA = 0;
    this.reportTotalEligibleEligibleEmp = 0;
    this.reportTotalEligibleIncrementPct = 0;
    this.reportTotalEligibleDaysServedinIncrementPeriod = 0;
    this.reportTotalEligibleProratedIncrementPct = 0;
    this.reportTotalEligibleHODIncrementPct = 0;
    this.reportTotalEligibleHrAndMdIncrementPct = 0;
    this.reportTotalEligibleIncrementAmount = 0;
    this.reportTotalEligibleNoOfPromotionPct = 0;
    this.reportTotalEligiblePromotionPct = 0;
    this.reportTotalEligiblePromotionAmount = 0;
    this.reportTotalEligibleupdatedCtcAfterIAndP = 0;
    this.reportTotalEligibleMarketBenchMarkCtc = 0;
    this.reportTotalEligiblemarketCorrectionPct = 0;
    this.reportTotalEligibleMarketCorrectionAmount = 0;
    this.reportTotalEligibleFinalIncrementPct = 0;
    this.reportTotalEligibleFinalIncrementAmount = 0;
    this.reportTotalEligibleFinalAnnualCtc = 0;
    this.reportTotalEligibleFinalMonthlyCtc = 0;

    // Counters for averaging purposes
    let totalFinalIncrementPctCount = 0;
    let totalMarketCorrectionPctCount = 0;
    let totalPromotionPctCount = 0;
    let totalHODIncrementPctCount = 0;
    let totalHrAndMdIncrementPctCount = 0;
    let totalIncrementPctCount = 0;
    let totalDaysServedCount = 0;
    let totalProratedIncrementPctCount = 0;

    data?.forEach(department => {
      department?.bandGrades.forEach((bandGrade: any) => {
        bandGrade.employeeData.forEach((employee: any) => {
          if (employee.isEligible) {
            this.reportTotalEligibleTotalFixedCtcPM += parseFloat(employee.monthlyCtc || 0);
            this.reportTotalEligibleTotalFixedCtcPA += parseFloat(employee.annualCtc || 0);
            this.reportTotalEligibleEligibleEmp += 1;
            // IncrementPct and count
            if (employee.incrementPercentage !== null && employee.incrementPercentage !== undefined) {
              this.reportTotalEligibleIncrementPct += parseFloat(employee.incrementPercentage);
              totalIncrementPctCount++;
            }

            // DaysServed and count
            if (employee.daysServed !== null && employee.daysServed !== undefined) {
              this.reportTotalEligibleDaysServedinIncrementPeriod += parseFloat(employee.daysServed);
              totalDaysServedCount++;
            }

            // ProratedIncrementPct and count
            if (employee.proratedIncrementPercentage !== null && employee.proratedIncrementPercentage !== undefined) {
              this.reportTotalEligibleProratedIncrementPct += parseFloat(employee.proratedIncrementPercentage);
              totalProratedIncrementPctCount++;
            }

            // HODIncrementPct and count
            if (employee.hodIncrementPercentage !== null && employee.hodIncrementPercentage !== undefined) {
              this.reportTotalEligibleHODIncrementPct += parseFloat(employee.hodIncrementPercentage);
              totalHODIncrementPctCount++;
            }

            // HrAndMdIncrementPct and count
            if (employee.hrAndMdIncrementPercentage !== null && employee.hrAndMdIncrementPercentage !== undefined) {
              this.reportTotalEligibleHrAndMdIncrementPct += parseFloat(employee.hrAndMdIncrementPercentage);
              totalHrAndMdIncrementPctCount++;
            }

            // PromotionPct and count
            if (employee.promotionPercentage !== null && employee.promotionPercentage !== undefined) {
              this.reportTotalEligiblePromotionPct += parseFloat(employee.promotionPercentage);
              totalPromotionPctCount++;
            }

            this.reportTotalEligibleIncrementAmount += parseFloat(employee.incrementAmount || 0);
            this.reportTotalEligibleNoOfPromotionPct += parseFloat(employee.noOfPromotions || 0);
            this.reportTotalEligiblePromotionAmount += parseFloat(employee.promotionAmount || 0);
            this.reportTotalEligibleupdatedCtcAfterIAndP += parseFloat(employee.updatedCtcAfterIncrementAndPromotion || 0);
            this.reportTotalEligibleMarketBenchMarkCtc += parseFloat(employee.marketBenchMarkCtc || 0);

            // FinalIncrementPct and count
            if (employee.finalIncrementPercentage !== null && employee.finalIncrementPercentage !== undefined) {
              this.reportTotalEligibleFinalIncrementPct += parseFloat(employee.finalIncrementPercentage);
              totalFinalIncrementPctCount++;
            }

            // MarketCorrectionPct and count
            if (employee.marketCorrectionPercentage !== null && employee.marketCorrectionPercentage !== undefined) {
              this.reportTotalEligiblemarketCorrectionPct += parseFloat(employee.marketCorrectionPercentage);
              totalMarketCorrectionPctCount++;
            }

            this.reportTotalEligibleMarketCorrectionAmount += parseFloat(employee.marketCorrectionAmount || 0);
            this.reportTotalEligibleFinalIncrementAmount += parseFloat(employee.finalIncrementAmount || 0);
            this.reportTotalEligibleFinalAnnualCtc += parseFloat(employee.finalAnnualCtc || 0);
            this.reportTotalEligibleFinalMonthlyCtc += parseFloat(employee.finalMonthlyCtc || 0);
          }
        });
      });
    });

    // Calculate averages for all percentage fields with valid counts
    if (totalFinalIncrementPctCount > 0) {
      this.reportTotalEligibleFinalIncrementPct = parseFloat((this.reportTotalEligibleFinalIncrementPct / totalFinalIncrementPctCount).toFixed(2));
    }
    if (totalMarketCorrectionPctCount > 0) {
      this.reportTotalEligiblemarketCorrectionPct = parseFloat((this.reportTotalEligiblemarketCorrectionPct / totalMarketCorrectionPctCount).toFixed(2));
    }
    if (totalPromotionPctCount > 0) {
      this.reportTotalEligiblePromotionPct = parseFloat((this.reportTotalEligiblePromotionPct / totalPromotionPctCount).toFixed(2));
    }
    if (totalHODIncrementPctCount > 0) {
      this.reportTotalEligibleHODIncrementPct = parseFloat((this.reportTotalEligibleHODIncrementPct / totalHODIncrementPctCount).toFixed(2));
    }
    if (totalHrAndMdIncrementPctCount > 0) {
      this.reportTotalEligibleHrAndMdIncrementPct = parseFloat((this.reportTotalEligibleHrAndMdIncrementPct / totalHrAndMdIncrementPctCount).toFixed(2));
    }
    if (totalIncrementPctCount > 0) {
      this.reportTotalEligibleIncrementPct = parseFloat((this.reportTotalEligibleIncrementPct / totalIncrementPctCount).toFixed(2));
    }
    if (totalDaysServedCount > 0) {
      this.reportTotalEligibleDaysServedinIncrementPeriod = parseFloat((this.reportTotalEligibleDaysServedinIncrementPeriod / totalDaysServedCount).toFixed(2));
    }
    if (totalProratedIncrementPctCount > 0) {
      this.reportTotalEligibleProratedIncrementPct = parseFloat((this.reportTotalEligibleProratedIncrementPct / totalProratedIncrementPctCount).toFixed(2));
    }
  }

  getIncrementReportsNonEligibleData() {
    // helper to centralize how we handle the API response
    const handleNonEligibleResponse = (result: any) => {
      const data = result?.data || [];

      // keep the full nested structure (department -> bandGrades -> employeeData)
      this.getIncrementReportsNonEligibleTableData = data;

      // 🔹 Flatten for Non-Eligible AG Grid only
      const flatRows = this.buildGridRowsFromDepartments(data || []);

      // (optional) debug log
      const nestedCount = (data || []).reduce((tot: number, dept: any) => {
        return (
          tot +
          (dept.bandGrades || []).reduce((bt: number, band: any) => {
            return bt + (band.employeeData || []).length;
          }, 0)
        );
      }, 0);
      console.log('NON-ELIGIBLE buildGridRowsFromDepartments: nested employees =', nestedCount, 'flattened rows =', flatRows.length);

      // 🔸 bind to NON-ELIGIBLE grid rowData
      this.gridRowDataNonEligible = flatRows;

      // 🔸 push rows into NON-ELIGIBLE grid API ONLY
      const api: any = this.gridApiNonEligible;
      if (api && typeof api.setRowData === 'function') {
        try {
          api.setRowData(flatRows);
        } catch (e) {
          console.warn('setRowData (non-eligible) failed, using binding only', e);
        }
      }

      // 🔸 pinned bottom totals for non-eligible only
      if (typeof this.buildPinnedBottomTotalsNonEligible === 'function') {
        try {
          this.buildPinnedBottomTotalsNonEligible(flatRows);
        } catch (e) {
          console.warn('buildPinnedBottomTotalsNonEligible error', e);
        }
      }

      // 🔸 total employee count for non-eligible
      this.reportsTotalNonEligibleCount = (data || []).reduce((total: number, department: any) => {
        const bandGrades = department.bandGrades || [];
        const deptTotal = bandGrades.reduce((bandTotal: number, band: any) => {
          const employees = band.employeeData || [];
          return bandTotal + employees.length;
        }, 0);
        return total + deptTotal;
      }, 0);
    };

    // ------------------- HOD + MD COMBO BRANCHES -------------------
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      // with filters
      if (this.selectedIncrementReportDep || this.selectedIncrementReportBand || this.selectedIncrementReportDesignation || this.selectedIncrementReportManager || this.selectedIncrementReportEmployee || this.selectedIncrementReportPromotion || this.selectedIncrementReportMarketCorr || this.selectedIncrementReportRating) {
        const request = {
          band: this.selectedIncrementReportBand.length > 0 ? this.selectedIncrementReportBand.map((band: any) => band.name) : [],
          companyId: this.loggedInUserCompanyID,
          department: this.selectedIncrementReportDep.length > 0 ? this.selectedIncrementReportDep.map((band: any) => band.name) : [],
          designation: this.selectedIncrementReportDesignation.length > 0 ? this.selectedIncrementReportDesignation.map((band: any) => band.name) : [],
          employeeId: this.selectedIncrementReportEmployee.length > 0 ? this.selectedIncrementReportEmployee.map((ele: any) => ele.id) : [],
          fromYear: this.incrementFromYear,
          isEligible: false,
          isHod: true,
          manager: this.selectedIncrementReportManager.length > 0 ? this.selectedIncrementReportManager.map((ele: any) => ele.id) : [],
          marketCorrection: this.selectedIncrementReportMarketCorr,
          promotion: this.selectedIncrementReportPromotion,
          ratings: this.selectedIncrementReportRating.length > 0 ? this.selectedIncrementReportRating.map((band: any) => band.name) : [],
          search: this.searchIncrementReportTableData,
          toYear: this.incrementToYear
        };

        this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
          handleNonEligibleResponse(result);
          this.calculateReportsNonEligibleTotals(this.getIncrementReportsNonEligibleTableData);
        });
      } else {
        // HOD, no filters
        const request = {
          band: [],
          companyId: this.loggedInUserCompanyID,
          department: [],
          designation: [],
          employeeId: [],
          fromYear: this.incrementFromYear,
          isEligible: false,
          isHod: true,
          manager: [],
          marketCorrection: null,
          promotion: null,
          ratings: [],
          search: this.searchIncrementReportTableData,
          toYear: this.incrementToYear
        };

        this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
          handleNonEligibleResponse(result);
          this.calculateReportsNonEligibleTotals(this.getIncrementReportsNonEligibleTableData);
        });
      }
    } else {
      // ------------------- NON-HOD BRANCHES -------------------
      if (this.selectedIncrementReportDep || this.selectedIncrementReportBand || this.selectedIncrementReportDesignation || this.selectedIncrementReportManager || this.selectedIncrementReportEmployee || this.selectedIncrementReportPromotion || this.selectedIncrementReportMarketCorr || this.selectedIncrementReportRating) {
        const request = {
          band: this.selectedIncrementReportBand.length > 0 ? this.selectedIncrementReportBand.map((band: any) => band.name) : [],
          companyId: this.loggedInUserCompanyID,
          department: this.selectedIncrementReportDep.length > 0 ? this.selectedIncrementReportDep.map((band: any) => band.name) : [],
          designation: this.selectedIncrementReportDesignation.length > 0 ? this.selectedIncrementReportDesignation.map((band: any) => band.name) : [],
          employeeId: this.selectedIncrementReportEmployee.length > 0 ? this.selectedIncrementReportEmployee.map((ele: any) => ele.id) : [],
          fromYear: this.incrementFromYear,
          isEligible: false,
          isHod: false,
          manager: this.selectedIncrementReportManager.length > 0 ? this.selectedIncrementReportManager.map((ele: any) => ele.id) : [],
          marketCorrection: this.selectedIncrementReportMarketCorr,
          promotion: this.selectedIncrementReportPromotion,
          ratings: this.selectedIncrementReportRating.length > 0 ? this.selectedIncrementReportRating.map((band: any) => band.name) : [],
          search: this.searchIncrementReportTableData,
          toYear: this.incrementToYear
        };

        this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
          handleNonEligibleResponse(result);
          this.calculateReportsNonEligibleTotals(this.getIncrementReportsNonEligibleTableData);
        });
      } else {
        // NON-HOD, no filters
        const request = {
          band: [],
          companyId: this.loggedInUserCompanyID,
          department: [],
          designation: [],
          employeeId: [],
          fromYear: this.incrementFromYear,
          isEligible: false,
          isHod: false,
          manager: [],
          marketCorrection: null,
          promotion: null,
          ratings: [],
          search: this.searchIncrementReportTableData,
          toYear: this.incrementToYear
        };

        this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
          handleNonEligibleResponse(result);
          this.calculateReportsNonEligibleTotals(this.getIncrementReportsNonEligibleTableData);
        });
      }
    }
  }

  reportTotalNonEligibleTotalFixedCtcPM: any = 0;
  reportTotalNonEligibleTotalFixedCtcPA: any = 0;
  reportTotalNonEligibleEligibleEmp: any = 0;
  reportTotalNonEligibleIncrementPct: any = 0;
  reportTotalNonEligibleDaysServedinIncrementPeriod: any = 0;
  reportTotalNonEligibleProratedIncrementPct: any = 0;
  reportTotalNonEligibleHODIncrementPct: any = 0;
  reportTotalNonEligibleHrAndMdIncrementPct: any = 0;
  reportTotalNonEligibleIncrementAmount: any = 0;
  reportTotalNonEligibleNoOfPromotionPct: any = 0;
  reportTotalNonEligiblePromotionPct: any = 0;
  reportTotalNonEligiblePromotionAmount: any = 0;
  reportTotalNonEligibleupdatedCtcAfterIAndP: any = 0;
  reportTotalNonEligibleMarketBenchMarkCtc: any = 0;
  reportTotalNonEligiblemarketCorrectionPct: any = 0;
  reportTotalNonEligibleMarketCorrectionAmount: any = 0;
  reportTotalNonEligibleFinalIncrementPct: any = 0;
  reportTotalNonEligibleFinalIncrementAmount: any = 0;
  reportTotalNonEligibleFinalAnnualCtc: any = 0;
  reportTotalNonEligibleFinalMonthlyCtc: any = 0;

  calculateReportsNonEligibleTotals(data: any[]): void {
    // Initialize totals and counters for percentage fields
    this.reportTotalNonEligibleTotalFixedCtcPM = 0;
    this.reportTotalNonEligibleTotalFixedCtcPA = 0;
    this.reportTotalNonEligibleEligibleEmp = 0;
    this.reportTotalNonEligibleIncrementPct = 0;
    this.reportTotalNonEligibleDaysServedinIncrementPeriod = 0;
    this.reportTotalNonEligibleProratedIncrementPct = 0;
    this.reportTotalNonEligibleHODIncrementPct = 0;
    this.reportTotalNonEligibleHrAndMdIncrementPct = 0;
    this.reportTotalNonEligibleIncrementAmount = 0;
    this.reportTotalNonEligibleNoOfPromotionPct = 0;
    this.reportTotalNonEligiblePromotionPct = 0;
    this.reportTotalNonEligiblePromotionAmount = 0;
    this.reportTotalNonEligibleupdatedCtcAfterIAndP = 0;
    this.reportTotalNonEligibleMarketBenchMarkCtc = 0;
    this.reportTotalNonEligiblemarketCorrectionPct = 0;
    this.reportTotalNonEligibleMarketCorrectionAmount = 0;
    this.reportTotalNonEligibleFinalIncrementPct = 0;
    this.reportTotalNonEligibleFinalIncrementAmount = 0;
    this.reportTotalNonEligibleFinalAnnualCtc = 0;
    this.reportTotalNonEligibleFinalMonthlyCtc = 0;

    // Counters for averaging purposes
    let totalFinalIncrementPctCount = 0;
    let totalMarketCorrectionPctCount = 0;
    let totalPromotionPctCount = 0;
    let totalHODIncrementPctCount = 0;
    let totalHrAndMdIncrementPctCount = 0;
    let totalIncrementPctCount = 0;
    let totalDaysServedCount = 0;
    let totalProratedIncrementPctCount = 0;

    data?.forEach(department => {
      department.bandGrades.forEach((bandGrade: any) => {
        bandGrade.employeeData.forEach((employee: any) => {
          if (!employee.isEligible) {
            this.reportTotalNonEligibleTotalFixedCtcPM += parseFloat(employee.annualCtc || 0);
            this.reportTotalNonEligibleTotalFixedCtcPA += parseFloat(employee.annualCtc || 0);
            this.reportTotalNonEligibleEligibleEmp += 1;

            // IncrementPct and count
            if (employee.incrementPercentage !== null && employee.incrementPercentage !== undefined) {
              this.reportTotalNonEligibleIncrementPct += parseFloat(employee.incrementPercentage);
              totalIncrementPctCount++;
            }

            // DaysServed and count
            if (employee.daysServed !== null && employee.daysServed !== undefined) {
              this.reportTotalNonEligibleDaysServedinIncrementPeriod += parseFloat(employee.daysServed);
              totalDaysServedCount++;
            }

            // ProratedIncrementPct and count
            if (employee.proratedIncrementPercentage !== null && employee.proratedIncrementPercentage !== undefined) {
              this.reportTotalNonEligibleProratedIncrementPct += parseFloat(employee.proratedIncrementPercentage);
              totalProratedIncrementPctCount++;
            }

            // HODIncrementPct and count
            if (employee.hodIncrementPercentage !== null && employee.hodIncrementPercentage !== undefined) {
              this.reportTotalNonEligibleHODIncrementPct += parseFloat(employee.hodIncrementPercentage);
              totalHODIncrementPctCount++;
            }

            // HrAndMdIncrementPct and count
            if (employee.hrAndMdIncrementPercentage !== null && employee.hrAndMdIncrementPercentage !== undefined) {
              this.reportTotalNonEligibleHrAndMdIncrementPct += parseFloat(employee.hrAndMdIncrementPercentage);
              totalHrAndMdIncrementPctCount++;
            }

            // PromotionPct and count
            if (employee.promotionPercentage !== null && employee.promotionPercentage !== undefined) {
              this.reportTotalNonEligiblePromotionPct += parseFloat(employee.promotionPercentage);
              totalPromotionPctCount++;
            }

            this.reportTotalNonEligibleIncrementAmount += parseFloat(employee.incrementAmount || 0);
            this.reportTotalNonEligibleNoOfPromotionPct += parseFloat(employee.noOfPromotions || 0);
            this.reportTotalNonEligiblePromotionAmount += parseFloat(employee.promotionAmount || 0);
            this.reportTotalNonEligibleupdatedCtcAfterIAndP += parseFloat(employee.updatedCtcAfterIncrementAndPromotion || 0);
            this.reportTotalNonEligibleMarketBenchMarkCtc += parseFloat(employee.marketBenchMarkCtc || 0);

            // FinalIncrementPct and count
            if (employee.finalIncrementPercentage !== null && employee.finalIncrementPercentage !== undefined) {
              this.reportTotalNonEligibleFinalIncrementPct += parseFloat(employee.finalIncrementPercentage);
              totalFinalIncrementPctCount++;
            }

            // MarketCorrectionPct and count
            if (employee.marketCorrectionPercentage !== null && employee.marketCorrectionPercentage !== undefined) {
              this.reportTotalNonEligiblemarketCorrectionPct += parseFloat(employee.marketCorrectionPercentage);
              totalMarketCorrectionPctCount++;
            }

            this.reportTotalNonEligibleMarketCorrectionAmount += parseFloat(employee.marketCorrectionAmount || 0);
            this.reportTotalNonEligibleFinalIncrementAmount += parseFloat(employee.finalIncrementAmount || 0);
            this.reportTotalNonEligibleFinalAnnualCtc += parseFloat(employee.finalAnnualCtc || 0);
            this.reportTotalNonEligibleFinalMonthlyCtc += parseFloat(employee.finalMonthlyCtc || 0);
          }
        });
      });
    });

    // Calculate averages for all percentage fields with valid counts
    if (totalFinalIncrementPctCount > 0) {
      this.reportTotalNonEligibleFinalIncrementPct = parseFloat((this.reportTotalNonEligibleFinalIncrementPct / totalFinalIncrementPctCount).toFixed(2));
    }
    if (totalMarketCorrectionPctCount > 0) {
      this.reportTotalNonEligiblemarketCorrectionPct = parseFloat((this.reportTotalNonEligiblemarketCorrectionPct / totalMarketCorrectionPctCount).toFixed(2));
    }
    if (totalPromotionPctCount > 0) {
      this.reportTotalNonEligiblePromotionPct = parseFloat((this.reportTotalNonEligiblePromotionPct / totalPromotionPctCount).toFixed(2));
    }
    if (totalHODIncrementPctCount > 0) {
      this.reportTotalNonEligibleHODIncrementPct = parseFloat((this.reportTotalNonEligibleHODIncrementPct / totalHODIncrementPctCount).toFixed(2));
    }
    if (totalHrAndMdIncrementPctCount > 0) {
      this.reportTotalNonEligibleHrAndMdIncrementPct = parseFloat((this.reportTotalNonEligibleHrAndMdIncrementPct / totalHrAndMdIncrementPctCount).toFixed(2));
    }
    if (totalIncrementPctCount > 0) {
      this.reportTotalNonEligibleIncrementPct = parseFloat((this.reportTotalNonEligibleIncrementPct / totalIncrementPctCount).toFixed(2));
    }
    if (totalDaysServedCount > 0) {
      this.reportTotalNonEligibleDaysServedinIncrementPeriod = parseFloat((this.reportTotalNonEligibleDaysServedinIncrementPeriod / totalDaysServedCount).toFixed(2));
    }
    if (totalProratedIncrementPctCount > 0) {
      this.reportTotalNonEligibleProratedIncrementPct = parseFloat((this.reportTotalNonEligibleProratedIncrementPct / totalProratedIncrementPctCount).toFixed(2));
    }
  }

  onClickDownloadIncrementReportstExcelFile() {
    this.loader.simpleLoader();
    this.isShowExcelData = true;
    const tableName = this.activeIncrementReportsTab ? 'incrementReportsEligibleTable' : 'incrementReportsNonEligibleTable';
    if (tableName == 'incrementReportsEligibleTable') {
      setTimeout(() => {
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
        const flattenedData: any[] = [];
        const formatDate = (date: string) => {
          const formattedDate = new Date(date);
          return !isNaN(formattedDate.getTime()) ? formattedDate.toLocaleDateString('en-GB') : date;
        };
        const formatNum = (value: any) => {
          const num = parseFloat(value);
          return isNaN(num) ? '0.00' : num.toFixed(2);
        };
        const currentYear = new Date().getFullYear();
        const lastThreeYears = [currentYear - 3, currentYear - 2, currentYear - 1];
        this.getIncrementReportsEligibleTableData.forEach((department: any) => {
          department.bandGrades.forEach((band: any) => {
            band.employeeData.forEach((employee: any) => {
              flattenedData.push({
                Department: department.departmentName,
                Band: band.band,
                Employee: employee.employeeName,
                Manager: employee.managerName,
                HOD: employee.hodName,
                Designation: employee.designation,
                DOJ: formatDate(employee.dateOfJoining),
                'Total CTC p.m.': formatNum(employee.monthlyCtc || 0),
                'Total CTC p.a.': formatNum(employee.annualCtc || 0),
                'Eligible Emp.': employee.isEligible ? 'Yes' : 'No',
                'Individual KPI + Competency Score': formatNum(employee.individualKpiCompetencyScore || 0),
                'Department Score (out of 100)': formatNum(employee.deptScore || 0),
                'Company Score (out of 100)': formatNum(employee.companyScore || 0),
                'Final Score': formatNum(employee.finalScore || 0),
                'Final Rating': employee.finalRating,
                'Increment %': formatNum(employee.incrementPercentage || 0),
                'Days Served in the Increment Period': formatNum(employee.daysServed || 0),
                'Prorated Increment %': formatNum(employee.proratedIncrementPercentage || 0),
                'Increment Amount': formatNum(employee.incrementAmount || 0),
                'No Promotion Last 3 Year': formatNum(employee.noOfPromotions || 0),
                Promotion: employee.isPromoted ? 'Yes' : 'No',
                'Promotion %': formatNum(employee.promotionPercentage || 0),
                'Promotion Amount': formatNum(employee.promotionAmount || 0),
                'Updated CTC after Increment & Promotion': formatNum(employee.updatedCtcAfterIncrementAndPromotion || 0),
                'Market BenchMark CTC': formatNum(employee.marketBenchMarkCtc || 0),
                'Market Correction %': formatNum(employee.marketCorrectionPercentage || 0),
                'Market Correction Amount': formatNum(employee.marketCorrectionAmount || 0),
                'Final Increment % p.a': formatNum(employee.finalIncrementPercentage || 0),
                [`Increment % in ${lastThreeYears[0]}`]: formatNum(employee.yearBeforeLastYrIncrementPercentage || 0),
                [`Increment % in ${lastThreeYears[1]}`]: formatNum(employee.lastToLastYrIncrementPercentage || 0),
                [`Increment % in ${lastThreeYears[2]}`]: formatNum(employee.lastYrIncrementPercentage || 0),
                'HOD Approved Increment %': formatNum(employee.hodIncrementPercentage || 0),
                'HR Admin & MD/CEO Approved Increment %': formatNum(employee.hrAndMdIncrementPercentage || 0),
                'Final Increment Amount': formatNum(employee.finalIncrementAmount || 0),
                'Final Annual Revised CTC (post increment)': formatNum(employee.finalAnnualCtc || 0),
                'Final Monthly Revised CTC (post increment)': formatNum(employee.finalMonthlyCtc || 0),
                'Increment Letter Format': employee.incrementLetterFormat?.letterName || 'Letter not found'
              });
            });
          });
        });
        flattenedData.push({
          Department: 'Total',
          Band: '',
          Employee: '',
          Manager: '',
          HOD: '',
          Designation: '',
          DOJ: '',
          'Total CTC p.m.': formatNum(this.reportTotalEligibleTotalFixedCtcPM),
          'Total CTC p.a.': formatNum(this.reportTotalEligibleTotalFixedCtcPA),
          'Eligible Emp.': formatNum(this.reportTotalEligibleEligibleEmp),
          'Individual KPI + Competency Score': '',
          'Department Score (out of 100)': '',
          'Company Score (out of 100)': '',
          'Final Score': '',
          'Final Rating': '',
          'Increment %': formatNum(this.reportTotalEligibleIncrementPct),
          'Days Served in the Increment Period': formatNum(this.reportTotalEligibleDaysServedinIncrementPeriod),
          'Prorated Increment %': formatNum(this.reportTotalEligibleProratedIncrementPct),
          'Increment Amount': formatNum(this.reportTotalEligibleIncrementAmount),
          'No Promotion Last 3 Year': formatNum(this.reportTotalEligibleNoOfPromotionPct),
          Promotion: '',
          'Promotion %': formatNum(this.reportTotalEligiblePromotionPct),
          'Promotion Amount': formatNum(this.reportTotalEligiblePromotionAmount),
          'Updated CTC after Increment & Promotion': formatNum(this.reportTotalEligibleupdatedCtcAfterIAndP),
          'Market BenchMark CTC': formatNum(this.reportTotalEligibleMarketBenchMarkCtc),
          'Market Correction %': formatNum(this.reportTotalEligiblemarketCorrectionPct),
          'Market Correction Amount': formatNum(this.reportTotalEligibleMarketCorrectionAmount),
          'Final Increment % p.a': formatNum(this.reportTotalEligibleFinalIncrementPct),
          [`Increment % in ${lastThreeYears[0]}`]: '',
          [`Increment % in ${lastThreeYears[1]}`]: '',
          [`Increment % in ${lastThreeYears[2]}`]: '',
          'HOD Approved Increment %': formatNum(this.reportTotalEligibleHODIncrementPct),
          'HR Admin & MD/CEO Approved Increment %': formatNum(this.reportTotalEligibleHrAndMdIncrementPct),
          'Final Increment Amount': formatNum(this.reportTotalEligibleFinalIncrementAmount),
          'Final Annual Revised CTC (post increment)': formatNum(this.reportTotalEligibleFinalAnnualCtc),
          'Final Monthly Revised CTC (post increment)': formatNum(this.reportTotalEligibleFinalMonthlyCtc),
          'Increment Letter Format': ''
        });
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
        const defaultCellStyle = {
          alignment: { horizontal: 'left', vertical: 'top' },
          font: { name: 'Arial', sz: 12 }
        };
        const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
        for (let row = range.s.r; row <= range.e.r; row++) {
          for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
            if (worksheet[cellAddress]) {
              worksheet[cellAddress].s = defaultCellStyle;
            }
          }
        }
        worksheet['!cols'] = Object.keys(flattenedData[0]).map(() => ({
          wpx: 200
        }));
        const workbook: XLSX.WorkBook = {
          Sheets: { data: worksheet },
          SheetNames: ['data']
        };
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
        const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
        const fileName = `Increment_Report_Eligible_Employee_Data_${formattedDate}`;
        saveAs(data, fileName);
        this.isShowExcelData = false;
        this.loader.dismissLoader();
      }, 1000);
    } else if (tableName == 'incrementReportsNonEligibleTable') {
      setTimeout(() => {
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
        const flattenedData: any[] = [];
        const formatDate = (date: string) => {
          const formattedDate = new Date(date);
          return !isNaN(formattedDate.getTime()) ? formattedDate.toLocaleDateString('en-GB') : date;
        };
        const formatNum = (value: any) => {
          const num = parseFloat(value);
          return isNaN(num) ? '0.00' : num.toFixed(2);
        };
        const currentYear = new Date().getFullYear();
        const lastThreeYears = [currentYear - 3, currentYear - 2, currentYear - 1];
        this.getIncrementReportsNonEligibleTableData.forEach((department: any) => {
          department.bandGrades.forEach((band: any) => {
            band.employeeData.forEach((employee: any) => {
              flattenedData.push({
                Department: department.departmentName,
                Band: band.band,
                Employee: employee.employeeName,
                Manager: employee.managerName,
                HOD: employee.hodName,
                Designation: employee.designation,
                DOJ: formatDate(employee.dateOfJoining),
                'Total CTC p.m.': formatNum(employee.monthlyCtc || 0),
                'Total CTC p.a.': formatNum(employee.annualCtc || 0),
                'Eligible Emp.': employee.isEligible ? 'Yes' : 'No',
                'Individual KPI + Competency Score': formatNum(employee.individualKpiCompetencyScore || 0),
                'Department Score (out of 100)': formatNum(employee.deptScore || 0),
                'Company Score (out of 100)': formatNum(employee.companyScore || 0),
                'Final Score': formatNum(employee.finalScore || 0),
                'Final Rating': employee.finalRating,
                'Increment %': formatNum(employee.incrementPercentage || 0),
                'Days Served in the Increment Period': formatNum(employee.daysServed || 0),
                'Prorated Increment %': formatNum(employee.proratedIncrementPercentage || 0),
                'Increment Amount': formatNum(employee.incrementAmount || 0),
                'No Promotion Last 3 Year': formatNum(employee.noOfPromotions || 0),
                Promotion: employee.isPromoted ? 'Yes' : 'No',
                'Promotion %': formatNum(employee.promotionPercentage || 0),
                'Promotion Amount': formatNum(employee.promotionAmount || 0),
                'Updated CTC after Increment & Promotion': formatNum(employee.updatedCtcAfterIncrementAndPromotion || 0),
                'Market BenchMark CTC': formatNum(employee.marketBenchMarkCtc || 0),
                'Market Correction %': formatNum(employee.marketCorrectionPercentage || 0),
                'Market Correction Amount': formatNum(employee.marketCorrectionAmount || 0),
                'Final Increment % p.a': formatNum(employee.finalIncrementPercentage || 0),
                [`Increment % in ${lastThreeYears[0]}`]: formatNum(employee.yearBeforeLastYrIncrementPercentage || 0),
                [`Increment % in ${lastThreeYears[1]}`]: formatNum(employee.lastToLastYrIncrementPercentage || 0),
                [`Increment % in ${lastThreeYears[2]}`]: formatNum(employee.lastYrIncrementPercentage || 0),
                'HOD Approved Increment %': formatNum(employee.hodIncrementPercentage || 0),
                'HR Admin & MD/CEO Approved Increment %': formatNum(employee.hrAndMdIncrementPercentage || 0),
                'Final Increment Amount': formatNum(employee.finalIncrementAmount || 0),
                'Final Annual Revised CTC (post increment)': formatNum(employee.finalAnnualCtc || 0),
                'Final Monthly Revised CTC (post increment)': formatNum(employee.finalMonthlyCtc || 0),
                'Increment Letter Format': employee.incrementLetterFormat?.letterName || 'Letter not found'
              });
            });
          });
        });
        flattenedData.push({
          Department: 'Total',
          Band: '',
          Employee: '',
          Manager: '',
          HOD: '',
          Designation: '',
          DOJ: '',
          'Total CTC p.m.': `${this.reportTotalNonEligibleTotalFixedCtcPM}`,
          'Total CTC p.a.': `${this.reportTotalNonEligibleTotalFixedCtcPA}`,
          'Eligible Emp.': `${this.reportTotalNonEligibleEligibleEmp}`,
          'Individual KPI + Competency Score': '',
          'Department Score (out of 100)': '',
          'Company Score (out of 100)': '',
          'Final Score': '',
          'Final Rating': ``,
          'Increment %': formatNum(this.reportTotalNonEligibleIncrementPct),
          'Days Served in the Increment Period': formatNum(this.reportTotalNonEligibleDaysServedinIncrementPeriod),
          'Prorated Increment %': formatNum(this.reportTotalNonEligibleProratedIncrementPct),
          'Increment Amount': formatNum(this.reportTotalNonEligibleIncrementAmount),
          'No Promotion Last 3 Year': formatNum(this.reportTotalNonEligibleNoOfPromotionPct),
          Promotion: '',
          'Promotion %': formatNum(this.reportTotalNonEligiblePromotionPct),
          'Promotion Amount': `${this.reportTotalNonEligiblePromotionAmount}`,
          'Updated CTC after Increment & Promotion': formatNum(this.reportTotalNonEligibleupdatedCtcAfterIAndP),
          'Market BenchMark CTC': formatNum(this.reportTotalNonEligibleMarketBenchMarkCtc),
          'Market Correction %': formatNum(this.reportTotalNonEligiblemarketCorrectionPct),
          'Market Correction Amount': formatNum(this.reportTotalNonEligibleMarketCorrectionAmount),
          'Final Increment % p.a': formatNum(this.reportTotalNonEligibleFinalIncrementPct),
          [`Increment % in ${lastThreeYears[0]}`]: '',
          [`Increment % in ${lastThreeYears[1]}`]: '',
          [`Increment % in ${lastThreeYears[2]}`]: '',
          'HOD Approved Increment %': formatNum(this.reportTotalNonEligibleHODIncrementPct),
          'HR Admin & MD/CEO Approved Increment %': formatNum(this.reportTotalNonEligibleHrAndMdIncrementPct),
          'Final Increment Amount': formatNum(this.reportTotalNonEligibleFinalIncrementAmount),
          'Final Annual Revised CTC (post increment)': formatNum(this.reportTotalNonEligibleFinalAnnualCtc),
          'Final Monthly Revised CTC (post increment)': formatNum(this.reportTotalNonEligibleFinalMonthlyCtc),
          'Increment Letter Format': ''
        });
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
        const defaultCellStyle = {
          alignment: { horizontal: 'left', vertical: 'top' },
          font: { name: 'Arial', sz: 12 }
        };
        const range = XLSX.utils.decode_range(worksheet['!ref'] || '');
        for (let row = range.s.r; row <= range.e.r; row++) {
          for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
            if (worksheet[cellAddress]) {
              worksheet[cellAddress].s = defaultCellStyle;
            }
          }
        }
        worksheet['!cols'] = Object.keys(flattenedData[0]).map(() => ({
          wpx: 200
        }));
        const workbook: XLSX.WorkBook = {
          Sheets: { data: worksheet },
          SheetNames: ['data']
        };
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
        const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
        const fileName = `Increment_Report_NonEligible_Employee_Data_${formattedDate}`;
        saveAs(data, fileName);
        this.isShowExcelData = false;
        this.loader.dismissLoader();
      }, 1000);
    }
  }

  // Download Increment Policy

  donwloadIncrementPolicy() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.incrementFromYear,
      toYear: this.incrementToYear
    };
    this.httpService.callPostService(this.config.getIncrementSetupByYear, request).subscribe((result: any) => {
      const downloadFile: any = result.data;
      if (downloadFile.incrementPolicyUrl) {
        var fileName: any = downloadFile.incrementPolicyUrl.split(environment.downloadURL);
        saveAs(downloadFile.incrementPolicyUrl, fileName[1]);
        //  saveAs(environment.downloadURL+downloadFile.incrementPolicyUrl,downloadFile.incrementPolicyUrl);
      }
    });
  }

  // Manager View and employee view
  sendApproveForIsPromoted() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.incrementFromYear,
      isHod: null,
      toYear: this.incrementToYear
    };
    this.httpService.callPostService(this.config.isEmployeePromoted, request).subscribe((result: any) => {
      if (result.data === true) {
        this.ShowApproveForIsPromotedContent = true;
      } else {
        this.ShowApproveForIsPromotedContent = false;
      }
    });
  }

  getFormatedDate(dateOfJoining: any) {
    return this.datePipe.transform(dateOfJoining, 'dd-MM-YYYY');
  }

  getLetterAfterApprovel() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.incrementFromYear,
      toYear: this.incrementToYear
    };
    this.httpService.callPostService(this.config.getIncrementApprovalDataOfCompany, request).subscribe((result: any) => {
      if (result.data?.mdReviewStatus == 'Approved' && result.data?.isLetterSubmitted == true) {
        this.showIncrementLetterForEmp = true;
      } else {
        this.showIncrementLetterForEmp = false;
      }
    });
  }

  isDisabledIncrementAcceptanceReport: boolean = false;
  getIncrementUserDate = { acceptedDate: '', offerLetterPresent: '' };
  getAcceptanceReportUsers() {
    const getCompanyid = this.checkIfIsEnabledIncrement ? this.loggedInUserCompanyID : null;
    this.loader.loaderActive();
    // this.httpService.callGetService(this.config.getIncrementLetterStatus + '?year=2024-2025&companyId=' + 262).subscribe({
    this.httpService.callGetService(this.config.getIncrementLetterStatus + `?year=${this.yearadd}&companyId=` + this.loggedInUserCompanyID).subscribe({
      next: (acceptedReports: any) => {
        if (acceptedReports.data.length > 0) {
          const user: any = acceptedReports.data.find((user: any) => user.employeeCode == this.loggedInUserEmpCode);
          if (user?.status == 'ACCEPTED') {
            this.getIncrementUserDate.acceptedDate = user?.date || false;
            this.getIncrementUserDate.offerLetterPresent = user?.fileName || false;
            this.isDisabledIncrementAcceptanceReport = true;
          } else {
            this.isDisabledIncrementAcceptanceReport = false;
          }
        }
        setTimeout(() => {
          this.loader.dismissLoader();
        }, 1000);
      },
      error: error => {
        setTimeout(() => {
          this.loader.dismissLoader();
        }, 1500);
      }
    });
  }

  setAcceptanceReportTableHeaders = ['Emp Code', 'Emp Name', 'Official Email', 'Reporting Manager', 'HOD', 'Status', 'Accepted On', 'Increment Letter'];
  setAcceptanceReportTableData: any = [];
  filterAcceptanceReportTableData: any = [];
  searchAcceptanceReport: any = null;
  selectedAcceptanceReport: any = [];
  fetchAcceptanceReportTableData: boolean = false;

  getAcceptanceReport() {
    const getCompanyid = this.checkIfIsEnabledIncrement ? this.loggedInUserCompanyID : null;
    this.setAcceptanceReportTableData = [];
    this.loader.loaderActive();
    this.fetchAcceptanceReportTableData = true;
    // this.httpService.callGetService(this.config.getIncrementLetterStatus + '?year=2024-2025&companyId=' + 262).subscribe({
    this.httpService.callGetService(this.config.getIncrementLetterStatus + '?year=2024-2025&companyId=' + getCompanyid).subscribe({
      next: (acceptedReports: any) => {
        this.setAcceptanceReportTableData = acceptedReports.data;
        this.filterAcceptanceReportTableData = acceptedReports.data;
        this.fetchAcceptanceReportTableData = false;
        setTimeout(() => {
          this.loader.dismissLoader();
        }, 1000);
      },
      error: error => {
        this.fetchAcceptanceReportTableData = false;
        setTimeout(() => {
          this.loader.dismissLoader();
        }, 1500);
      }
    });
  }

  // TODO (Temp fix for Sellowrap)Remove below function once previous functionality start working properly
  /* Acceptance Report Table Filters 
    1: Search (Linked with tableSearchFilterPipe)
    2: Status (onSelectDeSelectAcceptanceReport)
    3: Excel Download (onClickDownloadAcceptanceReport)
  */
  onSelectDeSelectAcceptanceReport(multi: boolean, multiSelectedList?: any) {
    const filtersArray = multi ? multiSelectedList : this.selectedAcceptanceReport;
    this.setAcceptanceReportTableData = this.filterAcceptanceReportTableData;
    if (filtersArray.length > 0 && this.filterAcceptanceReportTableData.length > 0) {
      this.setAcceptanceReportTableData = this.filterAcceptanceReportTableData.filter((reportStatus: any) => filtersArray.some((selectedReport: any) => selectedReport.name.trim().toLowerCase() === (reportStatus?.status ? reportStatus.status.trim().toLowerCase() : '')));
    }
  }

  onClickDownloadIncrementLetterForEmp(empCode?: string, compId?: string) {
    const employeeCode = empCode ?? this.loggedInUserEmpCode;
    const companyId = compId ?? this.loggedInUserCompanyID;
    let payload = {
      companyId: companyId,
      fromYear: this.fromYear,
      id: parseInt(this.loggedInUserId),
      toYear: this.toYear
    };
    // if (this.loggedInUserCompanyID == '262') {
    if (this.checkIfIsEnabledIncrement) {
      this.httpService.callGetService(this.config.getIncrementLetterOfUser + '?employeeCode=' + employeeCode + '&companyId=' + companyId).subscribe({
        next: (response: any) => {
          if (response) {
            if (response?.fileName) {
              // Open the document in a new tab
              let fileUrl: string = `${this.config.downloadIncrement}${this.loggedInUserCompanyID}/${response?.fileName}`;
              window.open(fileUrl, '_blank');
            } else {
              this.popupExecution.apiSuccessOrErrorMessage({
                msg: 'Increment Letter Not Found.'
              });
            }
          } else {
            this.popupExecution.apiSuccessOrErrorMessage({
              msg: 'Increment Letter Not Found Please Try Again.'
            });
          }
        },
        error: error => {
          this.popupExecution.apiSuccessOrErrorMessage({
            msg: 'Something Went Wrong Please Try Again Later.'
          });
        }
      });
    } else {
      this.httpService.callPostService(this.config.getIncrementLetterOfEmployee, payload).subscribe({
        next: (response: any) => {
          if (response) {
            if (response?.data) {
              // Open the document in a new tab
              let fileUrl: string = `${this.config.downloadFile}${this.loggedInUserCompanyID}/${response?.data}`;
              window.open(fileUrl, '_blank');
            } else {
              this.popupExecution.apiSuccessOrErrorMessage({
                msg: 'Increment Letter Not Found.'
              });
            }
          } else {
            this.popupExecution.apiSuccessOrErrorMessage({
              msg: 'Increment Letter Not Found Please Try Again.'
            });
          }
        },
        error: error => {
          this.popupExecution.apiSuccessOrErrorMessage({
            msg: 'Something Went Wrong Please Try Again Later.'
          });
        }
      });
    }
  }

  onClickIncrementAcceptanceReport(acceptanceReport: any) {
    const confPopup = this.popupExecution.confirmationPopupComponentExe({
      msg: 'Are you sure you want to accept?'
    });
    confPopup.afterClosed().subscribe((confirmed: any) => {
      if (!confirmed) return;

      this.isDisabledIncrementAcceptanceReport = acceptanceReport;
      const request = {
        employeeCode: this.loggedInUserEmpCode,
        companyId: this.loggedInUserCompanyID,
        status: 'ACCEPTED'
      };

      this.httpService.callPutService(this.config.setIncrementUpdateStatus + '?employeeCode=' + this.loggedInUserEmpCode + '&companyId=' + this.loggedInUserCompanyID + '&status=ACCEPTED', request).subscribe({
        next: (response: any) => {
          if (response?.status) {
            this.isDisabledIncrementAcceptanceReport = true;
            this.popupExecution.apiSuccessOrErrorMessage({
              msg: 'Increment Request Accepting Successfully'
            });
          } else {
            this.isDisabledIncrementAcceptanceReport = false;
            this.popupExecution.apiSuccessOrErrorMessage({
              msg: 'Something went wrong please try again'
            });
          }
        },
        error: (error: any) => {
          this.isDisabledIncrementAcceptanceReport = false;
          this.popupExecution.apiSuccessOrErrorMessage({
            msg: 'Something went wrong please try again'
          });
        }
      });
    });
  }

  onClickDownloadAcceptanceReport(setAcceptanceReportTableData: any) {
    const flattenedData: any = setAcceptanceReportTableData.map((ele: any) => ({
      'Employee Code': ele.employeeCode,
      'Employee Name': ele.employeeFullName,
      'Official Email': ele.officialEmail,
      'Reporting Manager': ele.reportingManagerName,
      'HOD Name': ele.hodName,
      'Acceptance Status': ele.status,
      'Accepted On': this.datePipe.transform(ele.date, 'd, MMM y hh:mm a')
    }));
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const worksheet: XLSX.WorkSheet | any = XLSX.utils.json_to_sheet(flattenedData);
    const headerStyle = {
      fill: {
        fgColor: { rgb: 'FF0000' }
      },
      font: {
        bold: true,
        color: { rgb: 'FFFFFF' },
        sz: 14,
        name: 'Arial'
      }
    };
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ c: col, r: 0 });
      if (!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = headerStyle;
    }
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data']
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    const fileName = 'Acceptance_Report.xlsx';
    saveAs(data, fileName);
  }
  /* End */

  // --------------------------------AG GRID CODE---------------------------------------------------------
  //  gridApi: any;
  paginationPageSizeSelector = [5, 10, 20, 50, 100, 200, 500, 1000];
  pagination = true;
  paginationPageSize = 10;
  detailRowAutoHeight = true;

  defaultColDef: ColDef = {
    // flex: 1,
    minWidth: 120,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false, // enable a small filter box under each header
    // keep headers single-line and use ellipsis for overflow
    // wrapHeaderText: true,
    autoHeaderHeight: true,
    wrapText: false
    // headerClass: 'phi-ag-header',
  };

  gridOptions: any = {
    // tuned heights so data rows appear visually centered between header and floating-filter band
    headerHeight: 64, // taller header row (top)
    floatingFiltersHeight: 56,
    stopEditingWhenCellsLoseFocus: true, // 🔑 commit value when clicking anywhere outside
    suppressClickEdit: false, // allow click-to-edit
    singleClickEdit: true,
    rowHeight: 56, // give data rows room so content sits comfortably centered in the available vertical space
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: false,
      // keep single-line header style in grid options as well
      wrapHeaderText: false,
      autoHeaderHeight: false,
      wrapText: false,
      //  minWidth: 80,

      // ✅ add this
      cellClass: (p: any) => (p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd')
    },
    context: { componentParent: this },
    rowSelection: 'single',
    localeText: {
      noRowsToShow: 'No Data Found' // default text ko replace karna hai 'No Rows To Show' to 'No Data Found'
    }
  };

  openCommentModal(text: string, commentType: any) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: {
        text: text,
        commentType: commentType
      }
    });
  }
  //  gridApi!: GridApi;
  //  gridColumnApi!: ColumnApi;
  //  gridColumnApi: any;

  onReportGridReady(params: any) {
    // keep references
    this.reportGridApi = params.api;
    this.reportColumnApi = params.columnApi;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    // 1) Make sure columnDefs are built (Angular binding will apply them)
    this.buildColumnDefsFromConfig();

    // 2) Make sure rowData is at least an array (Angular binding applies it)
    if (!Array.isArray(this.gridRowData)) {
      this.gridRowData = [];
    }

    console.log('agGrid ready. rows:', this.gridRowData.length, 'cols:', this.columnDefs?.length || 0);

    // 3) Just do column sizing; DO NOT call setColumnDefs / setRowData
    setTimeout(() => {
      try {
        const apiAny = this.gridApi as any;
        const colApiAny = this.gridColumnApi as any;

        if (colApiAny?.autoSizeAllColumns) {
          colApiAny.autoSizeAllColumns();
        } else if (apiAny && !apiAny.isDestroyed?.()) {
          apiAny.sizeColumnsToFit?.();
        }
      } catch (e) {
        console.warn('onReportGridReady -> sizing failed', e);
      }
    }, 50);
  }

  formatStatus(value: any): string {
    if (!value || typeof value !== 'string') {
      return 'N/A'; // fallback agar value string na ho
    }

    // Camel Case → Title Case
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  formatDate(value: any): string {
    if (!value) return 'N/A';

    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Invalid Date';

    // dd-MM-yyyy format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  // Helper function to convert any date string into dd-MM-yyyy
  formatDateOnly(dateStr: string | null): string | null {
    if (!dateStr) return null;

    let datePart = dateStr;
    if (dateStr.includes('T')) {
      datePart = dateStr.split('T')[0];
    }

    const [y, m, d] = datePart.split('-').map(Number);
    if (!y || !m || !d) return null;

    // Date object
    const date = new Date(y, m - 1, d);

    // Format dd-MM-yyyy
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  // ✅ Global search function
  onFilterTextBoxChanged(value: string = '') {
    if (!this.gridApi) return;

    // v31+ way:
    this.gridApi.setGridOption('quickFilterText', value ?? '');
  }

  // npm install xlsx
  // import at top of file:
  // import * as XLSX from 'xlsx';

  onBtExport(exportCurrentPageOnly: boolean = true): void {
    // Determine active grid API (same logic you already had)
    const isSummary = this.selectedTypeTabName === 'Increment Summary';
    const isReports = this.selectedTypeTabName === 'Reports';
    const isInput = this.selectedTypeTabName === 'Increment Input';

    const isReportsEligible = isReports && this.activeIncrementReportsTab === true;
    const isReportsNonEligible = isReports && this.activeIncrementReportsTab === false;

    const isInputEligible = isInput && this.activeIncrementInputTab === true;
    const isInputNonEligible = isInput && this.activeIncrementInputTab === false;

    const api: any = isSummary ? this.gridApiIncrementSummary : isReportsEligible ? this.reportGridApi : isReportsNonEligible ? this.gridApiIncrementReportsNonEligible : isInputEligible ? this.gridApiIncrementInputEligible : isInputNonEligible ? this.gridApiIncrementInputNonEligible : null;

    if (!api) {
      console.warn('Grid API not available for export.');
      return;
    }

    // filename / sheet name
    const fileDate = new Date().toISOString().slice(0, 10);
    const baseName = isSummary ? `Increment_Summary_${fileDate}` : isReportsEligible ? `Increment_Reports_Eligible_${fileDate}` : isReportsNonEligible ? `Increment_Reports_NonEligible_${fileDate}` : isInputEligible ? `Increment_Input_Eligible_${fileDate}` : isInputNonEligible ? `Increment_Input_NonEligible_${fileDate}` : `Export_${fileDate}`;
    const sheetName = isSummary ? 'IncrementSummary' : isReportsEligible ? 'ReportsEligible' : isReportsNonEligible ? 'ReportsNonEligible' : isInputEligible ? 'InputEligible' : isInputNonEligible ? 'InputNonEligible' : 'Sheet1';

    // helper to format date-like values to DD-MM-YYYY if desired
    const formatCellValue = (colDef: any, value: any) => {
      if (value == null) return '';
      const header = (colDef.headerName ?? '').toString();
      const dateHeaders = ['DOJ', 'Date of Joining', 'dateOfJoining', 'date']; // extend as needed
      if (dateHeaders.some(h => h.toLowerCase() === header.toLowerCase())) {
        const d = new Date(value);
        if (!isNaN(d.getTime())) {
          return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
        }
      }
      return value;
    };

    // Get visible columns from grid API in displayed order.
    const displayedColumnObjs = api.getAllDisplayedColumns?.() || [];
    if (!displayedColumnObjs || displayedColumnObjs.length === 0) {
      console.warn('No displayed columns found for export.');
      return;
    }
    const displayedCols = displayedColumnObjs.map((colObj: any) => {
      // colObj may be Column object; call getColDef if present to get headerName/field
      return colObj.getColDef ? colObj.getColDef() : colObj;
    });

    // Build headers in displayed order
    const headers = displayedCols.map((cd: any) => cd.headerName ?? cd.field ?? cd.colId ?? '');

    // Determine page range if pagination and exportCurrentPageOnly === true
    const displayedCount = api.getDisplayedRowCount?.() ?? 0;
    let startIndex = 0;
    let endIndexExclusive: number = displayedCount; // always a number

    if (exportCurrentPageOnly && typeof api.paginationGetCurrentPage === 'function' && typeof api.paginationGetPageSize === 'function') {
      const page = api.paginationGetCurrentPage();
      const pageSize = api.paginationGetPageSize();
      // guard: page/pageSize should be numbers
      if (typeof page === 'number' && typeof pageSize === 'number' && pageSize > 0) {
        startIndex = page * pageSize;
        endIndexExclusive = Math.min(startIndex + pageSize, displayedCount);
      } else {
        // fallback to full result
        startIndex = 0;
        endIndexExclusive = displayedCount;
      }
    } else {
      // Not exporting only current page -> use all displayed rows
      startIndex = 0;
      endIndexExclusive = displayedCount;
    }

    // Collect row objects for the selected range using getDisplayedRowAtIndex (respects filter/sort/group)
    const rowsForExport: any[] = [];
    for (let i = startIndex; i < endIndexExclusive; i++) {
      const rowNode = api.getDisplayedRowAtIndex?.(i);
      if (!rowNode) continue;

      // skip group header rows (adjust if you want to export them)
      if (rowNode.group && rowNode.field) continue;

      const data = rowNode.data ?? {};
      const rowObj: any = {};

      displayedCols.forEach((colDef: any) => {
        const field = colDef.field ?? colDef.colId ?? colDef.headerName;
        const header = colDef.headerName ?? field;
        // attempt to read value using field; fallback to header if not present
        const rawValue = data[field] !== undefined ? data[field] : (data[colDef.colId] ?? data[header]);
        rowObj[header] = formatCellValue(colDef, rawValue);
      });

      rowsForExport.push(rowObj);
    }

    if (!rowsForExport.length) {
      console.warn('No rows found for the requested export range (check filter/pagination).');
      return;
    }

    // Build sheet and workbook using xlsx
    try {
      const worksheet = XLSX.utils.json_to_sheet(rowsForExport, {
        header: headers,
        skipHeader: false
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
      XLSX.writeFile(workbook, `${baseName}.xlsx`);
    } catch (e) {
      console.error('XLSX export failed, falling back to CSV. Error:', e);
      try {
        const ws = XLSX.utils.json_to_sheet(rowsForExport, {
          header: headers,
          skipHeader: false
        });
        const csv = XLSX.utils.sheet_to_csv(ws);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${baseName}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } catch (ee) {
        console.error('CSV fallback failed:', ee);
      }
    }
  }

  approvalRenderer(params: any) {
    if (!params.value) return '';
    const status = params.value.toUpperCase();

    let color = '';
    if (status === 'APPROVED') {
      color = '#4caf50'; // green
    } else if (status === 'REJECTED') {
      color = '#f44336'; // red
    } else if (status === 'PENDING') {
      color = '#ff9800'; // orange
    }

    return `
           <span style="
             border: 1px solid ${color};
             color: ${color};
             padding: 4px 10px;
             border-radius: 12px;
             font-size: 12px;
             font-weight: 500;
             display: inline-block;
             line-height: 20px;
             white-space: nowrap;
           ">
         ${status.charAt(0) + status.slice(1).toLowerCase()}
       </span>
     `;
  }

  statusFormatter(params: any): string {
    if (!params.value) return '';

    const valueUpper = params.value.toUpperCase();

    // 🔹 Status → Color map
    const statusColors: Record<string, string> = {
      APPROVED_BY_FINANCE_BUT_NOT_PAID: '#4caf50', // green
      APPROVED_BY_MANAGER_SENT_TO_FINANCE: '#4caf50',
      APPROVED_BY_MANAGER_REJECTED_BY_FINANCE: '#f44336', // red
      REJECTED_BY_MANAGER: '#f44336',
      PENDING_WITH_MANAGER: '#ff9800' // orange
    };

    // 🔹 Default color = grey
    const color = Object.keys(statusColors).find(key => valueUpper.includes(key)) ? statusColors[Object.keys(statusColors).find(key => valueUpper.includes(key))!] : '#999';

    // 🔹 Convert to Title Case
    const formattedText = params.value
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return `
       <span style="
         border: 1px solid ${color};
         color: ${color};
         padding: 4px 10px;
         border-radius: 12px;
         font-size: 12px;
         font-weight: 500;
         display: inline-block;
         white-space: normal;
         word-wrap: break-word;
         line-height: 1.4em;
         animation: fadeInScale 0.3s ease-in-out;
         max-width: 100%;
       ">
         ${formattedText}
       </span>
     `;
  }

  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }
  downloadRenderer = (params: any) => {
    const fileUrl = `${this.config.downloadFile}${params.value}`;
    if (!params.value) return '';
    const img = document.createElement('img');
    img.src = 'assets/icon/yellowdownload.png'; // replace with your icon path
    img.alt = 'download';
    img.style.width = '18px';
    img.style.height = '18px';
    img.style.cursor = 'pointer';
    img.title = params.value;
    img.addEventListener('click', e => {
      e.stopPropagation();
      // open file in new tab
      window.open(fileUrl, '_blank');
    });
    return img;
  };

  downloadDialogRenderer(fileName: string): string {
    if (!fileName) return '';
    return `${this.config.downloadFile}${fileName}`;
  }
  selectedRow: any;
  isDetailsOpen = false;
  onRowClicked(event: any) {
    this.selectedRow = event.data;
    this.isDetailsOpen = true;
  }
  closeDetails() {
    this.isDetailsOpen = false;
  }

  isClicked = false;
  searchTaskString: string = '';

  resetGrid(): void {
    this.isClicked = false;

    const isSummary = this.selectedTypeTabName === 'Increment Summary';
    const isReports = this.selectedTypeTabName === 'Reports';
    const isInput = this.selectedTypeTabName === 'Increment Input';

    const isReportsEligible = isReports && this.activeIncrementReportsTab === true;
    const isReportsNonEligible = isReports && this.activeIncrementReportsTab === false;
    const isInputEligible = isInput && this.activeIncrementInputTab === true;
    const isInputNonEligible = isInput && this.activeIncrementInputTab === false;

    // pick the right grid and column APIs
    const api: any = isSummary ? this.gridApiIncrementSummary : isReportsEligible ? this.reportGridApi : isReportsNonEligible ? this.gridApiIncrementReportsNonEligible : isInputEligible ? this.gridApiIncrementInputEligible : isInputNonEligible ? this.gridApiIncrementInputNonEligible : null;

    let colApi: any = isSummary ? this.gridColumnApiIncrementSummary : isReportsEligible ? this.reportColumnApi : isReportsNonEligible ? this.gridColumnApiIncrementReportsNonEligible : isInputEligible ? this.gridColumnApiIncrementInputEligible : isInputNonEligible ? this.gridColumnApiIncrementInputNonEligible : null;

    if (!colApi && api && typeof api.getColumnApi === 'function') {
      try {
        colApi = api.getColumnApi();
      } catch (e) {
        colApi = null;
      }
    }

    if (!api) {
      console.warn('resetGrid: no api available for current tab:', {
        selectedTypeTabName: this.selectedTypeTabName,
        activeIncrementInputTab: this.activeIncrementInputTab,
        activeIncrementReportsTab: this.activeIncrementReportsTab
      });
      return;
    }

    // Basic resets (filters, sorting, selection, quick filter)
    try {
      api.setFilterModel && api.setFilterModel(null);
    } catch {}
    try {
      api.setSortModel && api.setSortModel(null);
    } catch {}
    try {
      api.deselectAll && api.deselectAll();
    } catch {}
    try {
      api.setQuickFilter && api.setQuickFilter('');
    } catch {}
    try {
      api.paginationGoToFirstPage && api.paginationGoToFirstPage();
    } catch {}
    try {
      api.paginationSetPageSize && api.paginationSetPageSize(this.paginationPageSize || 20);
    } catch {}

    // Helper that tries to reset columns in the most robust order
    const tryResetColumns = (): boolean => {
      try {
        if (colApi && typeof colApi.resetColumnState === 'function') {
          colApi.resetColumnState();
          console.debug('resetGrid: used colApi.resetColumnState()');
          return true;
        }
      } catch (e) {
        console.warn('resetGrid: colApi.resetColumnState failed', e);
      }

      try {
        if (typeof api.resetColumnState === 'function') {
          api.resetColumnState();
          console.debug('resetGrid: used api.resetColumnState()');
          return true;
        }
      } catch (e) {
        console.warn('resetGrid: api.resetColumnState failed', e);
      }

      // fallback: explicitly drive visibility from your IncrementInputTableHideShowAllData
      try {
        const cfg = Array.isArray(this.IncrementInputTableHideShowAllData) ? this.IncrementInputTableHideShowAllData : null;
        if (colApi && cfg) {
          const desiredState: any[] = [];
          cfg.forEach((c: any) => {
            const display = c.fieldName;
            if (!display) return;
            const field = this.fieldKeyFromDisplayName(display);
            if (!field) return;
            desiredState.push({ colId: field, hide: !Boolean(c.isVisible) });
          });
          if (desiredState.length && typeof colApi.setColumnState === 'function') {
            colApi.setColumnState(desiredState);
            console.debug('resetGrid: applied colApi.setColumnState fallback');
            return true;
          }
          // per-column visibility fallback
          desiredState.forEach(s => {
            try {
              colApi.setColumnVisible(s.colId, !s.hide);
            } catch (e) {}
          });
          console.debug('resetGrid: applied per-column visibility fallback');
          return true;
        }
      } catch (e) {
        console.warn('resetGrid: visibility fallback failed', e);
      }

      return false;
    };

    // Try immediate reset, then retry if still not applied (timing issue)
    let applied = false;
    try {
      applied = tryResetColumns();
    } catch (e) {
      applied = false;
    }

    // If first attempt didn't fully apply, schedule retries — this fixes the "first click shows partial" problem
    if (!applied) {
      const retryDelays = [50, 180, 400]; // multiple retries to cover lifecycle timing
      retryDelays.forEach((d, i) => {
        setTimeout(() => {
          try {
            const ok = tryResetColumns();
            if (ok) {
              try {
                api.refreshHeader && api.refreshHeader();
              } catch (e) {}
              try {
                api.refreshCells && api.refreshCells({ force: true });
              } catch (e) {}
              console.debug(`resetGrid: columns reset on retry #${i + 1} (delay ${d}ms)`);
            }
          } catch (err) {
            console.warn('resetGrid retry failed', err);
          }
        }, d);
      });
    }

    // Force header/cell refresh and resize
    try {
      api.refreshHeader && api.refreshHeader();
    } catch (e) {}
    try {
      api.refreshCells && api.refreshCells({ force: true });
    } catch (e) {}
    try {
      api.redrawRows && api.redrawRows();
    } catch (e) {}
    setTimeout(() => {
      try {
        api.sizeColumnsToFit && api.sizeColumnsToFit();
      } catch (e) {}
      try {
        api.refreshHeader && api.refreshHeader();
      } catch (e) {}
    }, 80);

    // update counters and run change detection
    try {
      this.totalEligibleCount = (this.incrementEligibleRowData || []).length;
      this.totalNonEligibleCount = (this.incrementNonEligibleRowData || []).length;
    } catch (e) {}
    try {
      this.cd && this.cd.detectChanges();
    } catch (e) {}

    console.info('resetGrid completed for', {
      selectedTypeTabName: this.selectedTypeTabName,
      activeIncrementInputTab: this.activeIncrementInputTab,
      activeIncrementReportsTab: this.activeIncrementReportsTab,
      totalEligibleCount: this.totalEligibleCount,
      totalNonEligibleCount: this.totalNonEligibleCount
    });
  }

  // --------------------------------AG GRID CODE---------------------------------------------------------
  private buildGridRowsFromDepartments(departments: any[] = []): any[] {
    const rows: any[] = [];

    if (!Array.isArray(departments) || departments.length === 0) {
      return rows;
    }

    departments.forEach((dept: any) => {
      const bands = dept?.bandGrades || [];

      // how many employees in this department?
      const deptEmployeeCount = bands.reduce((sum: number, b: any) => sum + ((b?.employeeData || []).length || 0), 0);

      let isFirstDeptRow = true;

      bands.forEach((band: any) => {
        const emps = band?.employeeData || [];
        const bandRowCount = emps.length || 0;

        let isFirstBandRow = true;

        emps.forEach((emp: any) => {
          const row: any = {
            // basic fields
            departmentName: dept.departmentName,
            departmentId: dept.departmentId ?? null,
            band: band.band,
            bandId: band.bandId ?? null,
            employeeName: emp.employeeName,
            managerName: emp.managerName,
            hodName: emp.hodName,
            designation: emp.designation,
            dateOfJoining: emp.dateOfJoining,
            monthlyCtc: emp.monthlyCtc,
            annualCtc: emp.annualCtc,
            isEligible: emp.isEligible,
            individualKpiCompetencyScore: emp.individualKpiCompetencyScore,
            deptScore: emp.deptScore,
            companyScore: emp.companyScore,
            finalScore: emp.finalScore,
            finalRating: emp.finalRating,
            incrementPercentage: emp.incrementPercentage,
            daysServed: emp.daysServed,
            proratedIncrementPercentage: emp.proratedIncrementPercentage,
            incrementAmount: emp.incrementAmount,
            noOfPromotions: emp.noOfPromotions,
            isPromoted: emp.isPromoted,
            promotionPercentage: emp.promotionPercentage,
            promotionAmount: emp.promotionAmount,
            updatedCtcAfterIncrementAndPromotion: emp.updatedCtcAfterIncrementAndPromotion,
            marketBenchMarkCtc: emp.marketBenchMarkCtc,
            marketCorrectionPercentage: emp.marketCorrectionPercentage,
            marketCorrectionAmount: emp.marketCorrectionAmount,
            finalIncrementPercentage: emp.finalIncrementPercentage,
            yearBeforeLastYrIncrementPercentage: emp.yearBeforeLastYrIncrementPercentage,
            lastToLastYrIncrementPercentage: emp.lastToLastYrIncrementPercentage,
            lastYrIncrementPercentage: emp.lastYrIncrementPercentage,
            hodIncrementPercentage: emp.hodIncrementPercentage,
            hrAndMdIncrementPercentage: emp.hrAndMdIncrementPercentage,
            finalIncrementAmount: emp.finalIncrementAmount,
            finalAnnualCtc: emp.finalAnnualCtc,
            finalMonthlyCtc: emp.finalMonthlyCtc,
            incrementLetterName: emp.incrementLetterFormat?.letterName || null,

            // rowspan helpers
            departmentFirst: isFirstDeptRow,
            departmentRowSpanCount: isFirstDeptRow ? deptEmployeeCount || 1 : 1,
            bandFirst: isFirstBandRow,
            bandRowSpanCount: isFirstBandRow ? bandRowCount || 1 : 1,

            // keep originals
            __originalDepartment: dept,
            __originalBand: band,
            __originalEmployee: emp
          };

          rows.push(row);

          // only first row of dept/band gets the span flags
          isFirstDeptRow = false;
          isFirstBandRow = false;
        });
      });
    });

    // Debug: see how many rows we built
    console.log('buildGridRowsFromDepartments:', 'nested employees =', this.countNestedEmployees(departments), 'flattened rows =', rows.length);

    return rows;
  }

  private countNestedEmployees(departments: any[] = []): number {
    return (departments || []).reduce((sum, dept: any) => {
      return (
        sum +
        (dept.bandGrades || []).reduce((s: number, b: any) => {
          return s + ((b.employeeData || []).length || 0);
        }, 0)
      );
    }, 0);
  }

  /**
   * Convert nested departments -> bandGrades -> employeeData to flat rows and
   * apply them to the AG Grid. Keeps a single place to update gridRowData + gridApi.
   */
  private applyReportDataToGrid(departments: any[] | null) {
    const rows = this.buildGridRowsFromDepartments(departments || []);
    this.gridRowData = rows;
    console.log('applyReportDataToGrid -> rows:', rows?.length);

    // build totals for footer
    this.buildPinnedBottomTotals(this.gridRowData);

    // just do column sizing, no setRowData
    try {
      const apiAny = this.gridApi as any;
      if (apiAny && !apiAny.isDestroyed?.()) {
        apiAny.sizeColumnsToFit?.();
      }
    } catch (e) {
      console.warn('applyReportDataToGrid -> sizeColumnsToFit failed', e);
    }

    // keep your "coverage" logging if you want – it doesn’t touch the grid API
  }

  private getMinWidthForColumn(field: string): number {
    const widths: Record<string, number> = {
      // pinned left
      departmentName: 220,
      band: 160,

      // identity
      employeeName: 200,
      managerName: 180,
      hodName: 160,
      designation: 180,
      dateOfJoining: 140,

      // CTC & money
      monthlyCtc: 150,
      annualCtc: 150,
      updatedCtcAfterIncrementAndPromotion: 180,
      marketBenchMarkCtc: 160,
      finalAnnualCtc: 160,
      finalMonthlyCtc: 160,
      incrementAmount: 150,
      finalIncrementAmount: 160,
      promotionAmount: 150,

      // numeric scores & percentages
      individualKpiCompetencyScore: 220,
      deptScore: 140,
      companyScore: 140,
      finalScore: 140,
      finalRating: 140,
      incrementPercentage: 140,
      proratedIncrementPercentage: 160,
      finalIncrementPercentage: 150,
      yearBeforeLastYrIncrementPercentage: 200,
      lastToLastYrIncrementPercentage: 180,
      lastYrIncrementPercentage: 160,
      hodIncrementPercentage: 150,
      hrAndMdIncrementPercentage: 180,
      marketCorrectionPercentage: 160,
      marketCorrectionAmount: 170,
      promotionPercentage: 140,
      daysServed: 120,
      noOfPromotions: 140,

      // fallback / general
      incrementLetterName: 200
    };

    return widths[field] ?? 120; // default fallback
  }

  private buildColumnDefsFromConfig() {
    const cfg = this.IncrementReportsTableHideShowAllData || [];

    const labelToField = (label: string) => {
      const map: any = {
        Department: 'departmentName',
        Band: 'band',
        'Employee Name': 'employeeName',
        Employee: 'employeeName',
        'Manager Name': 'managerName',
        Manager: 'managerName',
        'HoD Name': 'hodName',
        HOD: 'hodName',
        Designation: 'designation',
        'Date Of Joining': 'dateOfJoining',
        DOJ: 'dateOfJoining',
        'Monthly CTC': 'monthlyCtc',
        'Annual CTC': 'annualCtc',
        'Total CTC p.m.': 'monthlyCtc',
        'Total CTC p.a.': 'annualCtc',
        'Fixed CTC p.m.': 'monthlyCtc',
        'Fixed CTC p.a.': 'annualCtc',
        'Is Eligible': 'isEligible',
        'Eligible Emp.': 'isEligible',
        'Individual KPI Competency Score': 'individualKpiCompetencyScore',
        'Individual KPI + Competency Score': 'individualKpiCompetencyScore',
        'Dept Score': 'deptScore',
        'Department Score (out of 100)': 'deptScore',
        'Company Score': 'companyScore',
        'Company Score (out of 100)': 'companyScore',
        'Final Score': 'finalScore',
        'Final Rating': 'finalRating',
        'Increment %': 'incrementPercentage',
        'Days Served': 'daysServed',
        'Days Served in the Increment Period': 'daysServed',
        'Prorated Increment %': 'proratedIncrementPercentage',
        'Increment Amount': 'incrementAmount',
        'No Of Promotions': 'noOfPromotions',
        'No Promotion Last 3 Year': 'noOfPromotions',
        'Is Promoted': 'isPromoted',
        Promotion: 'isPromoted',
        'Promotion %': 'promotionPercentage',
        'Promotion Amount': 'promotionAmount',
        'Updated CTC After I & P': 'updatedCtcAfterIncrementAndPromotion',
        'Updated CTC after Increment & Promotion': 'updatedCtcAfterIncrementAndPromotion',
        'Market Benchmark CTC': 'marketBenchMarkCtc',
        'Market BenchMark CTC': 'marketBenchMarkCtc',
        'Market Correction %': 'marketCorrectionPercentage',
        'Market Correction Amount': 'marketCorrectionAmount',
        'Final Increment %': 'finalIncrementPercentage',
        'Final Increment % p.a': 'finalIncrementPercentage',
        'Year Before Last Yr Increment %': 'yearBeforeLastYrIncrementPercentage',
        'Last To Last Yr Increment %': 'lastToLastYrIncrementPercentage',
        'Last Yr Increment %': 'lastYrIncrementPercentage',
        'HoD Increment %': 'hodIncrementPercentage',
        'HOD Approved Increment %': 'hodIncrementPercentage',
        'HR and MD Increment %': 'hrAndMdIncrementPercentage',
        'HR Admin & MD/CEO Approved Increment %': 'hrAndMdIncrementPercentage',
        'Final Increment Amount': 'finalIncrementAmount',
        'Final Annual CTC': 'finalAnnualCtc',
        'Final Monthly CTC': 'finalMonthlyCtc',
        'Increment Letter': 'incrementLetterName',
        'Increment Letter Format': 'incrementLetterName',
        'Final Annual Revised CTC (post increment)': 'finalAnnualCtc',
        'Final Monthly Revised CTC (post increment)': 'finalMonthlyCtc'
      };
      return map[label] || label.replace(/\s+/g, '').toLowerCase();
    };

    const cols: any[] = [];

    for (const item of cfg) {
      let itemName = item.fieldName;
      const incrementInYearMatch = /^Increment % in (\d{4})$/.exec(itemName);
      if (incrementInYearMatch) {
        const colYear = Number(incrementInYearMatch[1]);
        const currentYear = new Date().getFullYear();
        if (colYear === currentYear - 3) itemName = 'Year Before Last Yr Increment %';
        else if (colYear === currentYear - 2) itemName = 'Last To Last Yr Increment %';
        else if (colYear === currentYear - 1) itemName = 'Last Yr Increment %';
      }

      const fieldKey = labelToField(itemName);
      const col: any = {
        headerName: item.fieldName,
        field: fieldKey,
        hide: !item.isVisible,
        // prefer single-line headers and consistent header class
        wrapHeaderText: false,
        autoHeaderHeight: false,
        wrapText: false,
        headerTooltip: item.fieldName,
        tooltipField: fieldKey || undefined,
        minWidth: this.getMinWidthForColumn(fieldKey), // <-- use helper here
        headerClass: 'phi-ag-header',
        // ensure each column has an interactive filter and can be resized
        filter: true,
        // floatingFilter: true,
        resizable: true,
        // Add cellClass for pinned bottom row styling
        cellClass: (params: any) => {
          if (params && params.node && params.node.rowPinned === 'bottom') {
            return 'footer-total-cell-aggrid';
          }
          return null;
        }
      };

      // special formatting
      if (fieldKey === 'dateOfJoining') {
        col.valueFormatter = (params: any) => {
          if (!params.value) return '';
          const d = new Date(params.value);
          const day = String(d.getDate()).padStart(2, '0');
          const mon = String(d.getMonth() + 1).padStart(2, '0');
          const yr = d.getFullYear();
          return `${day}-${mon}-${yr}`;
        };
      } else if (['monthlyCtc', 'annualCtc', 'individualKpiCompetencyScore', 'deptScore', 'companyScore', 'finalScore', 'incrementPercentage', 'proratedIncrementPercentage', 'incrementAmount', 'promotionPercentage', 'promotionAmount', 'updatedCtcAfterIncrementAndPromotion', 'marketBenchMarkCtc', 'marketCorrectionPercentage', 'marketCorrectionAmount', 'finalIncrementPercentage', 'yearBeforeLastYrIncrementPercentage', 'lastToLastYrIncrementPercentage', 'lastYrIncrementPercentage', 'hodIncrementPercentage', 'hrAndMdIncrementPercentage', 'finalIncrementAmount', 'finalAnnualCtc', 'finalMonthlyCtc'].includes(fieldKey)) {
        col.filter = 'agNumberColumnFilter';
        col.valueFormatter = (params: any) => {
          if (params.value == null || params.value === '') return '';
          return Number(params.value).toLocaleString();
        };
        col.type = 'numericColumn';
        col.width = Math.max(this.getMinWidthForColumn(fieldKey), 130);
      } else if (fieldKey === 'isEligible' || fieldKey === 'isPromoted') {
        col.valueFormatter = (params: any) => (params.value ? 'Yes' : 'No');
        col.width = Math.max(this.getMinWidthForColumn(fieldKey), 100);
      } else {
        col.width = Math.max(this.getMinWidthForColumn(fieldKey), 150);
      }

      // Add rowSpan for department and band columns
      if (fieldKey === 'departmentName') {
        col.rowSpan = (params: any) => {
          return params.data && params.data.departmentFirst ? params.data.departmentRowSpanCount : 1;
        };
        col.cellClass = 'department-cell';
        col.headerClass = 'phi-ag-header';
        // col.pinned = 'left';
        col.width = Math.max(this.getMinWidthForColumn(fieldKey), 180);
        col.minWidth = Math.max(this.getMinWidthForColumn(fieldKey), 140);
      }
      if (fieldKey === 'band') {
        col.rowSpan = (params: any) => {
          return params.data && params.data.bandFirst ? params.data.bandRowSpanCount : 1;
        };
        col.cellClass = 'band-cell';
        col.headerClass = 'phi-ag-header';
        // col.pinned = 'left';
        col.width = Math.max(this.getMinWidthForColumn(fieldKey), 140);
        col.minWidth = Math.max(this.getMinWidthForColumn(fieldKey), 120);
      }

      cols.push(col);
    }

    this.columnDefs = cols;
  }

  private buildPinnedBottomTotals(rows: any[]) {
    if (!rows || rows.length === 0) {
      this.pinnedBottomRowData = [];
      try {
        if (this.gridApi && this.gridApi.setPinnedBottomRowData) {
          this.gridApi.setPinnedBottomRowData([]);
        }
      } catch (e) {
        console.warn('Failed to clear pinned bottom via API', e);
      }
      return;
    }

    const totals: any = {
      // Put the label in the first column's field
      departmentName: 'Total'
    };

    const sumFields = ['monthlyCtc', 'annualCtc', 'incrementPercentage', 'daysServed', 'proratedIncrementPercentage', 'incrementAmount', 'noOfPromotions', 'promotionPercentage', 'promotionAmount', 'updatedCtcAfterIncrementAndPromotion', 'marketBenchMarkCtc', 'marketCorrectionPercentage', 'marketCorrectionAmount', 'finalIncrementPercentage', 'finalIncrementAmount', 'finalAnnualCtc', 'finalMonthlyCtc'];

    for (const f of sumFields) {
      totals[f] = rows.reduce((acc: number, r: any) => {
        const raw = r[f] ?? 0;
        const num = typeof raw === 'number' ? raw : parseFloat(String(raw).replace(/,/g, '')) || 0;
        return acc + num;
      }, 0);
    }

    // keep eligibility blank/neutral
    totals.isEligible = null;

    // IMPORTANT: remove the duplicate label from the last column
    totals.incrementLetterName = null; // or '' if you prefer

    // assign and push to grid API so AG Grid shows it immediately
    this.pinnedBottomRowData = [totals];
    try {
      if (this.gridApi && this.gridApi.setPinnedBottomRowData) {
        this.gridApi.setPinnedBottomRowData([totals]);
        // optionally force a redraw of cells (safe)
        if (this.gridApi.refreshCells) this.gridApi.refreshCells({ force: true });
      }
    } catch (e) {
      console.warn('Failed to set pinned bottom via API', e);
    }
  }

  onGridReadyNonEligible(params: any) {
    this.gridApiIncrementReportsNonEligible = params.api;
    this.gridColumnApiIncrementReportsNonEligible = params.columnApi;
    this.gridApiNonEligible = params.api;
    this.gridColumnApiNonEligible = params.columnApi ?? null;

    console.log('onGridReadyNonEligible -> api proto keys:', Object.getOwnPropertyNames(Object.getPrototypeOf(this.gridApiNonEligible || {})));

    // If we already have row data/pinned data prepared, try to apply them safely
    try {
      // if api supports setRowData, use it; otherwise rely on bound [rowData] property
      if (this.gridApiNonEligible && typeof this.gridApiNonEligible.setRowData === 'function') {
        this.gridApiNonEligible.setRowData(this.gridRowDataNonEligible || []);
      }
    } catch (e) {
      console.warn('onGridReadyNonEligible - setRowData failed', e);
    }

    try {
      if (this.gridApiNonEligible && typeof this.gridApiNonEligible.setPinnedBottomRowData === 'function') {
        this.gridApiNonEligible.setPinnedBottomRowData(this.pinnedBottomRowDataNonEligible || []);
        console.log('onGridReadyNonEligible -> pinned applied via API');
      } else {
        console.log('onGridReadyNonEligible -> pinned API not available yet; relying on binding');
      }
    } catch (e) {
      console.warn('onGridReadyNonEligible - setPinnedBottomRowData failed', e);
    }

    // small safety: schedule a retry to apply pinned rows if API methods appear slightly later
    setTimeout(() => {
      try {
        const apiRetry = this.gridApiNonEligible;
        if (apiRetry && typeof apiRetry.setPinnedBottomRowData === 'function') {
          apiRetry.setPinnedBottomRowData(this.pinnedBottomRowDataNonEligible || []);
          console.log('onGridReadyNonEligible -> pinned applied on retry');
        }
      } catch (err) {
        console.warn('onGridReadyNonEligible retry failed', err);
      }
    }, 120);
  }
  onIncrementInputNonEligibleGridReady(event: any) {
    console.log('INPUT NON-ELIGIBLE GRID READY');

    // Correct API for Increment Input → Non Eligible
    this.gridApiIncrementInputNonEligible = event.api;
    this.gridColumnApiIncrementInputNonEligible = event.columnApi;

    // Apply row data
    if (this.incrementNonEligibleRowData) {
      event.api.setRowData(this.incrementNonEligibleRowData);
    }

    // Apply pinned totals
    if (this.pinnedBottomRowDataNonEligible) {
      event.api.setPinnedBottomRowData(this.pinnedBottomRowDataNonEligible);
    }

    // Auto-resize after render
    setTimeout(() => {
      event.api.sizeColumnsToFit();
    }, 50);
  }

  onFirstDataRenderedNonEligible(params: any) {
    // useful to auto-size once first data rendered
    try {
      params.api.sizeColumnsToFit();
    } catch (e) {}
  }

  private buildPinnedBottomTotalsNonEligible(rows: any[]) {
    console.log('buildPinnedBottomTotalsNonEligible called — rows length:', Array.isArray(rows) ? rows.length : '(not array)');

    if (!rows || rows.length === 0) {
      this.pinnedBottomRowDataNonEligible = [];
      try {
        const api = this.gridApiNonEligible;
        if (api && typeof api.setPinnedBottomRowData === 'function') {
          api.setPinnedBottomRowData([]);
          console.log('Cleared pinned rows via API (no rows)');
        }
      } catch (e) {
        console.warn('Failed to clear pinned via API', e);
      }
      return;
    }

    // Put the label in the first column field
    const totals: any = { departmentName: 'Total' };

    const sumFields = ['monthlyCtc', 'annualCtc', 'incrementPercentage', 'daysServed', 'proratedIncrementPercentage', 'incrementAmount', 'noOfPromotions', 'promotionPercentage', 'promotionAmount', 'updatedCtcAfterIncrementAndPromotion', 'marketBenchMarkCtc', 'marketCorrectionPercentage', 'marketCorrectionAmount', 'finalIncrementPercentage', 'finalIncrementAmount', 'finalAnnualCtc', 'finalMonthlyCtc'];

    for (const f of sumFields) {
      totals[f] = rows.reduce((acc: number, r: any) => {
        const raw = r && r[f];
        const num = typeof raw === 'number' ? raw : parseFloat(String(raw || '0').replace(/,/g, '')) || 0;
        return acc + num;
      }, 0);
    }

    // keep eligibility count or blank as required
    totals.isEligible = rows.filter(r => !!r.isEligible).length;

    // IMPORTANT: ensure last-column related fields are cleared so label ONLY appears in first column
    // Add any other possible last-column field names you might have in columnDefs
    totals.incrementLetterName = null;
    totals.incrementLetter = null;
    totals.incrementLetterDisplay = null;

    this.pinnedBottomRowDataNonEligible = [totals];
    console.log('buildPinnedBottomTotalsNonEligible -> computed totals:', totals);

    // try to apply via API; if not ready rely on template binding; also retry once
    try {
      const api = this.gridApiNonEligible;
      if (api && typeof api.setPinnedBottomRowData === 'function') {
        api.setPinnedBottomRowData(this.pinnedBottomRowDataNonEligible);
        console.log('Pinned rows applied via API immediately');
        return;
      } else {
        console.log('API not ready to set pinned rows; pinnedBottomRowDataNonEligible set for binding');
      }
    } catch (e) {
      console.warn('setPinnedBottomRowData immediate failed', e);
    }

    setTimeout(() => {
      try {
        const apiRetry = this.gridApiNonEligible;
        if (apiRetry && typeof apiRetry.setPinnedBottomRowData === 'function') {
          apiRetry.setPinnedBottomRowData(this.pinnedBottomRowDataNonEligible);
          console.log('Pinned rows applied via API on retry');
        } else {
          console.log('Retry: API still not ready; grid should pick up pinnedBottomRowData via binding');
        }
      } catch (err) {
        console.warn('Pinned rows retry error', err);
      }
    }, 140);
  }

  // Call this whenever you want to (re)apply grid data for the current tab.
  // If you use two separate grids, adapt to call the correct gridApi and pinned arrays.
  refreshGridData(isEligibleTab: boolean) {
    const nested = isEligibleTab ? this.getIncrementReportsEligibleTableData : this.getIncrementReportsNonEligibleTableData;

    const targetRowDataProp = isEligibleTab ? 'gridRowData' : 'gridRowDataNonEligible';

    const flatRows = this.buildGridRowsFromDepartments(nested || []);
    (this as any)[targetRowDataProp] = flatRows;

    // totals
    if (isEligibleTab && typeof (this as any).buildPinnedBottomTotals === 'function') {
      (this as any).buildPinnedBottomTotals(flatRows);
    }
    if (!isEligibleTab && typeof (this as any).buildPinnedBottomTotalsNonEligible === 'function') {
      (this as any).buildPinnedBottomTotalsNonEligible(flatRows);
    }

    // just auto-size columns, no setRowData
    const api = isEligibleTab ? this.gridApi : this.gridApiNonEligible;
    const colApi = isEligibleTab ? this.gridColumnApi : this.gridColumnApiNonEligible;

    setTimeout(() => {
      try {
        const colAny = colApi as any;
        const apiAny = api as any;

        if (colAny?.autoSizeAllColumns) {
          colAny.autoSizeAllColumns();
        } else if (apiAny && !apiAny.isDestroyed?.()) {
          apiAny.sizeColumnsToFit?.();
        }
      } catch {}
    }, 80);
  }

  /**
   * Replace your existing onClickIncrementReportsActiveTab with this.
   * It resets filters to proper typed defaults and refreshes the correct grid.
   */
  onClickIncrementReportsActiveTab(data: any) {
    this.activeIncrementReportsTab = data;
    this.checkIncrementDepartment = this.activeIncrementReportsTab ?? false;

    // --- Reset filters with correct types ---
    // multi-selects -> arrays
    this.selectedIncrementReportDep = [];
    this.selectedIncrementReportBand = [];
    this.selectedIncrementReportDesignation = [];
    this.selectedIncrementReportManager = [];
    this.selectedIncrementReportEmployee = [];
    this.selectedIncrementReportRating = [];

    // boolean single selects -> null (meaning "no filter")
    this.selectedIncrementReportPromotion = null;
    this.selectedIncrementReportMarketCorr = null;

    // search text
    this.searchIncrementReportTableData = '';

    // keep existing calls
    this.getDepartmentByYear();
    this.checkStatusForIncrementSetup();

    // give Angular time to render the tab's grid if it's controlled by *ngIf,
    // then refresh the grid data for the selected tab.
    setTimeout(() => {
      this.refreshGridData(this.activeIncrementReportsTab);
    }, 0);
  }
  buildIncrementSummaryColumnDefs(): void {
    const isVisible = (name: string) => this.getIncrementSummaryColumnVisibility(name);

    // helper for total row style (except Department)
    const totalCellStyle = (params: any) => {
      const data = params.data;
      if (data && (data.rowType === 'departmentTotal' || data.rowType === 'grandTotal')) {
        return {
          'background-color': '#f2f2f2',
          'font-weight': '700'
        };
      }
      return null;
    };

    this.incrementSummaryColumnDefs = [
      {
        headerName: 'Department',
        field: 'departmentName',
        cellClass: 'department-cell-center'
      },
      {
        headerName: 'Band',
        field: 'band',
        hide: !isVisible('Band'),
        cellStyle: totalCellStyle
      },
      {
        headerName: 'Total Emp.',
        field: 'totalEmp',
        hide: !isVisible('Total Emp.'),
        valueFormatter: p => (p.value != null ? Number(p.value).toLocaleString('en-IN') : ''),
        cellStyle: totalCellStyle
      },
      {
        headerName: this.incrementsummaryCtc,
        field: 'totalFixedCtc',
        hide: !isVisible(this.incrementsummaryCtc),
        valueFormatter: p => (p.value != null ? Number(p.value).toLocaleString('en-IN') : ''),
        cellStyle: totalCellStyle
      },
      {
        headerName: 'Eligible Emp.',
        field: 'eligibleEmp',
        hide: !isVisible('Eligible Emp.'),
        valueFormatter: p => (p.value != null ? Number(p.value).toLocaleString('en-IN') : ''),
        cellStyle: totalCellStyle
      },
      {
        headerName: 'Eligible Emp. Fixed CTC',
        field: 'eligibleEmpFixedCtc',
        hide: !isVisible('Eligible Emp. Fixed CTC'),
        valueFormatter: p => (p.value != null ? Number(p.value).toLocaleString('en-IN') : ''),
        cellStyle: totalCellStyle
      },
      {
        headerName: 'Overall Increment Budget',
        field: 'overallIncrementBudget',
        hide: !isVisible('Overall Increment Budget'),
        valueFormatter: p => (p.value != null ? Number(p.value).toLocaleString('en-IN') : ''),
        cellStyle: totalCellStyle
      },
      {
        headerName: 'Increment Amount',
        field: 'incrementAmount',
        hide: !isVisible('Increment Amount'),
        valueFormatter: p => (p.value != null ? Number(p.value).toLocaleString('en-IN') : ''),
        cellStyle: totalCellStyle
      },
      {
        headerName: 'No of Promotions',
        field: 'noOfPromotions',
        hide: !isVisible('No of Promotions'),
        valueFormatter: p => (p.value != null ? Number(p.value).toLocaleString('en-IN') : ''),
        cellStyle: totalCellStyle
      },
      {
        headerName: 'Promotion Amount',
        field: 'promotionAmount',
        hide: !isVisible('Promotion Amount'),
        valueFormatter: p => (p.value != null ? Number(p.value).toLocaleString('en-IN') : ''),
        cellStyle: totalCellStyle
      },
      {
        headerName: 'No of Market Corrections',
        field: 'noOfMarketCorrections',
        hide: !isVisible('No of Market Corrections'),
        valueFormatter: p => (p.value != null ? Number(p.value).toLocaleString('en-IN') : ''),
        cellStyle: totalCellStyle
      },
      {
        headerName: 'Market Correction Amount',
        field: 'marketCorrectionAmount',
        hide: !isVisible('Market Correction Amount'),
        valueFormatter: p => (p.value != null ? Number(p.value).toLocaleString('en-IN') : ''),
        cellStyle: totalCellStyle
      },
      {
        headerName: 'Final Increment Amount',
        field: 'finalIncrementAmount',
        hide: !isVisible('Final Increment Amount'),
        valueFormatter: p => (p.value != null ? Number(p.value).toLocaleString('en-IN') : ''),
        cellStyle: totalCellStyle
      },
      {
        headerName: 'Variance',
        field: 'variance',
        hide: !isVisible('Variance'),
        valueFormatter: p => (p.value != null ? Number(p.value).toLocaleString('en-IN') : ''),
        cellStyle: totalCellStyle
      },
      {
        headerName: 'Variance %',
        field: 'variancePercentage',
        hide: !isVisible('Variance %'),
        valueFormatter: p => (p.value != null ? Number(p.value).toFixed(2) : ''),
        cellStyle: totalCellStyle
      }
    ];
  }

  buildIncrementSummaryRowDataFromTableData(): void {
    const rows: any[] = [];

    (this.getIncrementSummaryTableData || []).forEach((department: any) => {
      const deptName = department.departmentName;
      const employees = department.employeeSummaryData || [];

      const rowCount = employees.length + 1;

      // normal rows
      employees.forEach((emp: any, index: number) => {
        rows.push({
          departmentName: index === 0 ? deptName : '',
          departmentRowCount: rowCount,
          departmentRowIndex: index,

          band: emp.band,
          totalEmp: emp.totalEmp,
          totalFixedCtc: emp.totalFixedCtc,
          eligibleEmp: emp.eligibleEmp,
          eligibleEmpFixedCtc: emp.eligibleEmpFixedCtc,
          overallIncrementBudget: emp.overallIncrementBudget,
          incrementAmount: emp.incrementAmount,
          noOfPromotions: emp.noOfPromotions,
          promotionAmount: emp.promotionAmount,
          noOfMarketCorrections: emp.noOfMarketCorrections,
          marketCorrectionAmount: emp.marketCorrectionAmount,
          finalIncrementAmount: emp.finalIncrementAmount,
          variance: emp.variance,
          variancePercentage: emp.variancePercentage,

          rowType: 'normal'
        });
      });

      // department total row
      if (employees.length) {
        rows.push({
          departmentName: '',
          departmentRowCount: rowCount,
          departmentRowIndex: employees.length,

          band: 'Total',
          totalEmp: this.getDepartmentTotal(employees, 'totalEmp'),
          totalFixedCtc: this.getDepartmentTotal(employees, 'totalFixedCtc'),
          eligibleEmp: this.getDepartmentTotal(employees, 'eligibleEmp'),
          eligibleEmpFixedCtc: this.getDepartmentTotal(employees, 'eligibleEmpFixedCtc'),
          overallIncrementBudget: this.getDepartmentTotal(employees, 'overallIncrementBudget'),
          incrementAmount: this.getDepartmentTotal(employees, 'incrementAmount'),
          noOfPromotions: this.getDepartmentTotal(employees, 'noOfPromotions'),
          promotionAmount: this.getDepartmentTotal(employees, 'promotionAmount'),
          noOfMarketCorrections: this.getDepartmentTotal(employees, 'noOfMarketCorrections'),
          marketCorrectionAmount: this.getDepartmentTotal(employees, 'marketCorrectionAmount'),
          finalIncrementAmount: this.getDepartmentTotal(employees, 'finalIncrementAmount'),
          variance: this.getDepartmentTotal(employees, 'variance'),
          variancePercentage: this.getDepartmentTotal(employees, 'variancePercentage'),

          rowType: 'departmentTotal'
        });
      }
    });

    this.incrementSummaryRowData = rows;
  }

  buildIncrementSummaryPinnedBottomRows(): void {
    const pinnedRows: any[] = [];

    // Band-wise totals (like your <ng-container *ngFor="let bandTotal of getAggregatedBandTotals()">)
    const bandTotals = this.getAggregatedBandTotals() || [];
    bandTotals.forEach((bandTotal: any, index: number) => {
      pinnedRows.push({
        departmentName: index === 0 ? 'Total' : '',
        band: bandTotal.band,
        totalEmp: bandTotal.totalEmp,
        totalFixedCtc: bandTotal.totalFixedCtc,
        eligibleEmp: bandTotal.eligibleEmp,
        eligibleEmpFixedCtc: bandTotal.eligibleEmpFixedCtc,
        overallIncrementBudget: bandTotal.overallIncrementBudget,
        incrementAmount: bandTotal.incrementAmount,
        noOfPromotions: bandTotal.noOfPromotions,
        promotionAmount: bandTotal.promotionAmount,
        noOfMarketCorrections: bandTotal.noOfMarketCorrections,
        marketCorrectionAmount: bandTotal.marketCorrectionAmount,
        finalIncrementAmount: bandTotal.finalIncrementAmount,
        variance: bandTotal.variance,
        variancePercentage: bandTotal.variancePercentage,
        rowType: 'bandTotal'
      });
    });

    // Grand Total row (same as your last <tr> in <tfoot>)
    pinnedRows.push({
      departmentName: 'Grand Total',
      band: '',
      totalEmp: this.getGrandTotal('totalEmp'),
      totalFixedCtc: this.getGrandTotal('totalFixedCtc'),
      eligibleEmp: this.getGrandTotal('eligibleEmp'),
      eligibleEmpFixedCtc: this.getGrandTotal('eligibleEmpFixedCtc'),
      overallIncrementBudget: this.getGrandTotal('overallIncrementBudget'),
      incrementAmount: this.getGrandTotal('incrementAmount'),
      noOfPromotions: this.getGrandTotal('noOfPromotions'),
      promotionAmount: this.getGrandTotal('promotionAmount'),
      noOfMarketCorrections: this.getGrandTotal('noOfMarketCorrections'),
      marketCorrectionAmount: this.getGrandTotal('marketCorrectionAmount'),
      finalIncrementAmount: this.getGrandTotal('finalIncrementAmount'),
      variance: this.getGrandTotal('variance'),
      variancePercentage: this.getGrandTotal('variancePercentage'),
      rowType: 'grandTotal'
    });

    this.incrementSummaryPinnedBottomRowData = pinnedRows;
  }
  onIncrementSummaryGridReady(event: GridReadyEvent): void {
    this.gridApiIncrementSummary = event.api;
    // this.gridColumnApiIncrementSummary = event.columnApi;

    // make sure columns exist
    this.buildIncrementSummaryColumnDefs();

    // load existing data (if already fetched)
    this.buildIncrementSummaryRowDataFromTableData();
    this.buildIncrementSummaryPinnedBottomRows();
    // setTimeout(() => {
    //   this.addHeaderEyeIcons();
    // }, 50);

    this.gridApiIncrementSummary.sizeColumnsToFit();
  }
  autoGroupColumnDef: ColDef = {
    headerName: 'Department',
    minWidth: 220,
    cellRendererParams: {
      suppressCount: false
    }
  };

  getIncrementSummaryRowStyle = (params: RowClassParams<any, any>): RowStyle | undefined => {
    const data: any = params.data;
    if (!data) return undefined;

    if (data.rowType === 'departmentTotal') {
      return {
        'background-color': '#d8f5d0', // light green
        'font-weight': '700'
      };
    }

    return undefined; // all other rows normal
  };

  private mapIncrementSummaryFieldNameToField(fieldName: string): string | null {
    switch (fieldName) {
      case 'Department':
        return 'departmentName';
      case 'Band':
        return 'band';
      case 'Total Emp.':
        return 'totalEmp';
      case this.incrementsummaryCtc:
        return 'totalFixedCtc';
      case 'Eligible Emp.':
        return 'eligibleEmp';
      case 'Eligible Emp. Fixed CTC':
        return 'eligibleEmpFixedCtc';
      case 'Overall Increment Budget':
        return 'overallIncrementBudget';
      case 'Increment Amount':
        return 'incrementAmount';
      case 'No of Promotions':
        return 'noOfPromotions';
      case 'Promotion Amount':
        return 'promotionAmount';
      case 'No of Market Corrections':
        return 'noOfMarketCorrections';
      case 'Market Correction Amount':
        return 'marketCorrectionAmount';
      case 'Final Increment Amount':
        return 'finalIncrementAmount';
      case 'Variance':
        return 'variance';
      case 'Variance %':
        return 'variancePercentage';
      default:
        return null;
    }
  }

  updateIncrementSummaryColumnVisibilityByField(field: string, isVisible: boolean) {
    if (!this.IncrementSummaryTableHideShowAllData) return;
    for (const c of this.IncrementSummaryTableHideShowAllData) {
      const mapped = this.mapIncrementSummaryFieldNameToField(c.fieldName) || c.fieldKey || c.fieldName;
      if (mapped === field) {
        c.isVisible = !!isVisible;
        break;
      }
    }
  }
  // // helper used by header-icon click
  // // robust toggle that works across different ag-grid typings/versions
  // toggleColumnVisibilityByField(field: string, newVisible: boolean) {
  //   // 1) update your local hide/show config so the rest of app stays in sync
  //   this.updateIncrementSummaryColumnVisibilityByField(field, newVisible);

  //   // 2) update local columnDefs hide flag so our state is correct
  //   this.incrementSummaryColumnDefs = (this.incrementSummaryColumnDefs || []).map((cd: any) => {
  //     if (cd && cd.field === field) {
  //       return { ...cd, hide: !newVisible };
  //     }
  //     return cd;
  //   });

  //   // 3) Try to toggle via columnApi (preferred if available)
  //   try {
  //     const apiAny = this.gridApiIncrementSummary as any;
  //     const colApi = apiAny && (typeof apiAny.getColumnApi === 'function') ? apiAny.getColumnApi() : (apiAny && apiAny.columnApi ? apiAny.columnApi : null);

  //     if (colApi && typeof colApi.setColumnVisible === 'function') {
  //       colApi.setColumnVisible(field, newVisible);
  //       // refresh header DOM and re-add icons
  //       setTimeout(() => this.addHeaderEyeIcons(), 50);
  //       return;
  //     }
  //   } catch (e) {
  //     // swallow and fallback below
  //     console.warn('columnApi toggle failed, falling back to setColumnDefs', e);
  //   }

  //   // 4) Fallback: try to call setColumnDefs on the grid API (use any cast)
  //   try {
  //     const apiAny = this.gridApiIncrementSummary as any;
  //     if (apiAny && typeof apiAny.setColumnDefs === 'function') {
  //       apiAny.setColumnDefs(this.incrementSummaryColumnDefs);
  //       setTimeout(() => this.addHeaderEyeIcons(), 50);
  //       return;
  //     }
  //   } catch (e) {
  //     console.warn('setColumnDefs failed', e);
  //   }

  //   // 5) Final fallback: if APIs are not present, just update local defs and refresh header
  //   try {
  //     // try refreshHeader if present
  //     const apiAny = this.gridApiIncrementSummary as any;
  //     if (apiAny && typeof apiAny.refreshHeader === 'function') {
  //       apiAny.refreshHeader();
  //     }
  //   } catch (e) {
  //     // nothing else we can do; UI will pick up next grid redraw
  //     console.warn('refreshHeader failed', e);
  //   }

  //   // always re-inject icons in case header DOM changed
  //   setTimeout(() => this.addHeaderEyeIcons(), 100);
  // }

  // addHeaderEyeIcons(): void {
  //   // container selector for the grid (use a class on your ag-grid-angular for safety)
  //   const gridRoot = document.querySelector('.increment-summary-grid'); // make sure this class is on ag-grid-angular
  //   if (!gridRoot) return;

  //   // iterate columns we defined
  //   (this.incrementSummaryColumnDefs || []).forEach((colDef: any) => {
  //     const field = colDef.field;
  //     if (!field) return;

  //     // find header cell DOM for this column
  //     // ag-grid sets attribute col-id on header cell
  //     const headerCell = gridRoot.querySelector(`.ag-header-cell[col-id="${field}"]`);
  //     if (!headerCell) return;

  //     // avoid duplicate icon insertion
  //     if (headerCell.querySelector('.col-eye-icon')) return;

  //     // create icon element
  //     const span = document.createElement('span');
  //     span.className = 'material-icons col-eye-icon';
  //     span.style.cursor = 'pointer';
  //     span.style.marginLeft = '6px';
  //     span.style.fontSize = '16px';
  //     span.style.verticalAlign = 'middle';

  //     // initial icon text based on current visibility
  //     const colVisible = this.getIncrementSummaryColumnVisibilityByField(field);
  //     span.textContent = colVisible ? 'visibility' : 'visibility_off';

  //     // stop header sort/menu on click
  //     span.addEventListener('click', (ev: Event) => {
  //       ev.stopPropagation();
  //       const currentlyVisible = this.getIncrementSummaryColumnVisibilityByField(field);
  //       const newVisible = !currentlyVisible;

  //       this.toggleColumnVisibilityByField(field, newVisible);

  //       // 3) update icon visually
  //       span.textContent = newVisible ? 'visibility' : 'visibility_off';
  //     });

  //     // append icon into header label area
  //     const headerLabel = headerCell.querySelector('.ag-header-cell-label') || headerCell;
  //     headerLabel.appendChild(span);
  //   });
  // }
  // getIncrementSummaryColumnVisibilityByField(field: string): boolean {
  //   if (!this.IncrementSummaryTableHideShowAllData) return true;
  //   for (const c of this.IncrementSummaryTableHideShowAllData) {
  //     const mapped = this.mapIncrementSummaryFieldNameToField(c.fieldName) || (c.fieldKey || c.fieldName);
  //     if (mapped === field) return !!c.isVisible;
  //   }
  //   // default true
  //   return true;
  // }
  private fieldKeyFromDisplayName(displayName: string): string {
    // map some special names used in your template; fallback to sanitized displayName
    const map: Record<string, string> = {
      Department: 'Department',
      Band: 'Band',
      Employee: 'Employee',
      Manager: 'Manager',
      HOD: 'HOD',
      Designation: 'Designation',
      DOJ: 'DOJ',
      'Eligible Emp.': 'isEligible',
      'Total CTC p.m.': 'monthlyCtc',
      'Total CTC p.a.': 'annualCtc',
      'Promotion %': 'promotionPercentage',
      'Market BenchMark CTC': 'marketBenchMarkCtc',
      'Market Correction %': 'marketCorrectionPercentage',
      'Increment %': 'incrementPercentage',
      'Prorated Increment %': 'proratedIncrementPercentage',
      'Increment Amount': 'incrementAmount',
      'Final Increment % p.a': 'finalIncrementPercentage',
      'Final Increment Amount': 'finalIncrementAmount'
      // add more mappings as needed
    };
    return map[displayName] ?? displayName.replace(/\s+/g, '_');
  }

  moveEmployeeBetweenEligibility(rowData: any, params: any, toEligible: boolean) {
    if (!rowData) return;

    try {
      const userId = rowData.__rawEmployee?.userId ?? rowData.userId ?? null;

      // 1) ensure normalized flag on both rowData and rawEmployee
      rowData.isEligible = !!toEligible;
      if (rowData.__rawEmployee) rowData.__rawEmployee.isEligible = !!toEligible;

      // 2) create fresh copies of arrays with duplicates removed (replace reference to trigger CD)
      const existingEligible = Array.isArray(this.incrementEligibleRowData) ? this.incrementEligibleRowData.slice() : [];
      const existingNonEligible = Array.isArray(this.incrementNonEligibleRowData) ? this.incrementNonEligibleRowData.slice() : [];

      const clean = (arr: any[]) =>
        arr.filter((r: any) => {
          const id = r.__rawEmployee?.userId ?? r.userId ?? null;
          return id !== userId;
        });

      const newEligible = clean(existingEligible);
      const newNonEligible = clean(existingNonEligible);

      // 3) prepare newRow (preserve __rawEmployee)
      const newRow = { ...rowData };
      if (newRow.__rawEmployee) newRow.__rawEmployee.isEligible = !!toEligible;

      // 4) push into correct array (we created new array references above)
      if (toEligible) {
        newEligible.push(newRow);
      } else {
        newNonEligible.push(newRow);
      }

      // 5) assign back (replace references so template/OnPush picks up changes)
      this.incrementEligibleRowData = newEligible;
      this.incrementNonEligibleRowData = newNonEligible;

      // 6) update grid apis defensively
      const applyDataToApi = (api: any, rows: any[]) => {
        if (!api) return;
        try {
          if (typeof api.setRowData === 'function') {
            api.setRowData(rows || []);
            return;
          }
          if (typeof api.setRowData === 'undefined' && typeof api.applyTransaction === 'function') {
            // best-effort: try to replace by removing and adding
            try {
              api.applyTransaction({ remove: [], add: rows });
            } catch (_) {}
            return;
          }
        } catch (e) {
          console.warn('applyDataToApi failed', e);
        }
      };

      applyDataToApi(this.gridApiIncrementInputEligible, this.incrementEligibleRowData);
      applyDataToApi(this.gridApiIncrementInputNonEligible, this.incrementNonEligibleRowData);

      // 7) recompute pinned totals (call your existing helpers if present)
      try {
        if (typeof (this as any).buildPinnedBottomTotalsEligible === 'function') {
          (this as any).buildPinnedBottomTotalsEligible(this.incrementEligibleRowData || []);
        } else if (typeof (this as any).buildPinnedBottomTotalsEligible === 'function') {
          (this as any).buildPinnedBottomTotalsEligible();
        }
      } catch (e) {
        console.warn('Pinned totals eligible update failed', e);
      }

      try {
        if (typeof (this as any).buildPinnedBottomTotalsNonEligible === 'function') {
          (this as any).buildPinnedBottomTotalsNonEligible(this.incrementNonEligibleRowData || []);
        } else if (typeof (this as any).buildPinnedBottomTotalsNonEligible === 'function') {
          (this as any).buildPinnedBottomTotalsNonEligible();
        }
      } catch (e) {
        console.warn('Pinned totals non-eligible update failed', e);
      }

      // 8) Call the existing onEdit handler to persist change to backend if needed
      try {
        if (typeof this.onEditIncrementInputTableData === 'function') {
          this.onEditIncrementInputTableData(newRow.__rawEmployee || newRow, params);
        }
      } catch (e) {
        console.warn('onEditIncrementInputTableData failed', e);
      }

      // 9) update counts/totals and ensure Angular picks up change
      this.totalEligibleCount = (this.incrementEligibleRowData || []).length;
      this.totalNonEligibleCount = (this.incrementNonEligibleRowData || []).length;

      // optional: call your existing functions that compute derived totals
      try {
        if (typeof this.calculateInputEligibleTotals === 'function') {
          this.calculateInputEligibleTotals(this.getIncrementInputEligibleTableData);
        }
      } catch (e) {}

      // 10) UI refresh: refreshCells + sizeColumnsToFit + change detection
      setTimeout(() => {
        try {
          this.gridApiIncrementInputEligible?.refreshCells?.({ force: true });
        } catch (_) {}
        try {
          this.gridApiIncrementInputNonEligible?.refreshCells?.({
            force: true
          });
        } catch (_) {}
        try {
          this.gridApiIncrementInputEligible?.sizeColumnsToFit?.();
        } catch (_) {}
        try {
          this.gridApiIncrementInputNonEligible?.sizeColumnsToFit?.();
        } catch (_) {}

        // trigger Angular change detection safely (works with default and OnPush)
        try {
          if (this.cd) {
            // prefer markForCheck for OnPush components
            if (typeof this.cd.markForCheck === 'function') this.cd.markForCheck();
            if (typeof this.cd.detectChanges === 'function') this.cd.detectChanges();
          }
        } catch (e) {
          /* ignore */
        }
      }, 30);
    } catch (err) {
      console.error('moveEmployeeBetweenEligibility failed', err);
    }
  }

  buildIncrementColumnDefs(): void {
    const colDefs: ColDefExt[] = [];

    if (!Array.isArray(this.IncrementInputTableHideShowAllData)) {
      this.incrementColumnDefs = colDefs;
      console.log('incrementColumnDefs:', this.incrementColumnDefs);
      console.log('incrementEligibleRowData:', this.incrementEligibleRowData);
      return;
    }

    // helper: disable browser suggestions on the editor input (minimal, robust)
    const onCellEditorCreatedNoSuggest = (params: any) => {
      try {
        const editors =
          params.api.getCellEditorInstances?.({
            rowNodes: [params.node],
            columns: [params.column]
          }) || [];
        const editor = editors[0];
        const gui = editor?.getGui?.();
        if (!gui) return;

        const input: HTMLInputElement | null = (gui.querySelector && gui.querySelector('input')) || (gui.tagName === 'INPUT' ? (gui as HTMLInputElement) : null);

        if (!input) return;

        input.setAttribute('autocomplete', 'off');
        input.setAttribute('spellcheck', 'false');
        input.setAttribute('autocorrect', 'off');
        input.setAttribute('autocapitalize', 'off');

        // randomized name reduces browser autofill matches
        input.name = 'nosuggest_' + Math.random().toString(36).slice(2);
      } catch (e) {
        // swallow — non-critical
        // console.warn('no-suggest hook failed', e);
      }
    };

    const fmtIfLongDecimal = (val: any) => {
      if (val === null || val === undefined || val === '') return '';
      const str = String(val);
      if (!str.includes('.')) return str;
      const parts = str.split('.');
      const frac = parts[1] ?? '';
      if (frac.length <= 4) return str;
      const num = Number(str);
      if (isNaN(num)) return str;
      return num.toLocaleString('en-IN', {
        minimumFractionDigits: 4,
        maximumFractionDigits: 4
      });
    };

    const deltaAnimatedHeaders = ['Promotion Amount', 'Updated CTC after Increment & Promotion', 'Increment Amount', 'Final Increment % p.a', 'Final Increment Amount', 'Final Annual Revised CTC (post increment)', 'Final Monthly Revised CTC (post increment)', 'Market BenchMark CTC', 'Market Correction %', 'Market Correction Amount'];

    this.IncrementInputTableHideShowAllData.forEach((col: any) => {
      if (!col?.isVisible) return;
      const display = col.fieldName;
      const key = this.fieldKeyFromDisplayName(display);

      // Department
      if (display === 'Department') {
        colDefs.push({
          headerName: display,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          minWidth: 160,
          cellRenderer: (params: any) => {
            if (params.node?.rowPinned === 'bottom') {
              const label = params.value || 'Total';
              return `<span style="font-weight:bold;">${label}</span>`;
            }
            return params.value ?? '';
          },
          cellStyle: (params: any) => {
            if (params.node?.rowPinned === 'bottom') {
              return { fontWeight: 'bold' } as any;
            }
            return null as any;
          }
        } as ColDefExt);
        return;
      }

      // DOJ
      if (display === 'DOJ') {
        colDefs.push({
          headerName: display,
          field: key,
          cellRenderer: (params: any) => this.dateRenderer(params),
          comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
          minWidth: 140
        } as ColDefExt);
        return;
      }

      if (display === 'Designation') {
        colDefs.push({
          headerName: display,
          field: key,
          editable: (params: any) => !params.node?.rowPinned,
          cellEditor: 'agTextCellEditor',
          // attach no-suggest handler
          onCellEditorCreated: onCellEditorCreatedNoSuggest,

          cellRenderer: (params: any) => {
            if (params.node?.rowPinned) {
              return `<span style="font-weight:bold;">${params.value ?? ''}</span>`;
            }
            return params.value ?? '';
          },

          valueSetter: (params: any) => {
            const newValue = params.newValue;
            if (params.data[params.colDef.field] === newValue) return false;
            params.data[params.colDef.field] = newValue;
            if (params.data.__rawEmployee) {
              params.data.__rawEmployee.designation = newValue;
            }
            return true;
          },

          onCellValueChanged: (params: any) => {
            if (params.node?.rowPinned) return;
            const { oldValue, newValue } = params;
            if (oldValue === newValue) return;

            if (typeof this.onEditIncrementInputTableData === 'function') {
              const payload = params.data.__rawEmployee ?? params.data;
              this.onEditIncrementInputTableData(payload, params);
            }
          },

          cellStyle: (params: any) => {
            if (params.node?.rowPinned) return { fontWeight: 'bold' };
            return { backgroundColor: '#2244CC44', fontWeight: 'bold' };
          },
          minWidth: 160
        } as ColDefExt);
        return;
      }

      if (display === 'Eligible Emp.') {
        colDefs.push({
          headerName: display,
          field: key,
          editable: false,
          checkboxSelection: false,
          headerCheckboxSelection: false,

          cellStyle: (params: any) => {
            if (params.node?.rowPinned === 'bottom') return { backgroundColor: '#ffffff', fontWeight: 'bold' };
            return { backgroundColor: '#2244CC44', fontWeight: 'bold' };
          },

          cellRenderer: (params: any) => {
            const rowData = params.data;
            const emp = rowData?.__rawEmployee || rowData;

            const isGloballyLocked = this.afterHODForApprovalDate || this.afterMDAndCEOApproval;

            const isRowLocked = emp?.approvedByMd === true || emp?.isMdApproved === true;

            const disabled = isGloballyLocked || isRowLocked;

            if (params.node?.rowPinned === 'bottom') {
              return `<span style="font-weight:bold;">${emp?.isEligible ? 'Yes' : 'No'}</span>`;
            }

            const yesNo = emp?.isEligible ? 'Yes' : 'No';
            const id = `eligible_${params.node.id}`;

            setTimeout(() => {
              const el = document.getElementById(id) as HTMLSelectElement | null;
              if (!el) return;

              if ((el as any).__bound) return;
              (el as any).__bound = true;

              el.onchange = () => {
                if (disabled) return;
                const newVal = el.value === 'Yes';
                this.moveEmployeeBetweenEligibility(rowData, params, newVal);
              };
            });

            return `
        <select id="${id}"
          class="eligible-dropdown"
          style="width:100%;height:30px;padding-left:5px;border-radius:4px;
                 border:1px solid #ccc;font-weight:bold;background-color:transparent;"
          ${disabled ? 'disabled' : ''}
        >
          <option value="Yes" ${yesNo === 'Yes' ? 'selected' : ''}>Yes</option>
          <option value="No"  ${yesNo === 'No' ? 'selected' : ''}>No</option>
        </select>
      `;
          },

          minWidth: 140
        });
        return;
      }

      if (display === 'Promotion') {
        colDefs.push({
          headerName: display,
          field: key,
          editable: false,
          checkboxSelection: false,
          headerCheckboxSelection: false,

          cellStyle: (params: any) => {
            if (params.node?.rowPinned === 'bottom') return { backgroundColor: '#ffffff', fontWeight: 'bold' };
            return { backgroundColor: '#2244CC44', fontWeight: 'bold' };
          },

          cellRenderer: (params: any) => {
            const rowData = params.data;
            const emp = rowData?.__rawEmployee || rowData;

            const isGloballyLocked = this.afterHODForApprovalDate || this.afterMDAndCEOApproval;

            const isRowLocked = emp?.approvedByMd === true || emp?.isMdApproved === true;

            const disabled = isGloballyLocked || isRowLocked;

            if (params.node?.rowPinned === 'bottom') {
              return `<span style="font-weight:bold;">${emp?.isPromoted ? 'Yes' : 'No'}</span>`;
            }

            const yesNo = emp?.isPromoted ? 'Yes' : 'No';
            const id = `promotion_${params.node.id}`;

            setTimeout(() => {
              const el = document.getElementById(id) as HTMLSelectElement | null;
              if (!el) return;

              el.onchange = () => {
                if (disabled) return;
                const newVal = el.value === 'Yes';
                emp.isPromoted = newVal;
                rowData.isPromoted = newVal;

                if (typeof this.onEditIncrementInputTableData === 'function') {
                  this.onEditIncrementInputTableData(emp, params);
                }
              };
            });

            return `
        <select id="${id}"
          class="promotion-dropdown"
          style="width:100%;height:30px;padding-left:5px;border-radius:4px;
                 border:1px solid #ccc;font-weight:bold;background-color:transparent;"
          ${disabled ? 'disabled' : ''}
        >
          <option value="Yes" ${yesNo === 'Yes' ? 'selected' : ''}>Yes</option>
          <option value="No"  ${yesNo === 'No' ? 'selected' : ''}>No</option>
        </select>
      `;
          },

          minWidth: 140
        });
        return;
      }

      if (display === 'Promotion %') {
        colDefs.push({
          headerName: display,
          field: key,
          editable: (params: any) => !params.node?.rowPinned,
          cellEditor: 'agTextCellEditor',
          onCellEditorCreated: onCellEditorCreatedNoSuggest,

          suppressKeyboardEvent: (params: any) => {
            const e = params.event as KeyboardEvent;
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
            if (allowedKeys.includes(e.key)) return false;
            if (e.key === '-' || e.key === 'Minus') {
              e.preventDefault();
              return true;
            }
            if (/^[a-zA-Z]$/.test(e.key)) {
              e.preventDefault();
              return true;
            }
            if (/^[0-9]$/.test(e.key)) return false;
            if (e.key === '.') {
              const cellEditor =
                params.api.getCellEditorInstances?.({
                  rowNodes: [params.node],
                  columns: [params.column]
                }) || [];
              const currentValue = (cellEditor[0] && cellEditor[0].getGui && cellEditor[0].getGui().querySelector ? cellEditor[0].getGui().querySelector('input')?.value : params.value) || params.value || '';
              if (String(currentValue).includes('.')) {
                e.preventDefault();
                return true;
              }
              return false;
            }
            e.preventDefault();
            return true;
          },

          valueParser: (params: any) => {
            const raw = params.newValue;
            if (raw === null || raw === undefined || raw === '') return null;
            let sanitized = String(raw).replace(/[^0-9.]/g, '');
            const dotIndex = sanitized.indexOf('.');
            if (dotIndex >= 0) {
              sanitized = sanitized.slice(0, dotIndex + 1) + sanitized.slice(dotIndex + 1).replace(/\./g, '');
            }
            if (sanitized === '.' || sanitized === '') return null;
            if (sanitized.startsWith('.')) sanitized = '0' + sanitized;
            if (sanitized.endsWith('.')) sanitized = sanitized.slice(0, -1);
            const num = parseFloat(sanitized);
            if (isNaN(num)) return null;
            if (num < 0) return null;
            return num;
          },

          valueSetter: (params: any) => {
            const parsed = params.newValue;
            if (parsed === null || parsed === undefined || isNaN(Number(parsed))) {
              return false;
            }
            const numeric = Number(parsed);
            if (numeric < 0) return false;
            params.data[params.colDef.field] = numeric;
            if (params.data && params.data.__rawEmployee) {
              params.data.__rawEmployee.promotionPercentage = numeric;
            }
            return true;
          },

          cellRenderer: (params: any) => {
            if (params.node?.rowPinned) return params.value ?? '';
            if (params.value === null || params.value === undefined || params.value === '') {
              return `<span style="opacity:0.6;">Type here</span>`;
            }
            return params.value;
          },

          onCellValueChanged: (params: any) => {
            if (params.node?.rowPinned) return;
            const rawNew = params.newValue;
            const num = rawNew === null || rawNew === undefined || rawNew === '' ? null : Number(String(rawNew).replace(/[^0-9.]/g, ''));
            const final = isNaN(num as number) ? null : num;
            const row = params.data || {};
            const emp = row.__rawEmployee || row;
            if (emp) emp.promotionPercentage = final;
            (row as any).promotionPercentage = final;
            if (typeof this.onEditIncrementInputTableData === 'function') {
              this.onEditIncrementInputTableData(emp || row, params);
            }
          },

          cellStyle: (params: any) => {
            if (params.node?.rowPinned) return { fontWeight: 'bold' } as any;
            return { backgroundColor: '#2244CC44', fontWeight: 'bold' } as any;
          },

          minWidth: 130,
          cellClass: (p: any) => (p.node?.rowPinned === 'bottom' ? 'footer-total-cell-aggrid ag-right-aligned' : 'ag-right-aligned')
        } as ColDefExt);
        return;
      }

      if (display === 'Increment Letter Format') {
        colDefs.push({
          headerName: display,
          field: key,
          minWidth: 220,
          sortable: false,
          filter: false,
          cellRenderer: (params: any) => {
            if (params.node?.rowPinned === 'bottom') return '';
            const emp = params.data?.__rawEmployee || params.data;
            const text = emp?.incrementLetterFormat?.letterName || 'Letter not found';
            return `<span style="color: orange; text-decoration: underline; cursor: pointer;">${text}</span>`;
          },
          cellStyle: (params: any) => {
            if (params.node?.rowPinned === 'bottom') return { fontWeight: 'bold' } as any;
            return null as any;
          },
          onCellClicked: (params: any) => {
            if (params.node?.rowPinned === 'bottom') return;
            const emp = params.data?.__rawEmployee || params.data;
            const userId = emp?.userId;
            if (userId && typeof this.onClickShowIncrementLetter === 'function') {
              this.onClickShowIncrementLetter(userId);
            }
          }
        } as ColDefExt);
        return;
      }

      if (display === 'Market BenchMark CTC') {
        colDefs.push({
          headerName: display,
          field: key,
          editable: (params: any) => !params.node?.rowPinned,
          cellEditor: 'agTextCellEditor',
          onCellEditorCreated: onCellEditorCreatedNoSuggest,
          cellRenderer: (params: any) => {
            if (params.node?.rowPinned) return params.value ?? '';
            if (params.value === null || params.value === undefined || params.value === '') {
              return `<span style="opacity:0.6;">Type here</span>`;
            }
            return params.value;
          },

          suppressKeyboardEvent: (params: any) => {
            const e = params.event as KeyboardEvent;
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
            if (allowedKeys.includes(e.key)) return false;

            if (/^[a-zA-Z]$/.test(e.key)) {
              e.preventDefault();
              return true;
            }

            if (e.key === '-' || e.key === 'Minus' || e.key === '+' || e.key === 'Plus') {
              e.preventDefault();
              return true;
            }

            if (/^[0-9]$/.test(e.key)) return false;

            if (e.key === '.') {
              const current = params.value ?? '';
              if (String(current).includes('.')) {
                e.preventDefault();
                return true;
              }
              return false;
            }

            e.preventDefault();
            return true;
          },

          valueParser: (params: any) => {
            const raw = params.newValue;
            if (raw === null || raw === undefined || raw === '') return null;

            let sanitized = String(raw).replace(/[^0-9.]/g, '');
            const dotIndex = sanitized.indexOf('.');
            if (dotIndex >= 0) {
              sanitized = sanitized.slice(0, dotIndex + 1) + sanitized.slice(dotIndex + 1).replace(/\./g, '');
            }

            if (sanitized === '.' || sanitized === '') return null;
            if (sanitized.startsWith('.')) sanitized = '0' + sanitized;
            if (sanitized.endsWith('.')) sanitized = sanitized.slice(0, -1);

            const num = parseFloat(sanitized);
            return isNaN(num) ? null : num;
          },

          onCellValueChanged: (params: any) => {
            if (params.node?.rowPinned) return;

            const oldVal = params.oldValue;
            const newVal = params.newValue;

            if (oldVal === newVal || (oldVal == null && newVal == null)) return;

            const rowEmp = params.data?.__rawEmployee ?? params.data;
            if (rowEmp) {
              rowEmp.marketBenchMarkCtc = newVal;
            }

            if (typeof this.onEditIncrementInputTableData === 'function') {
              this.onEditIncrementInputTableData(rowEmp, params);
            }
          },
          cellStyle: (params: any): any => {
            if (params.node?.rowPinned) return { fontWeight: 'bold' } as any;
            return { backgroundColor: '#2244CC44', fontWeight: 'bold' } as any;
          },
          minWidth: 180,
          cellClass: (p: any) => (p.node?.rowPinned === 'bottom' ? 'footer-total-cell-aggrid ag-right-aligned' : 'ag-right-aligned')
        } as ColDefExt);
        return;
      }

      if (display === 'Market Correction %') {
        colDefs.push({
          headerName: display,
          field: key,
          editable: (params: any) => !params.node?.rowPinned,
          cellEditor: 'agTextCellEditor',
          onCellEditorCreated: onCellEditorCreatedNoSuggest,

          suppressKeyboardEvent: (params: any) => {
            const e = params.event as KeyboardEvent;
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
            if (allowedKeys.includes(e.key)) return false;

            if (/^[a-zA-Z]$/.test(e.key)) {
              e.preventDefault();
              return true;
            }

            if (e.key === '-' || e.key === 'Minus') {
              e.preventDefault();
              return true;
            }

            if (/^[0-9]$/.test(e.key)) return false;

            if (e.key === '.') {
              const current = params.value ?? '';
              if (String(current).includes('.')) {
                e.preventDefault();
                return true;
              }
              return false;
            }

            e.preventDefault();
            return true;
          },

          valueParser: (params: any) => {
            const raw = params.newValue;
            if (raw === null || raw === undefined || raw === '') return null;

            let sanitized = String(raw).replace(/[^0-9.]/g, '');
            const dotIndex = sanitized.indexOf('.');
            if (dotIndex >= 0) {
              sanitized = sanitized.slice(0, dotIndex + 1) + sanitized.slice(dotIndex + 1).replace(/\./g, '');
            }

            if (sanitized === '.' || sanitized === '') return null;
            if (sanitized.startsWith('.')) sanitized = '0' + sanitized;
            if (sanitized.endsWith('.')) sanitized = sanitized.slice(0, -1);

            const num = parseFloat(sanitized);
            return isNaN(num) ? null : num;
          },

          valueFormatter: (params: any) => (params.value === null || params.value === undefined ? '' : params.value),

          cellRenderer: (params: any) => {
            if (params.node?.rowPinned) return params.value ?? '';
            if (params == null || params.value === null || params.value === undefined || params.value === '') {
              return `<span style="opacity:0.6;">Type here</span>`;
            }
            return params.value;
          },

          onCellValueChanged: (params: any) => {
            if (params.node?.rowPinned) return;
            const emp = params.data?.__rawEmployee || params.data;
            const parsed = params.newValue === null || params.newValue === undefined || params.newValue === '' ? null : Number(params.newValue);
            if (emp) {
              emp.marketCorrectionPercentage = parsed;
              if (typeof this.onEditIncrementInputTableData === 'function') {
                this.onEditIncrementInputTableData(emp, params);
              }
              try {
                if (typeof this.calculateInputEligibleTotals === 'function') {
                  this.calculateInputEligibleTotals(this.getIncrementInputEligibleTableData);
                }
                if (typeof this.buildPinnedBottomTotalsEligible === 'function') {
                  this.buildPinnedBottomTotalsEligible();
                }
              } catch (e) {}
            }
          },

          cellStyle: (params: any): any => {
            if (params.node?.rowPinned) return { fontWeight: 'bold' } as any;
            return { backgroundColor: '#2244CC44', fontWeight: 'bold' } as any;
          },

          minWidth: 160,
          cellClass: (p: any) => (p.node?.rowPinned === 'bottom' ? 'footer-total-cell-aggrid ag-right-aligned' : 'ag-right-aligned')
        } as ColDefExt);
        return;
      }

      if (display === 'HOD Approved Increment %') {
        colDefs.push({
          headerName: display,
          field: key,
          editable: (params: any) => {
            if (params.node?.rowPinned) return false;
            return this.loggedInUserRole === 'HOD';
          },
          cellEditor: 'agTextCellEditor',
          onCellEditorCreated: onCellEditorCreatedNoSuggest,

          suppressKeyboardEvent: (params: any) => {
            const e = params.event as KeyboardEvent;
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
            if (allowedKeys.includes(e.key)) return false;
            if (e.key === '-' || e.key === 'Minus') {
              e.preventDefault();
              return true;
            }
            if (/^[a-zA-Z]$/.test(e.key)) {
              e.preventDefault();
              return true;
            }
            if (/^[0-9]$/.test(e.key)) return false;
            if (e.key === '.') {
              const current = String(params.value || '');
              if (current.includes('.')) {
                e.preventDefault();
                return true;
              }
              return false;
            }
            e.preventDefault();
            return true;
          },
          valueParser: (params: any) => {
            const raw = params.newValue;
            if (!raw) return null;
            let sanitized = String(raw).replace(/[^0-9.]/g, '');
            const dot = sanitized.indexOf('.');
            if (dot >= 0) {
              sanitized = sanitized.slice(0, dot + 1) + sanitized.slice(dot + 1).replace(/\./g, '');
            }
            if (sanitized === '.' || sanitized === '') return null;
            if (sanitized.startsWith('.')) sanitized = '0' + sanitized;
            if (sanitized.endsWith('.')) sanitized = sanitized.slice(0, -1);
            const num = parseFloat(sanitized);
            if (isNaN(num) || num < 0) return null;
            return num;
          },
          valueFormatter: (params: any) => (params.value === null || params.value === undefined ? '' : params.value),
          onCellValueChanged: (params: any) => {
            if (params.node?.rowPinned) return;
            const numeric = params.newValue === null || params.newValue === undefined ? null : Number(params.newValue);
            const emp = params.data?.__rawEmployee;
            if (emp) emp.hodIncrementPercentage = numeric;
            params.data[params.colDef.field] = numeric;
            if (typeof this.onEditIncrementInputTableData === 'function') {
              this.onEditIncrementInputTableData(emp || params.data, params);
            }
            try {
              this.calculateInputEligibleTotals?.(this.getIncrementInputEligibleTableData);
              this.buildPinnedBottomTotalsEligible?.();
            } catch {}
          },
          cellRenderer: (params: any) => {
            if (params.node?.rowPinned) return params.value ?? '';
            if (params.value === null || params.value === undefined) {
              return `<span style="opacity:0.6;">Type here</span>`;
            }
            return params.value;
          },
          cellStyle: (params: any): any => {
            if (params.node?.rowPinned)
              return {
                backgroundColor: 'transparent',
                fontWeight: 'bold'
              } as any;
            const isEditable = this.loggedInUserRole === 'HOD';
            return isEditable
              ? ({ backgroundColor: '#2244CC44', fontWeight: 'bold' } as any)
              : ({
                  backgroundColor: 'transparent',
                  fontWeight: 'normal'
                } as any);
          },
          minWidth: 160,
          cellClass: (p: any) => (p.node?.rowPinned === 'bottom' ? 'footer-total-cell-aggrid ag-right-aligned' : 'ag-right-aligned')
        } as ColDefExt);
        return;
      }

      if (display === 'HR Admin & MD/CEO Approved Increment %') {
        colDefs.push({
          headerName: display,
          field: key,
          editable: (params: any) => {
            if (params.node?.rowPinned) return false;
            if (this.isShowExcelData) return false;
            const role = (this.loggedInUserRole || '').toString().toLowerCase();
            return role.includes('hr') || role.includes('admin') || role.includes('super admin');
          },
          cellEditor: 'agTextCellEditor',
          onCellEditorCreated: onCellEditorCreatedNoSuggest,

          suppressKeyboardEvent: (params: any) => {
            const e = params.event as KeyboardEvent;
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
            if (allowedKeys.includes(e.key)) return false;
            if (e.key === '-' || e.key === 'Minus') {
              e.preventDefault();
              return true;
            }
            if (/^[a-zA-Z]$/.test(e.key)) {
              e.preventDefault();
              return true;
            }
            if (/^[0-9]$/.test(e.key)) return false;
            if (e.key === '.') {
              const currentValue = String(params.value || '');
              if (currentValue.includes('.')) {
                e.preventDefault();
                return true;
              }
              return false;
            }
            e.preventDefault();
            return true;
          },
          valueParser: (params: any) => {
            const raw = params.newValue;
            if (raw === null || raw === undefined || raw === '') return null;
            let sanitized = String(raw).replace(/[^0-9.]/g, '');
            const dotIndex = sanitized.indexOf('.');
            if (dotIndex >= 0) {
              sanitized = sanitized.slice(0, dotIndex + 1) + sanitized.slice(dotIndex + 1).replace(/\./g, '');
            }
            if (sanitized === '.' || sanitized === '') return null;
            if (sanitized.startsWith('.')) sanitized = '0' + sanitized;
            if (sanitized.endsWith('.')) sanitized = sanitized.slice(0, -1);
            const num = parseFloat(sanitized);
            if (isNaN(num) || num < 0) return null;
            return num;
          },
          valueFormatter: (params: any) => (params.value === null || params.value === undefined ? '' : params.value),
          onCellValueChanged: (params: any) => {
            if (params.node?.rowPinned) return;
            const newVal = params.newValue;
            const numeric = newVal === null || newVal === undefined || newVal === '' ? null : Number(newVal);
            const emp = params.data?.__rawEmployee;
            if (emp) {
              emp.hrAndMdIncrementPercentage = numeric;
            }
            if (params.data) params.data[params.colDef.field] = numeric;
            if (typeof this.onEditIncrementInputTableData === 'function') {
              this.onEditIncrementInputTableData(emp || params.data, params);
            }
            try {
              if (typeof this.calculateInputEligibleTotals === 'function') {
                this.calculateInputEligibleTotals(this.getIncrementInputEligibleTableData);
              }
              if (typeof this.buildPinnedBottomTotalsEligible === 'function') {
                this.buildPinnedBottomTotalsEligible();
              }
            } catch (e) {}
          },
          cellRenderer: (params: any) => {
            if (params.node?.rowPinned) return params.value ?? '';
            if (params.value === null || params.value === undefined || params.value === '') {
              return `<span style="opacity:0.6;">Type here</span>`;
            }
            return params.value;
          },
          cellStyle: (params: any): any => {
            if (params.node?.rowPinned)
              return {
                backgroundColor: 'transparent',
                fontWeight: 'bold'
              } as any;
            const role = (this.loggedInUserRole || '').toString().toLowerCase();
            const editable = (role.includes('hr') || role.includes('admin') || role.includes('super admin')) && !this.isShowExcelData;
            return editable
              ? ({ backgroundColor: '#2244CC44', fontWeight: 'bold' } as any)
              : ({
                  backgroundColor: 'transparent',
                  fontWeight: 'normal'
                } as any);
          },
          minWidth: 180,
          cellClass: (p: any) => (p.node?.rowPinned === 'bottom' ? 'footer-total-cell-aggrid ag-right-aligned' : 'ag-right-aligned')
        } as ColDefExt);
        return;
      }

      if (display === 'Band') {
        colDefs.push({
          headerName: display,
          field: key,
          rowSpan: (params: any) => params.data?.__bandRowSpan || 1,
          cellClass: ['vertically-centered-cell'],
          suppressMenu: true,
          sortable: true,
          resizable: true,
          minWidth: 140
        } as ColDefExt);
        return;
      }

      if (display === 'Individual KPI + Competency Score') {
        colDefs.push({
          headerName: display,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          minWidth: 160,
          valueFormatter: (params: any) => (params.value === null || params.value === undefined ? '' : fmtIfLongDecimal(params.value)),
          cellClass: (p: any) => (p.node?.rowPinned === 'bottom' ? 'footer-total-cell-aggrid ag-right-aligned' : 'ag-right-aligned')
        } as ColDefExt);
        return;
      }

      if (display === 'Department Score (out of 100)') {
        colDefs.push({
          headerName: display,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          minWidth: 160,
          valueFormatter: (params: any) => (params.value === null || params.value === undefined ? '' : fmtIfLongDecimal(params.value)),
          cellClass: (p: any) => (p.node?.rowPinned === 'bottom' ? 'footer-total-cell-aggrid ag-right-aligned' : 'ag-right-aligned')
        } as ColDefExt);
        return;
      }

      if (display === 'Company Score (out of 100)') {
        colDefs.push({
          headerName: display,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          minWidth: 160,
          valueFormatter: (params: any) => (params.value === null || params.value === undefined ? '' : fmtIfLongDecimal(params.value)),
          cellClass: (p: any) => (p.node?.rowPinned === 'bottom' ? 'footer-total-cell-aggrid ag-right-aligned' : 'ag-right-aligned')
        } as ColDefExt);
        return;
      }

      if (display === 'Final Score') {
        colDefs.push({
          headerName: display,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          minWidth: 160,
          valueFormatter: (params: any) => (params.value === null || params.value === undefined ? '' : fmtIfLongDecimal(params.value)),
          cellClass: (p: any) => (p.node?.rowPinned === 'bottom' ? 'footer-total-cell-aggrid ag-right-aligned' : 'ag-right-aligned')
        } as ColDefExt);
        return;
      }

      if (deltaAnimatedHeaders.includes(display)) {
        colDefs.push({
          headerName: display,
          field: key,
          tooltipField: key,
          sortable: true,
          filter: true,
          resizable: true,
          minWidth: 120,
          cellRenderer: 'agAnimateShowChangeCellRenderer',
          valueFormatter: (params: any) => {
            if (params.value === null || params.value === undefined || params.value === '') return '';
            const num = Number(params.value);
            return isNaN(num) ? params.value : num.toLocaleString('en-IN', { maximumFractionDigits: 2 });
          },
          cellClass: (params: any) => {
            if (params && params.node && params.node.rowPinned === 'bottom') return 'footer-total-cell-aggrid ag-right-aligned';
            return 'ag-right-aligned';
          }
        } as ColDefExt);
        return;
      }

      colDefs.push({
        headerName: display,
        field: key,
        tooltipField: key,
        sortable: true,
        filter: true,
        resizable: true,
        minWidth: 100,
        cellClass: (params: any) => {
          if (params && params.node && params.node.rowPinned === 'bottom') return 'footer-total-cell-aggrid';
          return null;
        }
      } as ColDefExt);
    });

    // ----------------- GLOBAL & PER-ROW LOCKING: HOD / MD -----------------
    colDefs.forEach((c: any) => {
      const originalEditable = c.editable;

      c.editable = (params: any) => {
        if (params?.node?.rowPinned) return false;

        if (this.afterHODForApprovalDate) return false;

        if (this.afterMDAndCEOApproval) return false;

        try {
          const emp = params?.data?.__rawEmployee;
          if (emp && (emp.approvedByMd === true || emp.isMdApproved === true)) {
            return false;
          }
        } catch (e) {}

        if (typeof originalEditable === 'function') {
          try {
            return originalEditable.call(this, params);
          } catch (e) {
            console.error('editable wrapper: original editable threw', e);
            return false;
          }
        }

        if (typeof originalEditable === 'boolean') return originalEditable;

        return false;
      };
    });

    this.incrementColumnDefs = colDefs;

    if (this.incrementEligibleRowData && this.incrementEligibleRowData.length > 0) {
      console.log('incrementColumnDefs:', this.incrementColumnDefs);
      console.log('First row of incrementEligibleRowData:', this.incrementEligibleRowData[0]);
    } else {
      console.log('incrementColumnDefs:', this.incrementColumnDefs);
      console.log('incrementEligibleRowData is empty or undefined');
    }
  }

  refreshEligibleRow(params: any) {
    try {
      if (this.gridApiIncrementInputEligible) {
        this.gridApiIncrementInputEligible.refreshCells({
          rowNodes: [params.node],
          force: true
        });

        // Recalculate totals if exists
        if (typeof this.buildPinnedBottomTotalsEligible === 'function') {
          this.buildPinnedBottomTotalsEligible();
        }
      }
    } catch (e) {
      console.warn('refreshEligibleRow failed:', e);
    }
  }

  buildIncrementRowData(departments: any[] = []): any[] {
    const rows: any[] = [];

    if (!Array.isArray(departments) || departments.length === 0) return rows;

    const setRowValue = (row: any, displayName: string, backendKey: string | null, value: any) => {
      try {
        const gridKey = this.fieldKeyFromDisplayName(displayName);
        if (gridKey) row[gridKey] = value;
      } catch (e) {
        /* ignore */
      }

      if (backendKey) {
        row[backendKey] = value;
      }

      const legacyKey = displayName
        .replace(/\s+/g, '_')
        .replace(/[()&,+%/]/g, '')
        .replace(/__+/g, '_')
        .replace(/_$/g, '');
      if (legacyKey && legacyKey !== displayName) {
        row[legacyKey] = value;
      }
    };

    departments.forEach((dept: any) => {
      const deptTotalRows = (dept.bandGrades || []).reduce((acc: number, bg: any) => acc + ((bg.employeeData || []).length || 0), 0);

      (dept.bandGrades || []).forEach((bandGrade: any) => {
        const bandLen = (bandGrade.employeeData || []).length || 0;

        (bandGrade.employeeData || []).forEach((emp: any, empIndex: number) => {
          const row: any = {};

          setRowValue(row, 'Department', 'departmentName', dept.departmentName);
          row['Department'] = dept.departmentName;
          setRowValue(row, 'Band', 'band', bandGrade.band);
          row['Band'] = bandGrade.band;
          setRowValue(row, 'Employee', 'employeeName', emp.employeeName);
          row['Employee'] = emp.employeeName;
          setRowValue(row, 'Manager', 'managerName', emp.managerName);
          row['Manager'] = emp.managerName;
          setRowValue(row, 'HOD', 'hodName', emp.hodName);
          row['HOD'] = emp.hodName;
          setRowValue(row, 'Designation', 'designation', emp.designation);
          row['Designation'] = emp.designation;
          setRowValue(row, 'DOJ', 'dateOfJoining', emp.dateOfJoining);
          row['DOJ'] = emp.dateOfJoining;

          setRowValue(row, 'Total CTC p.m.', 'monthlyCtc', emp.monthlyCtc);
          row['monthlyCtc'] = emp.monthlyCtc;
          setRowValue(row, 'Total CTC p.a.', 'annualCtc', emp.annualCtc);
          row['annualCtc'] = emp.annualCtc;

          setRowValue(row, 'Eligible Emp.', 'isEligible', emp.isEligible === true ? 'Yes' : 'No');
          row['isEligible'] = emp.isEligible === true ? 'Yes' : 'No';

          setRowValue(row, 'Promotion %', 'promotionPercentage', emp.promotionPercentage);
          row['promotionPercentage'] = emp.promotionPercentage;
          setRowValue(row, 'Market BenchMark CTC', 'marketBenchMarkCtc', emp.marketBenchMarkCtc);
          row['marketBenchMarkCtc'] = emp.marketBenchMarkCtc;
          setRowValue(row, 'Market Correction %', 'marketCorrectionPercentage', emp.marketCorrectionPercentage);
          row['marketCorrectionPercentage'] = emp.marketCorrectionPercentage;

          setRowValue(row, 'Individual KPI + Competency Score', 'individualKpiCompetencyScore', emp.individualKpiCompetencyScore);
          row['individualKpiCompetencyScore'] = emp.individualKpiCompetencyScore;

          setRowValue(row, 'Department Score (out of 100)', 'deptScore', emp.deptScore);
          row['deptScore'] = emp.deptScore;

          setRowValue(row, 'Company Score (out of 100)', 'companyScore', emp.companyScore);
          row['companyScore'] = emp.companyScore;

          setRowValue(row, 'Final Score', 'finalScore', emp.finalScore);
          row['finalScore'] = emp.finalScore;

          setRowValue(row, 'Final Rating', 'finalRating', emp.finalRating);
          row['finalRating'] = emp.finalRating;

          setRowValue(row, 'Increment %', 'incrementPercentage', emp.incrementPercentage);
          row['incrementPercentage'] = emp.incrementPercentage;

          setRowValue(row, 'Days Served in the Increment Period', 'daysServed', emp.daysServed);
          row['daysServed'] = emp.daysServed;

          setRowValue(row, 'Prorated Increment %', 'proratedIncrementPercentage', emp.proratedIncrementPercentage);
          row['proratedIncrementPercentage'] = emp.proratedIncrementPercentage;

          setRowValue(row, 'Increment Amount', 'incrementAmount', emp.incrementAmount);
          row['incrementAmount'] = emp.incrementAmount;

          setRowValue(row, 'No Promotion Last 3 Year', 'noOfPromotions', emp.noOfPromotions);
          row['noOfPromotions'] = emp.noOfPromotions;

          setRowValue(row, 'Promotion', 'isPromoted', emp.isPromoted === true ? 'Yes' : 'No');
          row['isPromoted'] = emp.isPromoted === true ? 'Yes' : 'No';
          setRowValue(row, 'Promotion Amount', 'promotionAmount', emp.promotionAmount);
          row['promotionAmount'] = emp.promotionAmount;

          setRowValue(row, 'Updated CTC after Increment & Promotion', 'updatedCtcAfterIncrementAndPromotion', emp.updatedCtcAfterIncrementAndPromotion);
          row['updatedCtcAfterIncrementAndPromotion'] = emp.updatedCtcAfterIncrementAndPromotion;

          setRowValue(row, 'Market Correction Amount', 'marketCorrectionAmount', emp.marketCorrectionAmount);
          row['marketCorrectionAmount'] = emp.marketCorrectionAmount;

          setRowValue(row, 'Final Increment % p.a', 'finalIncrementPercentage', emp.finalIncrementPercentage);
          row['finalIncrementPercentage'] = emp.finalIncrementPercentage;
          row['Final_Increment_%_p.a'] = emp.finalIncrementPercentage;

          row['yearBeforeLastYrIncrementPercentage'] = emp.yearBeforeLastYrIncrementPercentage;
          row['Increment_%_in_2022'] = emp.yearBeforeLastYrIncrementPercentage;

          row['lastToLastYrIncrementPercentage'] = emp.lastToLastYrIncrementPercentage;
          row['Increment_%_in_2023'] = emp.lastToLastYrIncrementPercentage;

          row['lastYrIncrementPercentage'] = emp.lastYrIncrementPercentage;
          row['Increment_%_in_2024'] = emp.lastYrIncrementPercentage;

          setRowValue(row, 'HOD Approved Increment %', 'hodIncrementPercentage', emp.hodIncrementPercentage);
          row['hodIncrementPercentage'] = emp.hodIncrementPercentage;
          setRowValue(row, 'HR Admin & MD/CEO Approved Increment %', 'hrAndMdIncrementPercentage', emp.hrAndMdIncrementPercentage);
          row['hrAndMdIncrementPercentage'] = emp.hrAndMdIncrementPercentage;

          setRowValue(row, 'Final Increment Amount', 'finalIncrementAmount', emp.finalIncrementAmount);
          row['finalIncrementAmount'] = emp.finalIncrementAmount;

          setRowValue(row, 'Final Annual Revised CTC (post increment)', 'finalAnnualCtc', emp.finalAnnualCtc);
          row['finalAnnualCtc'] = emp.finalAnnualCtc;

          setRowValue(row, 'Final Monthly Revised CTC (post increment)', 'finalMonthlyCtc', emp.finalMonthlyCtc);
          row['finalMonthlyCtc'] = emp.finalMonthlyCtc;

          setRowValue(row, 'Increment Letter Format', 'incrementLetterFormat', emp.incrementLetterFormat?.letterName || 'Letter not found');
          row['incrementLetterFormat'] = emp.incrementLetterFormat || null;
          row['Increment_Letter_Format'] = emp.incrementLetterFormat?.letterName || 'Letter not found';

          row.__rawEmployee = emp;
          row.__deptRowSpan = 0;
          row.__bandRowSpan = 0;

          if (empIndex === 0) {
            row.__bandRowSpan = bandLen || 1;
          }

          rows.push(row);
        });
      });

      const firstIndex = rows.findIndex(r => r[this.fieldKeyFromDisplayName('Department')] === dept.departmentName || r['Department'] === dept.departmentName);
      if (firstIndex !== -1) {
        rows[firstIndex].__deptRowSpan = deptTotalRows || 1;
      }
    });

    return rows;
  }

  onEligibleGridReady(params: any): void {
    this.gridApiIncrementInputEligible = params.api;
    this.gridColumnApiIncrementInputEligible = params.columnApi;
    this.gridApiEligible = params.api;
    this.gridColumnApiEligible = params.columnApi;

    if (this.incrementEligibleRowData && this.incrementEligibleRowData.length) {
      if ((this.gridApiEligible as any).setRowData) {
        (this.gridApiEligible as any).setRowData(this.incrementEligibleRowData);
      } else {
      }
    }

    if (this.pinnedBottomRowDataEligible && this.pinnedBottomRowDataEligible.length) {
      if ((this.gridApiEligible as any).setPinnedBottomRowData) {
        (this.gridApiEligible as any).setPinnedBottomRowData(this.pinnedBottomRowDataEligible);
      } else if ((this.gridApiEligible as any).setPinnedBottomData) {
        (this.gridApiEligible as any).setPinnedBottomData(this.pinnedBottomRowDataEligible);
      } else {
      }
    }
  }
  buildPinnedBottomTotalsEligible(): void {
    const totalsRow: any = {};

    totalsRow[this.fieldKeyFromDisplayName('Department')] = 'Total';
    totalsRow[this.fieldKeyFromDisplayName('Band')] = '';
    totalsRow[this.fieldKeyFromDisplayName('Employee')] = '';
    totalsRow[this.fieldKeyFromDisplayName('Manager')] = '';
    totalsRow[this.fieldKeyFromDisplayName('HOD')] = '';
    totalsRow[this.fieldKeyFromDisplayName('Designation')] = '';

    totalsRow[this.fieldKeyFromDisplayName('Total CTC p.m.')] = this.totalEligibleTotalFixedCtcPM || 0;
    totalsRow[this.fieldKeyFromDisplayName('Total CTC p.a.')] = this.totalEligibleTotalFixedCtcPA || 0;
    totalsRow[this.fieldKeyFromDisplayName('Eligible Emp.')] = this.totalEligibleEligibleEmp || 0;
    totalsRow[this.fieldKeyFromDisplayName('Final Rating')] = this.totalEligibleFinalRating || 0;
    totalsRow[this.fieldKeyFromDisplayName('Increment %')] = this.totalEligibleIncrementPct || 0;
    totalsRow[this.fieldKeyFromDisplayName('Days Served in the Increment Period')] = this.totalEligibleDaysServedinIncrementPeriod || 0;
    totalsRow[this.fieldKeyFromDisplayName('Prorated Increment %')] = this.totalEligibleProratedIncrementPct || 0;
    totalsRow[this.fieldKeyFromDisplayName('Increment Amount')] = this.totalEligibleIncrementAmount || 0;
    totalsRow[this.fieldKeyFromDisplayName('No Promotion Last 3 Year')] = this.totalEligibleNoOfPromotionPct || 0;
    totalsRow[this.fieldKeyFromDisplayName('Promotion %')] = this.totalEligiblePromotionPct || 0;
    totalsRow[this.fieldKeyFromDisplayName('Promotion Amount')] = this.totalEligiblePromotionAmount || 0;
    totalsRow[this.fieldKeyFromDisplayName('Updated CTC after Increment & Promotion')] = this.totalEligibleupdatedCtcAfterIAndP || 0;
    totalsRow[this.fieldKeyFromDisplayName('Market BenchMark CTC')] = this.totalEligibleMarketBenchMarkCtc || 0;
    totalsRow[this.fieldKeyFromDisplayName('Market Correction %')] = this.totalEligiblemarketCorrectionPct || 0;
    totalsRow[this.fieldKeyFromDisplayName('Market Correction Amount')] = this.totalEligibleMarketCorrectionAmount || 0;
    totalsRow[this.fieldKeyFromDisplayName('Final Increment % p.a')] = this.totalEligibleFinalIncrementPct || 0;
    totalsRow[this.fieldKeyFromDisplayName('HOD Approved Increment %')] = this.totalEligibleHODIncrementPct || 0;
    totalsRow[this.fieldKeyFromDisplayName('HR Admin & MD/CEO Approved Increment %')] = this.totalEligibleHrAndMdIncrementPct || 0;
    totalsRow[this.fieldKeyFromDisplayName('Final Increment Amount')] = this.totalEligibleFinalIncrementAmount || 0;
    totalsRow[this.fieldKeyFromDisplayName('Final Annual Revised CTC (post increment)')] = this.totalEligibleFinalAnnualCtc || 0;
    totalsRow[this.fieldKeyFromDisplayName('Final Monthly Revised CTC (post increment)')] = this.totalEligibleFinalMonthlyCtc || 0;

    this.pinnedBottomRowDataEligible = [totalsRow];

    if (this.gridApiEligible && (this.gridApiEligible as any).setPinnedBottomRowData) {
      try {
        (this.gridApiEligible as any).setPinnedBottomRowData(this.pinnedBottomRowDataEligible);
      } catch (e) {
        try {
          (this.gridApiEligible as any).setPinnedBottomData(this.pinnedBottomRowDataEligible);
        } catch (_) {}
      }
    }

    try {
      this.cd.detectChanges();
    } catch (e) {}
  }
  prepareNonEligibleRowData() {
    const raw = this.getIncrementInputNonEligibleTableData;

    const source = !raw ? [] : Array.isArray(raw) ? raw : [raw];

    const result: any[] = [];
    const headers = this.IncrementInputTableHideShowAllData || [];

    (source || []).forEach((dept: any) => {
      (dept.bandGrades || []).forEach((band: any) => {
        (band.employeeData || []).forEach((emp: any) => {
          const row: any = {};

          headers.forEach((col: any) => {
            if (!col?.fieldName) return;

            const display = col.fieldName;

            const gridKey = this.fieldKeyFromDisplayName(display);
            if (!gridKey) return;

            if (display === 'Department') {
              row[gridKey] = dept.departmentName;
              return;
            }

            if (display === 'Band') {
              row[gridKey] = band.band;
              return;
            }

            const backendKey = this.mapFieldName(display);
            if (backendKey && Object.prototype.hasOwnProperty.call(emp, backendKey)) {
              row[gridKey] = (emp as any)[backendKey];
            }
          });

          row.__rawEmployee = emp;

          result.push(row);
        });
      });
    });

    this.incrementNonEligibleRowData = result;

    if (result.length) {
      console.log('📌 Non-Eligible first row (flattened):', result[0]);
    }
  }

  mapFieldName(name: string) {
    switch (name) {
      case 'Department':
        return 'departmentName';
      case 'Band':
        return 'band';
      case 'Employee':
        return 'employeeName';
      case 'Manager':
        return 'managerName';
      case 'HOD':
        return 'hodName';
      case 'Designation':
        return 'designation';
      case 'DOJ':
        return 'dateOfJoining';
      case this.incrementCtcPerMonth:
        return 'monthlyCtc';
      case this.incrementCtcPerYear:
        return 'annualCtc';
      case 'Eligible Emp.':
        return 'isEligible';
      case 'Individual KPI + Competency Score':
        return 'individualKpiCompetencyScore';
      case 'Department Score (out of 100)':
        return 'deptScore';
      case 'Company Score (out of 100)':
        return 'companyScore';
      case 'Final Score':
        return 'finalScore';
      case 'Final Rating':
        return 'finalRating';
      case 'Increment %':
        return 'incrementPercentage';
      case 'Days Served in the Increment Period':
        return 'daysServed';
      case 'Prorated Increment %':
        return 'proratedIncrementPercentage';
      case 'Increment Amount':
        return 'incrementAmount';
      case 'No Promotion Last 3 Year':
        return 'noOfPromotions';
      case 'Promotion %':
        return 'promotionPercentage';
      case 'Promotion Amount':
        return 'promotionAmount';
      case 'Updated CTC after Increment & Promotion':
        return 'updatedCtcAfterIncrementAndPromotion';
      case 'Market BenchMark CTC':
        return 'marketBenchMarkCtc';
      case 'Market Correction %':
        return 'marketCorrectionPercentage';
      case 'Market Correction Amount':
        return 'marketCorrectionAmount';
      case 'Final Increment % p.a':
        return 'finalIncrementPercentage';
      case 'HOD Approved Increment %':
        return 'hodIncrementPercentage';
      case 'HR Admin & MD/CEO Approved Increment %':
        return 'hrAndMdIncrementPercentage';
      case 'Final Increment Amount':
        return 'finalIncrementAmount';
      case 'Final Annual Revised CTC (post increment)':
        return 'finalAnnualCtc';
      case 'Final Monthly Revised CTC (post increment)':
        return 'finalMonthlyCtc';
      default:
        return null;
    }
  }
  onNonEligibleGridReady(event: any) {
    console.log('NON-ELIGIBLE GRID READY FIRED');

    this.gridApiIncrementInputNonEligible = event.api;
    this.gridColumnApiIncrementInputNonEligible = event.columnApi;

    this.gridApiNonEligible = event.api;
    this.gridColumnApiNonEligible = event.columnApi;

    if (this.incrementNonEligibleRowData && this.incrementNonEligibleRowData.length) {
      this.gridApiIncrementInputNonEligible.setRowData(this.incrementNonEligibleRowData);
    }

    if (this.pinnedBottomRowDataNonEligible && this.pinnedBottomRowDataNonEligible.length) {
      this.gridApiIncrementInputNonEligible.setPinnedBottomRowData(this.pinnedBottomRowDataNonEligible);
    }
  }

  buildIncrementInputEligibleRowData() {
    const source = this.getIncrementInputEligibleTableData || [];
    const rows: any[] = [];

    for (const dept of source) {
      const deptName = dept.departmentName;
      const bandGrades = dept.bandGrades || [];

      const totalDeptRows = bandGrades.reduce((sum: number, bg: any) => sum + (bg.employeeData ? bg.employeeData.length : 0), 0);

      let isFirstRowOfDept = true;

      for (const bandGrade of bandGrades) {
        const band = bandGrade.band;
        const employees = bandGrade.employeeData || [];
        const bandRows = employees.length;

        let isFirstRowOfBand = true;

        for (const emp of employees) {
          rows.push({
            departmentName: deptName,
            band: band,
            employeeName: emp.employeeName,
            managerName: emp.managerName,
            hodName: emp.hodName,
            designation: emp.designation,
            dateOfJoining: emp.dateOfJoining,
            monthlyCtc: emp.monthlyCtc,
            annualCtc: emp.annualCtc,
            isEligible: emp.isEligible,
            individualKpiCompetencyScore: emp.individualKpiCompetencyScore,
            deptScore: emp.deptScore,
            companyScore: emp.companyScore,
            finalScore: emp.finalScore,
            finalRating: emp.finalRating,
            incrementPercentage: emp.incrementPercentage,
            daysServed: emp.daysServed,
            proratedIncrementPercentage: emp.proratedIncrementPercentage,
            incrementAmount: emp.incrementAmount,
            noOfPromotions: emp.noOfPromotions,
            isPromoted: emp.isPromoted,
            promotionPercentage: emp.promotionPercentage,
            promotionAmount: emp.promotionAmount,
            updatedCtcAfterIncrementAndPromotion: emp.updatedCtcAfterIncrementAndPromotion,
            marketBenchMarkCtc: emp.marketBenchMarkCtc,
            marketCorrectionPercentage: emp.marketCorrectionPercentage,
            marketCorrectionAmount: emp.marketCorrectionAmount,
            finalIncrementPercentage: emp.finalIncrementPercentage,
            yearBeforeLastYrIncrementPercentage: emp.yearBeforeLastYrIncrementPercentage,
            lastToLastYrIncrementPercentage: emp.lastToLastYrIncrementPercentage,
            lastYrIncrementPercentage: emp.lastYrIncrementPercentage,
            hodIncrementPercentage: emp.hodIncrementPercentage,
            hrAndMdIncrementPercentage: emp.hrAndMdIncrementPercentage,
            finalIncrementAmount: emp.finalIncrementAmount,
            finalAnnualCtc: emp.finalAnnualCtc,
            finalMonthlyCtc: emp.finalMonthlyCtc,
            incrementLetterFormat: emp.incrementLetterFormat,
            userId: emp.userId,

            deptRowSpan: isFirstRowOfDept ? totalDeptRows : 0,
            bandRowSpan: isFirstRowOfBand ? bandRows : 0
          });

          isFirstRowOfDept = false;
          isFirstRowOfBand = false;
        }
      }
    }

    this.incrementInputEligibleRowData = rows;
  }
  initIncrementInputEligibleColumnDefs() {
    this.incrementInputEligibleColumnDefs = [
      {
        headerName: 'Department',
        field: 'departmentName'
      },
      {
        headerName: 'Band',
        field: 'band'
      },
      { headerName: 'Employee', field: 'employeeName', width: 200 },
      { headerName: 'Manager', field: 'managerName', width: 180 },
      { headerName: 'HOD', field: 'hodName', width: 180 },
      { headerName: 'Designation', field: 'designation', width: 200 },

      {
        headerName: 'DOJ',
        field: 'dateOfJoining',
        width: 130,
        valueFormatter: (params: any) => (params.value ? new Date(params.value).toLocaleDateString('en-GB') : '')
      },
      {
        headerName: this.incrementCtcPerMonth,
        field: 'monthlyCtc',
        width: 150,
        valueFormatter: (p: any) => (p.value != null ? p.value.toLocaleString() : '')
      },
      {
        headerName: this.incrementCtcPerYear,
        field: 'annualCtc',
        width: 150,
        valueFormatter: (p: any) => (p.value != null ? p.value.toLocaleString() : '')
      },
      {
        headerName: 'Eligible Emp.',
        field: 'isEligible',
        width: 130,
        valueFormatter: (p: any) => (p.value === true ? 'Yes' : p.value === false ? 'No' : '')
      },
      {
        headerName: 'Individual KPI + Competency Score',
        field: 'individualKpiCompetencyScore',
        width: 200
      },
      {
        headerName: 'Department Score (out of 100)',
        field: 'deptScore',
        width: 200
      },
      {
        headerName: 'Company Score (out of 100)',
        field: 'companyScore',
        width: 200
      },
      { headerName: 'Final Score', field: 'finalScore', width: 130 },
      { headerName: 'Final Rating', field: 'finalRating', width: 130 },
      { headerName: 'Increment %', field: 'incrementPercentage', width: 130 },
      {
        headerName: 'Days Served in the Increment Period',
        field: 'daysServed',
        width: 220
      },
      {
        headerName: 'Prorated Increment %',
        field: 'proratedIncrementPercentage',
        width: 170
      },
      { headerName: 'Increment Amount', field: 'incrementAmount', width: 160 },
      {
        headerName: 'No Promotion Last 3 Year',
        field: 'noOfPromotions',
        width: 190
      },
      {
        headerName: 'Promotion',
        field: 'isPromoted',
        width: 120,
        valueFormatter: (p: any) => (p.value === true ? 'Yes' : p.value === false ? 'No' : '')
      },
      { headerName: 'Promotion %', field: 'promotionPercentage', width: 130 },
      { headerName: 'Promotion Amount', field: 'promotionAmount', width: 150 },
      {
        headerName: 'Updated CTC after Increment & Promotion',
        field: 'updatedCtcAfterIncrementAndPromotion',
        width: 260
      },
      {
        headerName: 'Market BenchMark CTC',
        field: 'marketBenchMarkCtc',
        width: 190
      },
      {
        headerName: 'Market Correction %',
        field: 'marketCorrectionPercentage',
        width: 170
      },
      {
        headerName: 'Market Correction Amount',
        field: 'marketCorrectionAmount',
        width: 190
      },
      {
        headerName: 'Final Increment % p.a',
        field: 'finalIncrementPercentage',
        width: 170
      },
      {
        headerName: this.getIncrementColumnName(3),
        field: 'yearBeforeLastYrIncrementPercentage',
        width: 180
      },
      {
        headerName: this.getIncrementColumnName(2),
        field: 'lastToLastYrIncrementPercentage',
        width: 180
      },
      {
        headerName: this.getIncrementColumnName(1),
        field: 'lastYrIncrementPercentage',
        width: 180
      },
      {
        headerName: 'HOD Approved Increment %',
        field: 'hodIncrementPercentage',
        width: 200
      },
      {
        headerName: 'HR Admin & MD/CEO Approved Increment %',
        field: 'hrAndMdIncrementPercentage',
        width: 260
      },
      {
        headerName: 'Final Increment Amount',
        field: 'finalIncrementAmount',
        width: 180
      },
      {
        headerName: 'Final Annual Revised CTC (post increment)',
        field: 'finalAnnualCtc',
        width: 260
      },
      {
        headerName: 'Final Monthly Revised CTC (post increment)',
        field: 'finalMonthlyCtc',
        width: 260
      },
      {
        headerName: 'Increment Letter Format',
        field: 'incrementLetterFormat',
        width: 220,
        cellRenderer: (params: any) => {
          const name = params.data?.incrementLetterFormat?.letterName || 'Letter not found';
          return `<span class="cp increment-letter-link">${name}</span>`;
        },
        onCellClicked: (params: any) => {
          if (params.data?.userId) {
            this.onClickShowIncrementLetter(params.data.userId);
          }
        }
      }
    ];
  }
  buildEligibleFooterRow(): void {
    const totals: any = {
      departmentName: 'Total',

      band: '',
      employeeName: '',
      managerName: '',
      hodName: '',
      designation: '',
      dateOfJoining: '',

      individualKpiCompetencyScore: '',
      deptScore: '',
      companyScore: '',
      finalScore: '',
      isPromoted: '',
      yearBeforeLastYrIncrementPercentage: '',
      lastToLastYrIncrementPercentage: '',
      lastYrIncrementPercentage: '',
      incrementLetterFormat: '',

      monthlyCtc: this.totalEligibleTotalFixedCtcPM || 0,
      annualCtc: this.totalEligibleTotalFixedCtcPA || 0,
      isEligible: this.totalEligibleEligibleEmp || 0,
      finalRating: this.totalEligibleFinalRating || 0,
      incrementPercentage: this.totalEligibleIncrementPct || 0,
      daysServed: this.totalEligibleDaysServedinIncrementPeriod || 0,
      proratedIncrementPercentage: this.totalEligibleProratedIncrementPct || 0,
      incrementAmount: this.totalEligibleIncrementAmount || 0,
      noOfPromotions: this.totalEligibleNoOfPromotionPct || 0,
      promotionPercentage: this.totalEligiblePromotionPct || 0,
      promotionAmount: this.totalEligiblePromotionAmount || 0,
      updatedCtcAfterIncrementAndPromotion: this.totalEligibleupdatedCtcAfterIAndP || 0,
      marketBenchMarkCtc: this.totalEligibleMarketBenchMarkCtc || 0,
      marketCorrectionPercentage: this.totalEligiblemarketCorrectionPct || 0,
      marketCorrectionAmount: this.totalEligibleMarketCorrectionAmount || 0,
      finalIncrementPercentage: this.totalEligibleFinalIncrementPct || 0,
      hodIncrementPercentage: this.totalEligibleHODIncrementPct || 0,
      hrAndMdIncrementPercentage: this.totalEligibleHrAndMdIncrementPct || 0,
      finalIncrementAmount: this.totalEligibleFinalIncrementAmount || 0,
      finalAnnualCtc: this.totalEligibleFinalAnnualCtc || 0,
      finalMonthlyCtc: this.totalEligibleFinalMonthlyCtc || 0
    };

    this.pinnedBottomRowDataEligible = [totals];

    if (this.gridApiIncrementInputEligible) {
      this.gridApiIncrementInputEligible.setPinnedBottomRowData(this.pinnedBottomRowDataEligible);
    }
  }

  onIncrementInputEligibleGridReady(params: any) {
    this.gridApiIncrementInputEligible = params.api;
    this.gridColumnApiIncrementInputEligible = params.columnApi;

    setTimeout(() => {
      this.gridApiIncrementInputEligible.setRowData(this.incrementInputEligibleRowData);
      this.buildEligibleFooterRow();
      this.gridApiIncrementInputEligible.redrawRows();
      this.gridApiIncrementInputEligible.sizeColumnsToFit();
    }, 60);
  }

  sideBarConfig: any = {
    position: 'right',
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        minWidth: 250,
        maxWidth: 400
      }
    ],
    defaultToolPanel: 'none'
  };
}
